<template>
    <Attr :widget_id="widget_id" :attr_id="attr_id">
        <!-- <div class="attr-containerResize" :id="'containerResize'+attr.html_id"> -->
            <!-- <Button class="p-button p-component p-button-secondary p-button-outlined mr-2 mb-2" @click="attrResize">Set height</Button> -->
            <div class="attr-chart" ref="attr_container" v-wjTooltip="attr.tooltip" :id="'vueObj'+attr_id" :class="{'chart-empty': chartEmptyShown(), 'chart-settling': settling}"><!-- IE 2026 09 15 (замечание Игоря: тело графика пропадало при наведении): класс settling — на СВОЕЙ обёртке; реактивный :class на хосте wijmo стирал его классы wj-control / wj-flexchart -->
                <div class="grid-commandPanel-top-right widget-commandPanel-2" v-show="show_commandPanel_topLeft" @mouseenter="onShow_commandPanel_topLeft" @mouseleave="onClose_commandPanel_topLeft">
                    <div class="ml-1">
                        <div class="pb-2" v-html="tooltip_html"></div>
                        <div class="widget-commandPanel-row mb-2" v-for="(row, rowIndex) in commandPanel_topLeft" 
                            :key="'row-' + rowIndex" 
                        >
                            <component v-for="attrM in row" 
                                :key="attrM.html_id" 
                                :widget_id="widget_id" 
                                :is="attrM.component" 
                                :attr_id="attrM.id" 
                                :initialAttr="attrM" 
                            />
                        </div>
                    </div>
                </div>
                <!-- IE 2026 09 15 / ODOO-… (заказ Игоря): угловые кнопки графика — островком (как кнопки масштаба карты); порядок: легенда, шестерёнка -->
                <div class="corner-island corner-island-tr">
                    <!-- IE 2026 10 31 / ODOO-347310 (запрос Андрея: стрелка назад после разложения серий): пока график разложен «Split the series» — стрелка назад
                         первой в островке (виден всегда, в т.ч. в строке заголовка вкладки визуализации, где кнопки панели команд шапки скрыты; в hdrOverflow не уходит);
                         клик — на один уровень назад, на последнем шаге стрелка исчезает (utils/chartSplitBack.js, chartDrillMixin.chartSplitBack_back) -->
                    <div class="button-lt chart-split-back-btn p-2" v-if="chartSplitBack_shown()" v-wjTooltip="t('Back to the previous chart')" @click="chartSplitBack_back"
                        v-uiHelp="'chart.line.splitBack'">
                        <i class="pi pi-arrow-left"/>
                    </div>
                    <!-- ODOO-2734: кнопка показать/скрыть иерархическую легенду (только в grouped-режиме) -->
                    <!-- IE 2026 09 26 / ODOO-… (заказ Игоря: расшифровка кусочка графика): объяснение кнопки по Alt — с vars.drill (простой клик по точке открывает форму расшифровки, окно легенды — Alt+клик) -->
                    <!-- IE 2026 09 23 / ODOO-341407: i18n -->
                    <div class="button-lt chart-legend-btn p-2" :class="{'chart-legend-btn-on': isLegendPanelShown()}"
                        v-if="isLegendGroupedActive()" v-wjTooltip="isLegendPanelShown() ? t('Hide legend') : t('Show legend')" @click="onToggle_legendPanel" v-uiHelp="{ key: 'chart.line.legendBtn', state: () => (isLegendPanelShown() ? 'on' : 'off'), vars: () => ({ drill: chartDrill_helpMode() }) }"><!-- IE 2026 09 29 / ODOO-343341 (заказ Игоря: вкладка расшифровки в окне легенды): vars.drill 2 — расшифровка во вкладке окна легенды -->
                        <i class="pi pi-tags"/><!-- IE 2026 09 14 / ODOO-5800 (замечание Игоря): та же иконка, что у легенды карты -->
                    </div>
                    <!-- IE 2026 09 27 / ODOO-341407 (замечание ie-dm7 по ревью -23, #47948): кнопка окна легенды Flow canvas (AntFlow) — в островке перед
                         шестерёнкой, как у карты (AttrGeoMap). Раньше AttrAntFlow ставил её сам поверх холста (absolute, right:44px, z-index 7), а в Float на
                         вкладке визуализации островок тоже стоит на right:44px — 🏷 накрывала ⚙ (так было и на -18). Окно и его состояние — в AttrAntFlow
                         (legendVisible), как было; здесь только кнопка и зеркало antLegendOn. Островок шире на кнопку — предел заголовка (Widget.vizTitle_measure)
                         считается до его левого края и учитывает обе кнопки -->
                    <div class="button-lt ant-flow-legend-btn p-2" v-if="isAntMode()" :class="{ 'chart-legend-btn-on': antLegendOn }"
                        v-wjTooltip="antLegendOn ? t('Hide legend') : t('Show legend')" @click="antLegend_toggle" v-uiHelp="{ key: 'chart.flow.legendBtn', state: () => (antLegendOn ? 'on' : 'off') }">
                        <i class="pi pi-tags"/>
                    </div>
                    <div class="button-lt p-2" ref="cogButton" @click="onToggle_chartSettings" v-uiHelp="{ key: 'chart.line.cog', state: () => (show_commandPanel_topLeft ? 'quick' : 'idle') }" @mouseenter="onShow_commandPanel_topLeft" @mouseleave="onClose_commandPanel_topLeft">
                        <i class="pi pi-cog"/>
                    </div>
                </div>

                <label class="label-attr" v-if="attr.title && !attr.hideTitle" :for="attr.html_id">{{ attr.title }}</label>

                <!-- IE 2026 09 01 / ODOO-5884: круговая диаграмма. Колонка с chartType 'Pie'
                     среди видимых серий переключает атрибут на FlexPie: binding = эта колонка
                     (значение), bindingName = первая включённая строковая колонка (категория),
                     палитра дефолтная wijmo. Легенды нет — подписи категорий стоят у долей
                     снаружи с линиями-выносками (dataLabel в initializePie), точные значения
                     остаются в тултипе. Обычные чарты (без Pie-колонки) идут прежней веткой
                     FlexChart ниже и не меняются. -->
                <!-- IE 2026 09 15 / ODOO-… (заказ Игоря): режим «муравьиная логистика» (viewParams.dataChart.chartType 'AntFlow') — канвас
                     потоков поставщик → хаб → страна по строкам источника, вместо wijmo-чарта -->
                <AttrAntFlow v-if="isAntMode()" ref="ant" :id="attr.html_id" class="attr-chart-1" :rows="antRows()" :attr="attr" :WIDGET="WIDGET" :store="store" v-visible="handleVisibility"
                    @legend-visible="antLegendOn = $event" /><!-- IE 2026 09 27 / ODOO-341407: окно легенды открыто / закрыто — вид кнопки 🏷 островка -->
                <wj-flex-pie v-if="isPieMode()"
                    class="attr-chart-1"
                    ref="attr_pie"
                    :id="attr.html_id"
                    :initialized="initializePie"
                    :binding="pieAttr()?.binding"
                    :bindingName="pieNameAttr()?.binding"
                    :tooltipContent="pieTooltipContent"
                    @click="pie_onClick"
                    v-wjContextMenu="'ContextWidgetMenuId'"
                    v-visible="handleVisibility"
                >
                    <!-- IE 2026 09 01 / ODOO-5884 (заказ Игоря): легенда выключена —
                         категории подписаны прямо у долей -->
                    <wj-flex-chart-legend position="None" />
                </wj-flex-pie>

                <wj-flex-chart
                    v-if="!isPieMode() && !isAntMode()"
                    class="attr-chart-1 custom-gridlines"
                    ref="attr_chart"
                    :id="attr.html_id"
                    :chart-type="'Column'" 
                    :legendToggle="true"
                    :initialized="initializeChart" 
                    
                    :rendering="chartRendering"
                    :rendered="chartRendered"
                    
                    :itemFormatter="itemFormatter"
                    v-wjContextMenu="'ContextWidgetMenuId'"
                    v-visible="handleVisibility"
                    
                    :selectionMode="'Point'"
                    :tooltipContent="tooltipContent"
                    @click="chart_onClick"

                    stacking="Stacked"
                    :seriesVisibilityChanged="seriesVisibilityChanged"
                >
                    <!-- :chartType="'Area'"  -->
                    <!-- :palette="palette" -->
                    <wj-flex-chart-axis wjProperty="axisX" :position="attr?.['axisX-position']" :majorGrid="attr?.['axisX-majorGrid']" :minorGrid="attr?.['axisX-minorGrid']" />
                    <wj-flex-chart-axis wjProperty="axisY" :position="attr?.['axisY-position']" :majorGrid="attr?.['axisY-majorGrid']" :minorGrid="attr?.['axisY-minorGrid']" :format="attr?.['axisY-format']" />
                    <!-- :format="'MMM yy'" -->
                    <!-- <wj-flex-chart-series :name="'Sales'" :binding="'measure__fact_sales'"></wj-flex-chart-series> -->
                    <!-- <wj-flex-chart-series :name="'Expenses'" :binding="'expenses'"></wj-flex-chart-series>
                    <wj-flex-chart-series :name="'Profit'" :binding="'profit'" :chartType="'LineSymbols'"></wj-flex-chart-series> -->
                    <!-- ODOO-2734: в grouped-режиме wijmo-легенда гасится — рисуем свою панель -->
                    <!-- ODOO-4206: штатную легенду гасим ТОЛЬКО когда своя панель реально
                         может быть показана. Раньше Grouped выключал wijmo-легенду всегда,
                         и на чарте без групп (нет серий разреза) чарт оставался БЕЗ легенды. -->
                    <wj-flex-chart-legend :position="wjLegendPos()" /><!-- IE 2026 09 15 (замечание Игоря, вечер): Popup — значение Legend position -->
                    <wj-flex-chart-animation v-if="attr?.animation_axisAnimation"
                        :initialized="initializeAnimation" 
                        :easing="easing" 
                        :animationMode="animationMode" 
                        :duration="attr?.animation_duration||400">
                    </wj-flex-chart-animation>
                    <!-- :axisAnimation="axisAnimation"  -->

                    <wj-flex-chart-line-marker :lines="'Both'" :interaction="'Move'" :isVisible="mouseSelecting.lmVisible" :content="markerContent"/>
                    
                    <wj-flex-chart-data-label
                        :content="dataLabelContent"
                        :rendering="dataLabelRendering"
                    />
                        <!-- position="Top"
                        :connectingLine="true"
                        :border="true"
                        :offset="4" -->
                </wj-flex-chart>
                <!-- IE 2026 09 13 / ODOO-5800 (замечание Игоря): строк данных нет (чипсы, период) — оси wijmo с шкалой 0…0,05 / −1…−0,7 ни о чём;
                     рисунок гасится, посередине сообщение. Выкл: window.feSettings.set('fe.ux.chartEmptyMessage', false) -->
                <div v-if="chartEmptyShown()" class="chart-empty-msg" v-uiHelp="{ key: 'chart.line.emptyMsg', state: () => (chartEmpty === 'zero' ? 'zero' : 'empty') }">{{ chartEmptyText() }}</div>

                <!-- IE 2026 09 04 / ODOO-336291 (mobile UX): B-23 / B-29 / P-29 / P-30 chartTapValues — тап по точке
                     читает значение НА МЕСТЕ (пузырёк у пальца, без backend round-trip 1.2–2.3 с); drill-down
                     остаётся явным действием: долгое нажатие (500 мс) или кнопка «Open row» в пузырьке.
                     Выкл: window.mobileUi.set('chartTapValues', false) -->
                <div v-if="mobBubble" class="chart-tap-bubble" v-uiHelp="'chart.line.mobileTapBubble'" :style="mobBubbleStyle" @click.stop>
                    <div class="ctb-head">{{ mobBubble.category }}</div>
                    <div class="ctb-row" v-for="(r, i) in mobBubble.rows" :key="i">
                        <span class="ctb-dot" :style="{ background: r.color }"></span>
                        <span class="ctb-name">{{ r.name }}</span>
                        <span class="ctb-val">{{ r.value }}</span>
                    </div>
                    <!-- IE 2026 09 23 / ODOO-341407: i18n -->
                    <div class="ctb-actions">
                        <button class="ctb-btn" @click.stop="mobBubbleOpenRow">{{ t('Open row') }}</button>
                        <button class="ctb-btn ctb-btn-2" @click.stop="mobBubbleHide">{{ t('Close') }}</button>
                    </div>
                </div>

                <!-- ODOO-2734/4440: иерархическая легенда-расшифровка (группа → серии).
                     Видимость серий — штатный механизм series.visibility + seriesVisibilityChanged.
                     Popup-режим: окно свободное (drag за заголовок) с пунктирной
                     стрелкой-привязкой к оси; клик по НАЗВАНИЮ серии — расшифровка. -->
                <!-- ODOO-4440: окно легенды СВОБОДНОЕ (как прежняя расшифровка) —
                     живёт в body; стрелка-привязка — страничный механизм edges_svg
                     (та же рыжая кривая, что у окна расшифровки) -->
                <!-- ODOO-4646: окно легенды вынесено в общий ChartLegendPanel
                     (используется и баблом). Группы/раскрытие/дата-расшифровка —
                     у чарта (нужны до открытия панели и для стрелки edges_svg);
                     окно, грид и вся его механика — в компоненте. -->
                <!-- IE 2026 09 04 / ODOO-336291 (mobile UX): B-41 chartLegendSheet — легенда графика на телефоне листом снизу:
                     строки 44 px вместо SVG-текста 13–102×14 px; серия гасится напрямую (series.visibility),
                     и пока wijmo перерисовывает чарт, строка показывает состояние ожидания — интерфейс не «молчит».
                     Выкл: window.mobileUi.set('chartLegendSheet', false) -->
                <teleport to="body" v-if="mobLegendOpen">
                    <div class="chart-legend-sheet-backdrop" @click.stop="mobLegendOpen = false"></div>
                    <div class="chart-legend-sheet" @click.stop v-uiHelp="'chart.line.mobileLegendSheet'">
                        <div class="mobile-list-title">{{ t('Chart series') }}</div><!-- IE 2026 09 23 / ODOO-341407: i18n -->
                        <div class="cls-rows">
                            <div v-for="s in mobLegendRows" :key="s.binding" class="cls-row"
                                :class="{ 'cls-off': !s.on, 'cls-busy': mobLegendBusy === s.binding }"
                                @click.stop="mobLegendToggle(s)">
                                <span class="cls-dot" :style="{ background: s.color }"></span>
                                <span class="cls-name">{{ s.name }}</span>
                                <i class="pi" :class="mobLegendBusy === s.binding ? 'pi-spinner pi-spin' : (s.on ? 'pi-check-square' : 'pi-stop')"></i>
                            </div>
                        </div>
                    </div>
                </teleport>

                <ChartLegendPanel ref="legendCmp"
                    :WIDGET="WIDGET" :flex="flex" :groups="legendGroups"
                    :rows="data" :attrsByBinding="attrs_by_binding"
                    :pointIndex="legendPointIndex" :range="legendRange()"
                    :hoverBinding="legendHoverBinding" :hoverIndex="legendHoverIndex"
                    :unmirror="chartDownUnmirror" :visible="isLegendPanelShown()"
                    :selState="legendSelState" @series-select="onLegendSeriesSelect"
                    @series-toggle="onLegendSeriesToggle"
                    @group-toggle="onLegendGroupToggle"
                    @series-settings="onLegendSeriesSettings"
                    @series-hover="onLegendSeriesHover"
                    @close="legendPanelVisible = false; WIDGET._legendPanelVisible = false; legendEdgeRemove()"
                    @point-reset="onLegendPointReset"
                    @expand-changed="onLegendExpandChanged"
                    @geometry-change="legendTetherUpdate"
                    @moved-z="buildLegendGroups"
                    @move-field="onLegendMoveField"
                    :drillTabs="chartDrill_tabOn()" :drill="legendDrill" :tab="legendTab_get()" @tab-select="legendTab_select"
                /><!-- IE 2026 09 29 / ODOO-343341 (заказ Игоря: вкладка расшифровки в окне легенды): вкладки [Breakdown | Legend], расшифровка кусочка — во вкладке Breakdown (utils/chartDrillMixin.js) -->

                <!-- SELECTOR -->
                <!-- IE 2026 09 01 / ODOO-5884: в pie-режиме flex нет (выражение падало бы
                     в 'date_parse') — селектор периода пирогу не рисуем -->
                <wj-flex-chart
                    v-if="!isPieMode() && (flex && flex.bindingX||'date_parse')=='date_parse' && attr['chart-selector-use']"
                    class="chart-selector"
                    :id="`${attr.html_id}-selector`"
                    :initialized="initializeSelector"
                    :itemsSource="doc[binding]"
                    bindingX="date_parse"
                    chartType="Area"
                    tooltipContent=""
                    plotMargin="NaN 60 NaN 60"
                >
                    <wj-flex-chart-series :binding="binding_forSelector" />
                    <wj-flex-chart-legend position="None" />
                    <wj-flex-chart-axis wjProperty="axisX" position="None" />
                    <wj-flex-chart-axis wjProperty="axisY" position="None" />
                    <wj-flex-chart-range-selector :seamless="true" v-uiHelp="'chart.line.rangeSelector'" :initialized="initializeRangeSelector" :rangeChanged="rangeChanged" />
                </wj-flex-chart>

                <!-- <div class='buttons-chart' v-if="!attr.buttonsChart">
                    <div class="button mr-2" v-wjTooltip="'Clear visibility'" @click="onClick({'command':'set_visibleChart'})">
                        <i class="pi pi-stop"></i>
                    </div>
                </div> -->
                <!-- IE 2026 09 23 / ODOO-341407: i18n -->
                <div class='buttons-chart' v-if="attr.buttonsChart">
                    <div class="button mr-2" v-wjTooltip="t('Clear visibility')" v-uiHelp="'chart.line.legacy.clearVisibility'" @click="onClick({'command':'set_visibleChart'})">
                        <i class="pi pi-stop"></i>
                    </div>
                    <div class="button mr-2" v-wjTooltip="t('Default visibility')" v-uiHelp="'chart.line.legacy.defaultVisibility'" @click="onClick({'command':'set_visibleChart', 'defaultSeriesVisibility':true})">
                        <i class="pi pi-check-square"></i>
                    </div>
                    <div class="button mr-2" v-wjTooltip="t('Minimize chart')" v-uiHelp="'chart.line.legacy.minimize'" @click="onClick({'command':'changeAttrState', 'attrs_newState':[
                        {'name':'dataSheet', 'size':80},
                    ]})">
                        <i class="pi pi-window-minimize"></i>
                    </div>
                    <div class="button mr-2" v-wjTooltip="t('Maximize chart')" v-uiHelp="'chart.line.legacy.maximize'" @click="onClick({'command':'changeAttrState', 'attrs_newState':[
                        {'name':'dataSheet', 'size':10},
                    ]})">
                        <i class="pi pi-window-maximize"></i>
                    </div>
                    <!-- <div class="button mr-2" title="Full screen" @click="onClick({'command': 'onFullscreen__Click', 'currentVueObj':true})">
                        <i class="pi pi-window-maximize"></i>
                    </div> -->
                    <!-- <div class="button mr-2" v-wjTooltip="'Export SVG'" @click="onClick({'command':'onExportChart__Click'})">
                        <i class="pi pi-file-export"></i>
                    </div> -->
                    <div class="button mr-2" v-wjTooltip="t('Close chart')" v-uiHelp="'chart.line.legacy.close'" @click="onClick({'command':'changeAttrState', 'attrs_newState':[
                        {'name':'dataSheet', 'size':100},
                        {'name':'tabChart', 'visible':False},
                    ]})">
                        <i class="pi pi-times"></i>
                    </div>
                </div>
            </div>
        <!-- </div> -->
    </Attr>
</template>

<script>
import { useMainStore } from '@/stores/mainStore'
import { PS, planStartFrame, planStartGround, planStartHeadSvg } from '@/utils/planStartCapsule'   // IE 2026 09 30 / ODOO-343343 (заказ Игоря: элемент Plan start одинаковый во всех формах): общий вид капсулы начала плана
import uiHelp, { uiHelp_html, uiHelp_enabled, uiHelp_ownerYields } from '@/utils/uiHelp'   // U6 (заказ Игоря: объяснение элементов по Alt) · регрессия ie-dm7 #43146 (25.09): «Chart area» — источник «по точке» на корне SVG (uiHelp6_bindPlot)
import { toRaw } from 'vue'   // IE 2026 09 12 / ODOO-…: this.flex — реактивный прокси над контролом wijmo; коллекции осей правим на raw
import * as wjChart from '@mescius/wijmo.chart';
import { CollectionView, PropertyGroupDescription, SortDescription } from "@mescius/wijmo";
import { AxisGroupsDisplay } from "@mescius/wijmo.chart";
import * as wjcChart from '@mescius/wijmo.chart';

import * as wjcCore from '@mescius/wijmo';
import * as wjGrid from '@mescius/wijmo.grid';
import { off } from 'process';
// ODOO-4646: окно легенды — общий компонент, группы — чистая функция
import ChartLegendPanel from './ChartLegendPanel.vue'
import { durNum, timeAxisDaysStep } from '@/utils/durationText'   // IE 2026 09 24 / ODOO-341407: число длительности под язык интерфейса (подсказка «5.6 m (169 d)» → «5,6 міс (169 дн)»); IE 2026 09 29 / ODOO-341407: шаг оси формата 'd'
import { ctxMenu_allowed, ctxMenu_count } from '@/utils/ctxMenuGuard'   // IE 2026 10 12 / ODOO-343342 (заказ Игоря: правая кнопка на остальных элементах — график / узел карты)
import { chartClickSel_on, chartClickSel_selectors, chartClickSel_target, chartClickSel_current, chartClickSel_decide } from '@/utils/chartClickSelectors'   // IE 2026 10 13 / ODOO-5800: клик по столбику / дольке ставит селекторы стола, как пузырь (флаг fe.ux.chartClickSelectors)
import { chartDrillMixin } from '@/utils/chartDrillMixin'   // IE 2026 09 26 / ODOO-… (заказ Игоря: расшифровка кусочка графика): форма расшифровки точки / блока
import { legendOwnerMixin } from '@/utils/legendOwner'   // IE 2026 09 20 / ODOO-… (Игорь: легенда закрывается вместе с виджетом и на вкладке, к которой не относится)
import { buildLegendGroups as buildLegendGroupsPure, legendSeriesColor, moveNodeInTree } from '@/utils/chartLegend'
import { tabsLazy_on, inHiddenTab, tabsLazy_count } from '@/utils/tabsLazy'
import { chartDateGroups_on, chartDateGroups_freq, chartDateGroups_rowsOk, chartDateGroups_tooltip, chartDateGroups_monthBuckets, chartDateGroups_bucketRow, chartDateGroups_bandLabels } from '@/utils/chartDateGroups'   // IE 2026 10 31 / ODOO-5800: полосы год/месяц/неделя у графика без data_schedule (флаг fe.ux.chartDateGroupsNoSchedule)
// demo-webscm 2026 11 02 / ODOO-347310: группа оси с пустым именем (полоса месяца и недели у месячного бакета на оси дней) — ни подписи, ни скобки:
// wijmo резал бы имя до буквы по ширине одной строки. Фильтр подписей только на время render (getHeight / hitTest видят все); режим Show (наш)
if (wjChart._AxisGroups && !wjChart._AxisGroups.prototype._ieBlankSkip) {
    const render = wjChart._AxisGroups.prototype.render
    wjChart._AxisGroups.prototype.render = function (engine) {
        const show = this.axis?.groupsOptions?.display === AxisGroupsDisplay.Show
        const saved = show ? this.groups.map(g => g._labels) : null
        try {
            if (show) this.groups.forEach(g => { g._labels = chartDateGroups_bandLabels(g._labels) })
            return render.call(this, engine)
        } finally {
            if (saved) this.groups.forEach((g, i) => { g._labels = saved[i] })
        }
    }
    wjChart._AxisGroups.prototype._ieBlankSkip = true
}
import { monthAxis_label, monthAxis_step, monthAxis_shown, monthAxis_yearBands, monthAxis_height } from '@/utils/monthAxis'   // IE 2026 10 16 / ODOO-5800: общий хелпер оси месяцев (и у SVG-графика VERSIONS формы ячейки)   // IE 2026 09 26 / ODOO-5800: серии скрытой вкладки — при первом показе (fe.ux.tabsLazyHidden)
import { isoWeek } from '@/utils/isoWeek'   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: номер тижня на осі X теплокарти, як у REPORT2): общий расчёт ISO-недели (был методом isoWeek)
// IE 2026 09 01 / ODOO-5884: внешние подписи долей круговой диаграммы —
// единственные ручки настройки. У PieDataLabel в подключённой версии wijmo
// (@mescius/wijmo.chart 5.20241.x) НЕТ свойства overlappingLabels — оно есть
// только у Axis; поэтому «Auto» (гасить перекрытия) сделан руками в
// pieLabelRendering: подпись меряется, и та, что налезает на уже нарисованную
// или не влезает в виджет, не рисуется — её значение остаётся в тултипе.
const PIE_LABEL_OFFSET    = 8   // отступ подписи от края дольки (px) — под выноску
const PIE_LABEL_MAX_CHARS = 20  // максимум символов имени категории, дальше «…»
const PIE_LABEL_MIN_CHARS = 8   // короче не режем: обрубок нечитаем — остаётся один процент
const PIE_LABEL_MIN_PCT   = 3   // доли мельче — без подписи (значение видно в тултипе)
const PIE_LABEL_GAP       = 2   // зазор между соседними подписями (px)
const PIE_LABEL_PAD       = 2   // отступ подписи от края виджета (px)

// IE 2026 09 11 / ODOO-5800 (заказ Игоря): ноль именованной (правой, напр. DOS) оси Y совпадает с нулём главной оси —
// иначе «0m» справа стоит на дне графика, а «0» слева выше (под ним бары OUT), и шкалы читаются вразнобой.
// Выравнивание — после отрисовки (chartRendered → alignSecondaryAxesZero). Выключатель без пересборки:
// window.chartAlignZero.set(false) / .reset() (localStorage 'chart.alignZero'), дефолт ВКЛ.
const chartAlignZeroOn = () => { try { return localStorage.getItem('chart.alignZero') !== 'false' } catch (e) { return true } }
// IE 2026 09 11 / ODOO-5800 (заказ Игоря): подсветка серии под курсором — остальные серии притушены, у оси серии подсвечены
// подписи и показан ярлык с именем серии, строка серии подсвечена в открытой легенде. Без перерисовки чарта (классы на SVG).
// Выключатель: window.chartHover.set(false) / .reset() (localStorage 'chart.hover'), дефолт ВКЛ.
const chartHoverOn = () => { try { return localStorage.getItem('chart.hover') !== 'false' } catch (e) { return true } }
if (typeof window !== 'undefined' && !window.chartHover) {
    window.chartHover = {
        get: chartHoverOn,
        set: (on) => { try { localStorage.setItem('chart.hover', on === false ? 'false' : 'true') } catch (e) { /* хранилище недоступно */ } return chartHoverOn() },
        reset: () => { try { localStorage.removeItem('chart.hover') } catch (e) { /* хранилище недоступно */ } return chartHoverOn() },
    }
}
if (typeof window !== 'undefined' && !window.chartAlignZero) {
    window.chartAlignZero = {
        get: chartAlignZeroOn,
        set: (on) => { try { localStorage.setItem('chart.alignZero', on === false ? 'false' : 'true') } catch (e) { /* хранилище недоступно */ } return chartAlignZeroOn() },
        reset: () => { try { localStorage.removeItem('chart.alignZero') } catch (e) { /* хранилище недоступно */ } return chartAlignZeroOn() },
    }
}

// IE 2026 09 01 / ODOO-5884: как wijmo (FlexPie._renderLabels) выравнивает внешнюю
// подпись по углу «центр пирога → точка подписи»: [halign, valign], где
// 0 — текст растёт вправо/вниз, 1 — по центру точки, 2 — влево/вверх.
// Порядок условий повторяет wijmo: первое совпавшее выигрывает.
function pieLabelAlign(d) {
    if (d <= -170 || d >= 170)  return [2, 1]
    if (d >= -100 && d <= -80)  return [1, 2]
    if (d >= -10  && d <= 10)   return [0, 1]
    if (d >= 80   && d <= 100)  return [1, 0]
    if (d > -180  && d < -90)   return [2, 2]
    if (d >= -90  && d < 0)     return [0, 2]
    if (d > 0     && d < 90)    return [0, 0]
    if (d > 90    && d < 180)   return [2, 0]
    return [1, 1]
}

let tooltip = new wjcCore.Tooltip({ 
    // attr_type: 'AttrChart',
});
// tooltip.attr_type = 'AttrChart';

// U6 (заказ Игоря: объяснение элементов по Alt): ключ объяснения ряда быстрых настроек — по последнему сегменту binding
// (doc.params.freq -> 'freq'; doc.viewParams.<name>.<param> -> '<param>'); один ключ на все кнопки ряда, state — текущее
// состояние на момент показа подсказки (attr = this.attr в момент вызова из forEach, WIDGET = this.WIDGET)
const UI_HELP_QS_LINE = {
    freq: 'chart.line.qs.freq', 'chart-selector-use': 'chart.line.qs.selector', animation_axisAnimation: 'chart.line.qs.axisAnimation',
    'axisY-majorGrid': 'chart.line.qs.gridY', 'axisY-minorGrid': 'chart.line.qs.gridY',
    'axisX-majorGrid': 'chart.line.qs.gridX', 'axisX-minorGrid': 'chart.line.qs.gridX',
    'axisY-position': 'chart.line.qs.axisYPos', 'compact-axisY': 'chart.line.qs.compactY',
    'axisX-position': 'chart.line.qs.axisXPos', 'compact-axisX': 'chart.line.qs.compactX',
    'axisX-legend': 'chart.line.qs.axisXLegend', 'hover-link': 'chart.line.qs.hoverLink',
    'click-open-row': 'chart.line.qs.clickOpenRow', 'legend-position': 'chart.line.qs.legendPos',
    'click-drill': 'chart.line.qs.clickDrill',   // IE 2026 09 26 / ODOO-… (заказ Игоря: расшифровка кусочка графика): кнопка «Breakdown form»
}
const UI_HELP_QS_LINE_STATE = {
    freq: (vm) => (vm.WIDGET.record.doc.params.freq || 'G'),
    'chart-selector-use': (vm) => (vm.attr['chart-selector-use'] ? 'on' : 'off'),
    animation_axisAnimation: (vm) => (vm.attr.animation_axisAnimation ? 'on' : 'off'),
    'axisY-majorGrid': (vm) => ((vm.attr['axisY-majorGrid'] ? 'major' : '') + (vm.attr['axisY-minorGrid'] ? '+minor' : '') || 'none'),
    'axisY-minorGrid': (vm) => ((vm.attr['axisY-majorGrid'] ? 'major' : '') + (vm.attr['axisY-minorGrid'] ? '+minor' : '') || 'none'),
    'axisX-majorGrid': (vm) => ((vm.attr['axisX-majorGrid'] ? 'major' : '') + (vm.attr['axisX-minorGrid'] ? '+minor' : '') || 'none'),
    'axisX-minorGrid': (vm) => ((vm.attr['axisX-majorGrid'] ? 'major' : '') + (vm.attr['axisX-minorGrid'] ? '+minor' : '') || 'none'),
    'axisY-position': (vm) => (vm.attr['axisY-position'] || 'None'),
    'compact-axisY': (vm) => (vm.axesCompactY() ? 'on' : 'off'),
    'axisX-position': (vm) => (vm.attr['axisX-position'] || 'None'),
    'compact-axisX': (vm) => (vm.axesCompactX() ? 'on' : 'off'),
    'axisX-legend': (vm) => (vm.attr['axisX-legend'] || 'Auto'),
    'hover-link': (vm) => (vm.attr['hover-link'] === 'page' ? 'on' : 'off'),
    // IE 2026 09 26 / ODOO-… (заказ Игоря: расшифровка кусочка графика): при включённой форме расшифровки выключенная опция = «клик открывает форму» (drill), иначе — прежнее off
    // IE 2026 09 29 / ODOO-343341 (заказ Игоря: вкладка расшифровки в окне легенды): tab — расшифровка во вкладке Breakdown окна легенды
    'click-open-row': (vm) => (vm.attr['click-open-row'] === true ? 'on' : (vm.chartDrill_tabOn?.() ? 'tab' : (vm.chartDrill_on?.() ? 'drill' : 'off'))),
    'click-drill': (vm) => (vm.get_viewParam('click-drill', true) !== false ? (vm.chartDrill_tabOn?.() ? 'tab' : 'on') : 'off'),   // IE 2026 09 29 / ODOO-343341 (заказ Игоря: вкладка расшифровки в окне легенды): tab — во вкладке окна легенды
    'legend-position': (vm) => (vm.attr['legend-position'] || 'None'),
}
export default {
    components: { ChartLegendPanel },
    mixins: [legendOwnerMixin, chartDrillMixin],   // IE 2026 09 20 / ODOO-… (Игорь: легенда закрывается вместе с виджетом и на вкладке, к которой не относится) · chartDrillMixin — IE 2026 09 26 / ODOO-… (заказ Игоря: расшифровка кусочка графика)
    props: [
        'widget_id',
        'attr_id',
    ],
    data: () => ({
        settling: false,   // IE 2026 09 15 / ODOO-… (замечание Игоря): одна отрисовка вместо дёрганья
        WIDGET: {},
        // ODOO-2734: attr назначается в widget_attr_set (store) — объявляем в data,
        // чтобы присваивание было реактивным и computed-легенда пересчитывалась;
        // без этого computed кэширует значение, снятое до прихода view с бэкенда
        attr: {},
        doc: {},
        data: [], // doc[binding]
        binding: '',
        binding_forSelector: '',
        flex: null,
        flexPie: null, // IE 2026 09 01 / ODOO-5884: контрол FlexPie (pie-режим)
        flexSelector: null,
        rangeSelectorCtl: null,
        tooltip_html: '',
        tooltip_widget: 'widget-row',
        tooltip_widget_opened: false,
        inlineTipOff: false,   // IE 2026 10 22 / ODOO-5800 (Igor 22.10: легенда открыта — тултипа нет): график формы ячейки ('tooltip-inline') — подсказку wijmo выключает форма (Dropdown.cellChart_tipSync), пока открыта её форма легенды

        drawnLabels: [],
        // IE 2026 09 01 / ODOO-5884: прямоугольники уже нарисованных подписей
        // пирога в текущем кадре — по ним гасятся перекрытия (см. pieLabelRendering)
        pieLabelRects: [],

        easing: 'Linear',
        animationMode: 'All', // Point Series

        attrs_by_binding: {},
        mouseSelecting:{
            lmVisible:false,
            pointIndex:0,
            isSelecting: false,
            i1:null,
            i2:null,
            rect:null,
        },

        show_commandPanel_topLeft: false,
        commandPanel_topLeft: [],

        // ODOO-2734: иерархическая легенда
        legendGroups: [],           // [{key, title, checked, indeterminate, expanded, collapsible, series:[...]}]
        // ODOO-4137: раскрытие групп живёт ОТДЕЛЬНО от legendGroups: buildLegendGroups()
        // пересобирает массив на каждый рендер чарта, и состояние внутри него сбрасывалось бы.
        // Ключ — g.key, значение — bool. Пусто = дефолт (группы разреза свёрнуты).
        legendExpanded: {},
        legendPanelVisible: null,   // null = дефолт режима (docked — открыта, popup — закрыта)
        // ODOO-4646: legendGrid/legendPos/legendDrag/legendPortal/showLegendValues
        // переехали в ChartLegendPanel; здесь остаётся то, что нужно чарту ДО
        // открытия панели (группы, раскрытие) и для стрелки edges_svg (дата/якорь)
        // ODOO-4440: легенда-расшифровка
        legendAnchor: null,         // якорь рыжей линии — точка клика (как у расшифровки)
        legendPointIndex: null,     // индекс точки, выбранной кликом по чарту (режим расшифровки)
        legendHoverBinding: null,   // IE 2026 09 11 / ODOO-5800: binding серии под курсором (подсветка строки легенды)
        legendHoverIndex: null,     // IE 2026 09 13 / ODOO-5800 (замечание Игоря): индекс точки под курсором — легенда без зафиксированной точки следует за ней
        seriesSelEpoch: 0,          // IE 2026 09 15 (заказ Игоря: селективные серии): счётчик правок чипса из легенды / бейджа
        chartEmpty: false,          // IE 2026 09 13 / ODOO-5800 (замечание Игоря): строк данных нет — вместо пустых осей сообщение
        // IE 2026 09 04 / ODOO-336291 (mobile UX): B-23 chartTapValues / B-41 chartLegendSheet
        mobBubble: null,            // {category, rows:[{name,color,value}], x, y, item} — пузырёк значения у пальца
        mobLegendOpen: false,       // лист серий (мобильная легенда) раскрыт
        mobLegendBusy: null,        // binding серии, которую сейчас перерисовывает wijmo (состояние ожидания в строке)
        mobLegendTick: 0,           // пересборка строк листа после смены видимости
        antLegendOn: false,         // IE 2026 09 27 / ODOO-341407: окно легенды AttrAntFlow открыто (зеркало его legendVisible) — вид кнопки 🏷 островка
    }),
    computed: {
        // IE 2026 09 04 / ODOO-336291 (mobile UX): B-41 — строки листа серий (имя, цвет маркера, включена ли)
        mobLegendRows() {
            void this.mobLegendTick
            const list = this.flex?.series || []
            return list.map((s) => ({
                binding: s.binding,
                name: s.name || s.binding,
                color: legendSeriesColor(list, this.flex?.palette, s, this.attrs_by_binding?.[s.binding]),
                on: s.visibility === 0 || s.visibility === 1,
            }))
        },
        // IE 2026 09 04 / ODOO-336291 (mobile UX): B-23 — пузырёк держится в границах карточки
        mobBubbleStyle() {
            if (!this.mobBubble) return null
            return { left: this.mobBubble.x + 'px', top: this.mobBubble.y + 'px' }
        },
    },
    setup() {
        const store = useMainStore();
        return { store }
    },
    created() {
        // if (!this.store.hide_console) console.log(`created ${this.attr_id}`)
        this.WIDGET = this.store.findWidget(this.widget_id).WIDGET
        this.content_Changed()
    },
    mounted() {
        // IE 2026 09 24 / ODOO-341407 (второй обход dev02: месяцы на осях KPI-чартов после живого переключения языка): подписи оси X
        // (date_Month / date_Week) считаются в load_data из дат строк на языке интерфейса — виджеты-списки с чартом select не делают,
        // поэтому после перелокализации подписей бэка (phase 'attrs') чарт пересобирается из своих же строк (без запроса)
        this._i18nHandler = (ev) => {
            // IE 2026 09 25 / ODOO-341407 (проверка dev02 25.09: после переключения uk → en панель быстрых настроек графика — «Кілька / Рік / Місяць …»,
            // «Селектор діаграми», «Анімація осей», положение легенды — оставалась на прежнем языке): commandPanel_topLeft собирается один раз строками t()
            // (set_commandsActive) — сбросить, показанную сейчас — пересобрать (как у AttrGrid)
            if (ev?.detail?.phase === 'ui' && this.commandPanel_topLeft?.length) {
                const shown = this.show_commandPanel_topLeft
                this.commandPanel_topLeft = []
                if (shown) this.$nextTick(() => { try { this.set_commandsActive() } catch (e) { console.warn('[i18n] chart settings panel', e) } })
            }
            if (ev?.detail?.phase !== 'attrs') return
            try {
                if (!this.flex || !this.doc || !this.doc[this.binding] || this.isAntMode?.() || this.isPieMode?.()) return
                if (this.tabsLazy_hold(false)) return   // IE 2026 09 26 / ODOO-5800: скрытая неоткрытая вкладка — подписи соберутся при показе
                this.load_data()
                this.set_itemsSource()
            } catch (e) { console.warn('[i18n] chart relabel', e) }
        }
        window.addEventListener('i18n:changed', this._i18nHandler)
        this.mobilePinchInit() // IE 2026 08 21 (заказ Игоря): пинч-зум графика
        this.mobChartTapInit() // IE 2026 09 04 / ODOO-336291 (mobile UX): B-23 — долгое нажатие = drill-down, короткий тап = значение
        // IE 2026 09 04 / ODOO-336291 (mobile UX): B-41 — кнопка «Chart series» (Widget.vue) открывает лист этого чарта
        this.$watch(() => this.store.mobileChartLegend, (v) => {
            if (!v || v.wid !== this.WIDGET?.id) return
            if (this.store.mobileUi?.chartLegendSheet === false) return
            this.mobLegendTick++
            this.mobLegendOpen = !this.mobLegendOpen
        })
        this.WIDGET.attrsResize.push(this.attrResize)
    },
    methods: {
        // IE 2026 08 21 (заказ Игоря 19:33): два пальца — масштаб графика (1..4x),
        // один палец — промотка вправо-влево, когда график шире экрана;
        // пинч к 1 сбрасывает. Только мобильный профиль.
        mobilePinchInit() {
            if (!this.store.mobileUi?.on) return
            const host = this.$refs.attr_container
            if (!host || host._pinchHooked) return
            host._pinchHooked = true
            const st = { scale: 1, tx: 0, ty: 0 }
            const target = () => host.querySelector('.attr-chart-1')
            const apply = () => {
                const el = target()
                if (!el) return
                const w = host.clientWidth || 1, h = host.clientHeight || 1
                st.tx = Math.min(0, Math.max(-(w * (st.scale - 1)), st.tx))
                st.ty = Math.min(0, Math.max(-(h * (st.scale - 1)), st.ty))
                el.style.transformOrigin = '0 0'
                el.style.transform = st.scale > 1.01
                    ? `translate(${st.tx}px, ${st.ty}px) scale(${st.scale})` : ''
                el.style.willChange = st.scale > 1.01 ? 'transform' : ''
            }
            let pinch0 = null, pan0 = null
            const dist = (t) => Math.hypot(t[0].clientX - t[1].clientX, t[0].clientY - t[1].clientY)
            host.addEventListener('touchstart', (e) => {
                if (!this.store.mobileUi?.on) return
                if (e.touches.length === 2) {
                    const r = host.getBoundingClientRect()
                    pinch0 = { d: dist(e.touches), scale: st.scale, tx: st.tx, ty: st.ty,
                        cx: (e.touches[0].clientX + e.touches[1].clientX) / 2 - r.left,
                        cy: (e.touches[0].clientY + e.touches[1].clientY) / 2 - r.top }
                    pan0 = null
                } else if (e.touches.length === 1 && st.scale > 1.01) {
                    pan0 = { x: e.touches[0].clientX, y: e.touches[0].clientY, tx: st.tx, ty: st.ty }
                }
            }, { passive: true })
            host.addEventListener('touchmove', (e) => {
                if (pinch0 && e.touches.length === 2) {
                    e.preventDefault()
                    const k = dist(e.touches) / (pinch0.d || 1)
                    const ns = Math.min(4, Math.max(1, pinch0.scale * k))
                    // точка между пальцами остаётся на месте (по обеим осям)
                    st.tx = pinch0.cx - (pinch0.cx - pinch0.tx) * (ns / pinch0.scale)
                    st.ty = pinch0.cy - (pinch0.cy - pinch0.ty) * (ns / pinch0.scale)
                    st.scale = ns
                    apply()
                } else if (pan0 && e.touches.length === 1) {
                    // IE 2026 08 21 (замечание Игоря 22:26): при увеличении панорама
                    // по ОБЕИМ осям (страница под зумом не скроллится)
                    e.preventDefault()
                    st.tx = pan0.tx + (e.touches[0].clientX - pan0.x)
                    st.ty = pan0.ty + (e.touches[0].clientY - pan0.y)
                    apply()
                }
            }, { passive: false })
            host.addEventListener('touchend', (e) => {
                if (e.touches.length < 2) pinch0 = null
                if (e.touches.length === 0) pan0 = null
                if (st.scale <= 1.05 && st.scale !== 1) { st.scale = 1; st.tx = 0; st.ty = 0; apply() }
            }, { passive: true })
        },
        content_Changed() {
            this.store.widget_attr_set(this)
        
            // this.text = this.store.attr_get(this.WIDGET, this.attr)
            const [doc, binding] = this.store.attr_get_link(this.WIDGET, this.attr)
            this.doc = doc, this.binding = binding

            // IE 2026 09 26 / ODOO-5800 (fe.ux.tabsLazyHidden, utils/tabsLazy.js): вкладка чарта скрыта (не выбрана) — серии не строим до первого показа;
            // handleVisibility(true) повторит content_Changed уже видимым и соберёт их из тех же строк (запроса к бэку нет); показанный однажды — как раньше
            if (this.tabsLazy_hold()) return
            const _tl0 = performance.now()   // IE 2026 09 26 / ODOO-5800: замер сборки (tabsLazy_after)

            // IE 2026 09 01 / ODOO-5884: pie-режим живёт своей веткой — серии
            // FlexChart не строим (контрола и нет, v-if в шаблоне)
            if (this.isAntMode()) {   // IE 2026 09 15 / ODOO-… (заказ Игоря): муравьиная логистика — компонент строит потоки сам
                this.$nextTick(() => { this.attrResize(); this.$refs.ant?.reload?.() })
            } else if (this.isPieMode()) {
                if (this.flexPie) { this.pieLoad(); this.tabsLazy_after(_tl0) }   // IE 2026 09 26 / ODOO-5800: + замер
            } else if(this.flex) {
                this.load_data()
                this.set_itemsSource()
                this.tabsLazy_after(_tl0)   // IE 2026 09 26 / ODOO-5800
            }
        },
        // IE 2026 09 26 / ODOO-5800 (замер gantt_payload, Bio: выключенный чарт списка, смонтированный фоном, строил серии по всем строкам 5,6 с при открытом
        // Ганте): чарт в СКРЫТОЙ вкладке не строится, пока его ни разу не показали (_tabsLazyShown); муравьиный режим (контрола нет) — как раньше.
        // Счётчик tabsLazy.stats().chartHeld; выключатель fe.ux.tabsLazyHidden
        tabsLazy_hold(count = true) {
            if (this._tabsLazyShown || !(this.flex || this.flexPie)) return false
            if (inHiddenTab(this) !== true || !tabsLazy_on(this.store)) return false
            this._tabsLazyPending = true
            if (count) tabsLazy_count('chartHeld')
            return true
        },
        tabsLazy_after(t0) {
            // IE 2026 09 26 / ODOO-5800: сборка прошла — в скрытой вкладке (флаг выключен / чарт уже показывали) или отложенная при первом показе;
            // собран видимым — дальше чарт строится как раньше (в т.ч. скрытым)
            const ms = performance.now() - t0, hidden = inHiddenTab(this)
            if (hidden === true) { tabsLazy_count('chartBuiltHidden', ms); return }
            if (this._tabsLazyPending) { this._tabsLazyPending = false; tabsLazy_count('chartBuiltOnShow', ms) }
            if (hidden === false) this._tabsLazyShown = true
        },
        load_data() {
            this.$nextTick(() => this.attrResize())
            // АН 2026 08 15 / ODOO-4997: у виджета с неполным doc (вставка из
            // буфера) attr_get_link не резолвится — не роняем mounted-цепочку
            if (!this.doc) return
            let chart_data = this.doc[this.binding],
            attrs = this.store.fieldsNoHierarchy(this.attr.attrs)

            // ODOO-4440: после смены отбора (чип «Позиции» из бабла и т.п.) в attrs
            // приходят ДУБЛИ разрезных атрибутов мер — старый и новый наборы слиты
            // (замерено: 28 numeric-атрибутов, 6 дублей binding). Две серии одного
            // binding рисуются ОБЕ (стек удваивается, ось завышена), а тумблер
            // легенды гасит один экземпляр, пока rendered-карта держит другой —
            // галочки «не снимаются». Мера на binding — одна; первый экземпляр
            // (свежий набор идёт первым) побеждает.
            const seenMeasures = new Set()
            attrs = attrs.filter(a => {
                if (a.attr_type !== 'AttrNumber' && a.attr_type !== 'AttrDays') return true
                if (seenMeasures.has(a.binding)) return false
                seenMeasures.add(a.binding)
                return true
            })

            if (!chart_data) return
            this.chartDrill_tabDataCheck?.(chart_data)   // IE 2026 09 29 / ODOO-343341 (заказ Игоря: вкладка расшифровки в окне легенды): пришли другие строки — расшифровка вкладки Breakdown устарела
            // IE 2026 09 13 / ODOO-5800 (замечание Игоря): нет строк — сообщение вместо пустых осей; строки есть, но все показываемые
            // меры нули/пусто (Армения: остаток, приход и расход 0 на всём горизонте) — тоже сообщение, а не плоская линия на нуле
            this.chartEmpty = !chart_data.length ? 'rows' : (this.chartAllZero(chart_data, attrs) ? 'zero' : false)

            this.flex.bindingX = this.attr.axisX_bindingX2 = this.attr.axisX_bindingX2||'date_parse'
            if (this.flex.bindingX=='date_parse' || this.flex.bindingX=='date') {
                this.flex.bindingX='date_parse'

                // parseDate
                this.formatX = 'yyyy-MM'
                if (chart_data.length && ! wijmo.Globalize.parseDate(chart_data[0].date, this.formatX)) {
                    this.formatX = 'yyyy-MM-dd'
                }
                if (chart_data.length && ! wijmo.Globalize.parseDate(chart_data[0].date, this.formatX)) {
                    this.formatX = 'yyyy-MM-dd/ffff-ff-ff'
                }
                this.flex.axisX.itemsSource = []
                // Un-zoom the range-selector navigator itself. The axisX reset below only
                // un-zooms the MAIN plot; the selector keeps its old thumb window, so a
                // refresh that loads a different period (e.g. switching from a short-lived
                // nomenclature back to all) leaves the thumbs cropping now-irrelevant dates.
                // The selector binds its data reactively (:itemsSource="doc[binding]") on the
                // NEXT tick, and Wijmo then DEFERS (~100ms) a step that re-applies the prior
                // selection clamped to the new data — it only ever shrinks, never grows, so a
                // short→long switch leaves the thumbs stuck narrow on the left. A reset done in
                // $nextTick (a microtask) runs BEFORE that deferred restore and gets clobbered
                // by it. Force the restore to run synchronously via flexSelector.refresh(true)
                // first; the explicit full-extent reset that follows then sticks.
                if (this.rangeSelectorCtl) {
                    const rsPointCount = chart_data.length
                    this.$nextTick(() => {
                        if (!this.rangeSelectorCtl) return
                        if (this.flexSelector) this.flexSelector.refresh(true)
                        if (rsPointCount > 0) {
                            this.rangeSelectorCtl.min = 0
                            this.rangeSelectorCtl.max = rsPointCount - 1
                        } else {
                            this.rangeSelectorCtl.min = null
                            this.rangeSelectorCtl.max = null
                        }
                    })
                }
                // Rebuild the axis range on every (re)load. A refresh can load a different
                // time period, so drop any min/max retained from a prior range-selector zoom
                // (set in rangeChanged) and let the axis re-fit the freshly loaded dates.
                this.flex.axisX.min = null
                this.flex.axisX.max = null
                this.bindingX_type = '' // index/category axis — required for grouped year/month axis bands

                this.freq_doc = {}
                for (let j = 0; j < chart_data.length; j++) {
                    if (chart_data[j].date) {
                        if (this.attr.data_schedule?.[j]) {
                            let rowDS = this.attr.data_schedule[j]
                            this.freq_doc[rowDS.freq] = true
                        }
                    }
                }

                this.freq = this.attr.freq
                if ( this.freq === 'G') {
                    if (this.freq_doc['S'] || this.freq_doc['D']) {
                        this.freq = 'D'
                    } else if (this.freq_doc['W']) {
                        this.freq = 'W'
                    } else if (this.freq_doc['M']) {
                        this.freq = 'M'
                    } else if (this.freq_doc['A']) {
                        this.freq = 'A'
                    }
                }
                // IE 2026 10 31 / ODOO-5800 (заказ Игоря: «Хронологія змін» без месяца и года на оси): у списка над SQL-источником
                // нет data_schedule — частота «Кілька» (G) ничем не раскрывалась, и полосы год/месяц/неделя не строились;
                // берём шаг из формата дат самих строк (yyyy-MM-dd → дни, yyyy-MM → месяцы), флаг fe.ux.chartDateGroupsNoSchedule (по умолчанию вкл.)
                this.freq = chartDateGroups_freq({ freq: this.freq, hasSchedule: !!this.attr.data_schedule, formatX: this.formatX, rows: chart_data, on: this.chartDateGroupsNoSchedule_on() }) || this.freq
                this.freq_text = this.freq
                if ((this.attr['axisX-legend']||'Auto') !== 'Auto') {
                    if (this.freq !== this.attr['axisX-legend']) {
                        this.freq_text = ''
                    }
                    this.freq = this.attr['axisX-legend']
                }

                const monthBuckets = this.freq_text === 'D' ? chartDateGroups_monthBuckets(chart_data) : new Set()   // IE 2026 11 02 / ODOO-347310: индексы месячных строк смешанной сетки
                let bucketK = 0
                for (let j = 0; j < chart_data.length; j++) {
                    if (chart_data[j].date) {
                        if (this.bindingX_type === 'wijmo.Globalize.parseDate') {
                            chart_data[j].date_parse = wijmo.Globalize.parseDate(chart_data[j].date, this.formatX) // .getTime()
                        } else {
                            chart_data[j].date_parse = j
                        }
                        
                        // Labels/grouping derive from THIS row's own parsed date — NOT from
                        // this.attr.data_schedule[j] by index. data_schedule is the full
                        // report-period schedule, independent of the fact rows (e.g. 90 vs 173
                        // rows, starting 2019 vs 2012), so index alignment shifted every label
                        // and put out-of-range years on the axis. Formats mirror the backend
                        // (data_layout_transpose.py): %Y, %B (English), {weekofyear}W, day.
                        let text = chart_data[j].date
                        const d = wijmo.Globalize.parseDate(chart_data[j].date, this.formatX)
                        if (d instanceof Date && !isNaN(d)) {
                            chart_data[j].date_Year = String(d.getFullYear())
                            chart_data[j].date_Month = d.toLocaleString(this.store.ui_locale(), { month: 'long' })   // IE 2026 09 24 / ODOO-341407: месяц — на языке интерфейса (было en-US)
                            chart_data[j].date_Week = `${isoWeek(d)}W`   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: номер тижня на осі X теплокарти, як у REPORT2): общий src/utils/isoWeek.js
                            chart_data[j].date_Day = d.getDate()

                            if (this.freq_text === 'D') {
                                text = chart_data[j].date_Day
                                chart_data[j].date_Bucket = ''
                                if (monthBuckets.has(j)) text = chartDateGroups_bucketRow(chart_data[j], bucketK++)   // IE 2026 11 02 / ODOO-347310: месячный бакет на оси дней — имя месяца на делении, полосы месяца/недели пустые
                            } else if (this.freq_text === 'W') {
                                text = chart_data[j].date_Week
                            } else if (this.freq_text === 'M') {
                                text = chart_data[j].date_Month
                            } else if (this.freq_text === 'A') {
                                text = chart_data[j].date_Year
                            } else if (this.freq_text === '') {
                                text = ''
                            } else {
                                text = chart_data[j].date_Day
                            }
                            // IE 2026 09 13 / ODOO-5800 (заказ Игоря): компактные оси — на оси X только годы (полоса групп), подписи пустые
                            if (this.axesCompactX() && this.freq !== 'A') text = ''
                        }
                        this.flex.axisX.itemsSource.push({
                            value: chart_data[j].date_parse,
                            text:  text,
                        })
                    }
                }

                this.flex.axisX.groupsOptions = { display:AxisGroupsDisplay.Show }
            } else {
                if (!this.attr.axisX_bindingX2.endsWith('.title')) {
                    for (let attr of attrs) {
                        if (attr['binding'] === this.attr.axisX_bindingX2 && attr.attr_type === 'AttrLink') {
                            const ids = [...new Set(
                                (this.doc[this.binding] || [])
                                    .map(row => this.store.get_value(row, attr.binding))
                                    .filter(id => id && !String(id).startsWith('=') && !String(id).startsWith('#'))
                            )]
                            this.store.get_itemsSource(this, this.doc[this.binding], attr, {fill:'_doc.data', ids})
                            this.flex.bindingX = `${attr['binding']}.title`
                            break
                        }
                    }
                }
                // Apply format from the axisX field to suppress thousands separators etc.
                const axisXAttr = attrs.find(a => a.binding === this.attr.axisX_bindingX2)
                this.flex.axisX.format = axisXAttr?.format || null
            }

            if (!this.attr?.animation_axisAnimation || !this.data.length || this.data.length!=chart_data.length) {
                this.data = chart_data
            } else {
                this.data.length = 0
                for (let i=0; i < chart_data.length; i++) {
                    this.data.push(chart_data[i])
                    // for (let attr of attrs) {
                    //     if (this.data[i][attr.binding] !== chart_data[i][attr.binding]) {
                    //         this.data[i][attr.binding] = chart_data[i][attr.binding]
                    //     }
                    // }
                }
                // this.data.unshift({})
                // this.data.shift()
            }

            // cache visibility
            let cacheVisibility = {}
            for (let i=0; i < this.flex.series.length; i++) {
                cacheVisibility[this.flex.series[i].binding] = {visibility: this.flex.series[i].visibility}
            }

            const isStockChart = this.attr.chartType // ['stockColumn','stockLine'].includes(this.attr.chartType)
            const binding_stock = this.attr.binding_stock || 'open_balance';
            const binding_DOS   = this.attr.binding_DOS   || 'DOS';
            const binding_LS    = this.attr.binding_LS    || 'LS';
            const binding_in    = this.attr.binding_in    || 'IN';
            const binding_out   = this.attr.binding_out   || 'OUT';
            // IE 2026 09 11 / ODOO-5800 (заказ Игоря): списание (плановое уничтожение просрочки, WO_OUT) уходит из остатка
            // так же, как расход — ступень остатка иначе рвалась на месяц списания (март→апрель 2027, −43 034).
            // Поле — 'binding_wo' чарта (дефолт WO_OUT; false — не учитывать); нет колонки в данных → 0.
            const binding_wo    = this.attr.binding_wo === false ? '' : (this.attr.binding_wo || 'WO_OUT');
            const woOf = (row) => (binding_wo && row ? (row[binding_wo] || 0) : 0);
            // IE 2026 09 13 / ODOO-5800 (замечание Игоря): контекст расчёта диапазонов осей (axisRangeCompute / axisRangesRefresh)
            const rangeCtx = { isStockChart, binding_stock, binding_in, binding_out, woOf, stack2: this.attr.chart_stack2 || 'down',
                               shownOnly: this.axisRangeShownOnly(), shown: (a) => this.axisSeriesShown(a, cacheVisibility) }
            this._axisRangeCtx = { ...rangeCtx, attrs }
            this.uncovCurveCut(this.data, attrs, binding_stock, binding_in, binding_out)   // IE 2026 10 01 / ODOO-5800 (fe.ux.uncovCurveOnlyWhileOpen)

            // series
            // if (!this.flex.series.length) {
                this.flex.series.clear()
                this.axesUnused_restoreMain()   // IE 2026 09 10 / ODOO-… (замечание Игоря)
                // IE 2026 09 23 / ODOO-5800 (Igor, форма ячейки: значения оси Y слева и заголовок «Quantity»): заголовок ГЛАВНОЙ оси Y — ключ 'axisY-title'
                // чарта (у именованных осей и рядов областей тот же ключ стоит у поля); ключа нет — заголовок, поставленный прежней сборкой, снимается.
                // Компактная ось Y (compact-axisY) заголовки по-прежнему снимает (axesCompactApply)
                { const t0 = this.attr['axisY-title'], ay0 = this.flex.axisY; if (t0 != null && String(t0) !== '') { ay0.title = String(t0); ay0._ieTitleAttr = true } else if (ay0._ieTitleAttr) { ay0.title = ''; ay0._ieTitleAttr = false } }
                // IE 2026 10 22 / ODOO-5800 (Igor 22.10: графики ВЕРСІЇ / ПЛАНИ формы ячейки на AttrChart): явные границы ГЛАВНОЙ оси Y — ключи чарта 'axisY-max' / 'axisY-min'
                // (стек wijmo иначе тянет ось на сумму столбиков факта и текущей версии, нарисованной рядом в режиме chart_stack2 'beside'); без ключа — авто, как прежде.
                // Выключатель fe.ux.chartAxisYRange (дефолт ВКЛ)
                { const ayM = this.flex.axisY, onR = (() => { try { return this.store?.setting?.('fe.ux.chartAxisYRange', true) !== false } catch (e) { return true } })()
                  const numR = (v) => (onR && v !== null && v !== undefined && v !== '' && Number.isFinite(Number(v))) ? Number(v) : null
                  ayM.max = numR(this.attr['axisY-max']); ayM.min = numR(this.attr['axisY-min']) }   // IE 2026 10 22 / ODOO-5800
                let axisY = this.axisY = {}
                // ODOO-4141: раздельные стеки. `stacking` в wijmo — свойство ЧАРТА, на
                // серии его нет, поэтому ВСЕ stacked-серии всегда падают в один общий
                // стек; именованная ось Y стек не группирует (проверено на стенде: серии
                // вторичной оси вообще перестают стекаться). Разделяет только PlotArea:
                // группа получает свою область и привязанную к ней ось Y и стекуется
                // независимо. Раскладка 'stackGroup-layout': 'rows' — панели друг под
                // другом (по умолчанию), 'overlay' — панели в одной ячейке (наложение).
                const stackGroups = {}
                const stackLayout = this.attr['stackGroup-layout'] || 'rows'
                if (this.flex.plotAreas.length) this.flex.plotAreas.clear()
                // IE 2026 09 12 / ODOO-… (заказ Игоря): нижние области графика — серия с именем оси X (attr.axisX, как attr.axisY) рисуется
                // в своей области под основной (ряд 1, 2, …) со своими осями X и Y; оси прежней сборки снимаем
                // IE 2026 09 12 / ODOO-…: this.flex — реактивный прокси Vue: push через прокси дублирует ось в коллекции, indexOf не находит
                // raw-объект — снимаем оси нижних областей по метке _plotRowKey на raw-коллекции
                { const rawAxes = toRaw(this.flex).axes; for (let i = rawAxes.length - 1; i >= 0; i--) { const a = rawAxes[i]; if (a && a._plotRowKey) rawAxes.removeAt(i) } }
                this._plotRowAxes = []
                const plotRows = this._plotRows = {}
                this._plotRowSpacer = null; this._axisXMainRowPass = 0   // IE 2026 09 23 / ODOO-5800: ряд-распорка под ось X главного ряда (axisXMainRow_*), проходы подгонки её высоты
                this._hatch = {}   // IE 2026 09 23 / ODOO-5800: паттерны штриховки этой сборки — id → {fill, color} (hatchDefs_ensure)
                // Ширина группы колонок: с раздельными стеками в категории стоит уже не
                // одна колонка, а по одной на группу — при дефолтных ~70% они вырождаются
                // в частокол. Ключ чарта 'groupWidth' ('90%', число px) правит вручную.
                // flex переживает перерисовку — groupWidth задаём ВСЕГДА (в т.ч. снимаем),
                // иначе выставленная режимом 'beside' ширина остаётся навсегда (ODOO-4646)
                this.flex.options = { ...(this.flex.options || {}) }
                if (this.attr.groupWidth) {
                    this.flex.options.groupWidth = this.attr.groupWidth
                } else {
                    delete this.flex.options.groupWidth
                }
                // ODOO-4646: КАК рисуется второй стек (меры с chart_down — расход против
                // остатков). Ключ чарта 'chart_stack2':
                //   'down'   — зеркало вниз штатным стеком wijmo (вариант A, ПО УМОЛЧАНИЮ,
                //              поведение прежнее: ключ отсутствует → 'down');
                //   'inside' — узкой колонкой внутри той же категории (вариант B);
                //   'beside' — отдельной колонкой рядом в пределах категории (вариант C).
                // В режимах B/C значения НЕ зеркалятся, штатная отрисовка этих серий
                // подавляется, стек рисуется своим слоем в itemFormatter.
                const stack2 = this.attr.chart_stack2 || 'down'
                if (stack2 === 'beside' && !this.attr.groupWidth) {
                    // рядом с основным стеком нужна вторая колонка — при дефолтных ~70%
                    // бина места нет. Явно заданный groupWidth не трогаем.
                    this.flex.options.groupWidth = '30%'
                }
                const attrsByOrder = [...attrs].sort((a, b) => {
                    const rank = (x) =>
                        !x.axisY ? 0 :
                        x.stacked ? 1 :
                        2;

                    return rank(a) - rank(b);
                });

                // разрезные серии одной меры: единый родительский cssStyleChart сливал
                // N линий в один цвет — при >1 серии разреза стиль не наследуем (палитра)
                const seriesSiblings = {}
                for (const a of attrsByOrder) {
                    if (a.series_binding) seriesSiblings[a.series_binding] = (seriesSiblings[a.series_binding] || 0) + 1
                }
                // ODOO-4646: производные __down-ключи заводятся ДО цикла серий.
                // Расчёт min/max оси (ниже) сканирует ВСЕ attrs в момент обработки
                // первой серии своей оси — chart_down-мера, стоящая в порядке позже,
                // на тот момент ключа ещё не имела, и учёт стека вниз молча выпадал.
                for (const attr of attrsByOrder) {
                    if (!attr['chart_down'] || stack2 !== 'down' || attr.axisX) continue   // IE 2026 09 12 / ODOO-…: в нижней области — положительные
                    const nb = attr.binding + '__down'
                    for (const row of this.data) {
                        const v = row[attr.binding]
                        row[nb] = (v === null || v === undefined || v === '') ? v : -v
                    }
                }
                for (let attr of attrsByOrder) {
                    // IE 2026 09 10 / ODOO-5800: AttrTime (DOS в секундах, Offset) — серия наравне с AttrDays
                    if (attr.attr_type=='AttrNumber' || attr.attr_type=='AttrDays' || attr.attr_type=='AttrTime') { // && !attr.chartGroup
                    // && ['M_minStock','M_optStock'].includes(attr.binding)
                        if (attr.binding === this.attr.axisX_bindingX2) continue
                        let series = new wjChart.Series()
                        series.binding = attr.binding
                        if (this.binding_forSelector=='' && attr.forSelector) {
                            this.binding_forSelector = attr.binding
                        }
                        series.name = attr.title
                        // ODOO-4449: chart_down — серия рисуется ВНИЗ от нуля (расход против
                        // прихода). Значения не трогаем — в строках заводится производный
                        // ключ __down, грид и остальные потребители видят исходную меру.
                        if (attr['chart_down'] && stack2 === 'down' && !attr.axisX) {   // IE 2026 09 12 / ODOO-…: нижняя область — без зеркала
                            const nb = attr.binding + '__down'   // значения заведены пред-проходом выше
                            series.binding = nb
                            // все lookups серий идут по binding — производный ключ
                            // обязан резолвиться в тот же attr (visibility, легенда, тултип)
                            this.attrs_by_binding[nb] = attr
                        }
                        // ODOO-4441: stock_DOS_line — DOS выходит из сток-обработки и
                        // рисуется обычной серией своего типа (Spline/Line по оси DOS);
                        // по умолчанию поведение прежнее (Column + ступенчатый рендер)
                        const dos_asLine = this.attr['stock_DOS_line'] && series.binding === binding_DOS
                        if (isStockChart && !dos_asLine && (series.binding === binding_stock || series.binding === binding_DOS)) {
                            series.chartType ='Column'
                            for (const row of this.data) {
                                if (row[series.binding] === null || row[series.binding] === undefined) {
                                    row[series.binding] = 0
                                }
                            }
                        // IE 2026 09 01 / ODOO-5884: 'Pie' в enum FlexChart нет — колонка,
                        // попавшая в обычную ветку (напр. скрытый chart_hidden-пирог),
                        // рисуется дефолтной Column, а не роняет сеттер Series.chartType
                        // неизвестной строкой
                        } else if (attr.chartType && attr.chartType !== 'Pie') {
                            if (attr.stacked) { // attr.chartType=='Area' &&
                                // pass for stacking: серия остаётся на типе чарта.
                                // ODOO-3720: Column в enum wijmo = 0 (falsy) — проверка `!chartType`
                                // позволяла stacked-серии с собственным типом затереть тип ВСЕГО
                                // чарта (SplineArea превращал столбики в области). Заполняем тип
                                // чарта только когда он реально не задан; stacked-серия с типом,
                                // ОТЛИЧНЫМ от типа чарта, получает его per-series (стекуется
                                // в рамках своей оси Y).
                                if (this.flex.chartType == null) {
                                    this.flex.chartType = attr.chartType
                                } else if (String(this.flex.chartType) !== String(wjChart.ChartType[attr.chartType] ?? attr.chartType)) {
                                    // enum, не строка: Series.chartType молча игнорирует
                                    // строковое значение — серия падала на тип чарта
                                    series.chartType = wjChart.ChartType[attr.chartType] ?? attr.chartType
                                }
                            } else {
                                series.chartType = wjChart.ChartType[attr.chartType] ?? attr.chartType
                            }
                        } else { // default
                            series.chartType ='Column'
                        }
                        // series.chartType="LineSymbols"
                        // series.symbolStyle={fill:'gold',stroke:'gold'}
                        
                        const setZero = true
                        // IE 2026 09 16 / ODOO-5800 (решение Игоря): у длительностей (DOS / DOS (country) / Offset — AttrTime, AttrDays)
                        // пустое значение — это «не определён» (бэкенд: WAvg без весов → NULL), линия рвётся, а не падает в 0;
                        // выключатель fe.ux.chartDurationGap=false — прежнее заполнение нулём
                        // Выборка бэкенда отбрасывает нули как пустые (skipEmptyValues), поэтому «нет значения» само по себе не
                        // отличает 0 (нет остатка) от «не определён»: признак — колонка-вес <binding>_w, которую WAvg кладёт рядом.
                        // Вес есть (> 0) → значение было 0 → восстанавливаем 0; веса нет → разрыв. Серии без весов — как прежде (0).
                        const durationGap = (['AttrTime', 'AttrDays'].includes(attr.attr_type) || series.binding === binding_DOS)
                            && this.store?.setting?.('fe.ux.chartDurationGap', true) !== false
                        const wKey = attr.binding + '_w'
                        const hasW = durationGap && this.data.some(r => r && r[wKey] !== undefined && r[wKey] !== null)
                        if (setZero && series.chartType === 9) { // "Spline"
                            for (const row of this.data) {
                                if (row[attr.binding] === null || row[attr.binding] === undefined) {
                                    if (hasW && !(Number(row[wKey]) > 0)) continue   // WAvg без весов → не определён → разрыв линии
                                    row[attr.binding] = 0
                                }
                            }
                        }

                        if (attr.cssStyleChart && attr.cssStyleChart!=''){
                            if (!(attr.series_binding && seriesSiblings[attr.series_binding] > 1)) {
                                series.style = attr.cssStyleChart
                            } else if (attr.series_color_pinned && this.seriesColorPinnedOn()) {
                                // IE 2026 09 14 / ODOO-5800 (заказ Игоря): цвет, закреплённый за ЗНАЧЕНИЕМ разреза (doc.color записи
                                // справочника — у стран цвет флага; ставит бэк, widgets.series_dim_colors), — свой stroke и fill серии,
                                // одна страна = один цвет на всех чартах; прочие разрезные серии по-прежнему палитрой wijmo (ODOO-4440)
                                const c = attr.cssStyleChart.fill || attr.cssStyleChart.stroke
                                if (c) series.style = { ...attr.cssStyleChart, fill: c, stroke: (/^#[0-9a-f]{8}$/i.test(c) ? c.slice(0, 7) : c) }
                            }
                        }
                        // IE 2026 09 23 / ODOO-5800 (Igor, форма ячейки: «uncovered — тот же цвет, что у базовой серии, с красной штриховкой»): hatch_base у поля —
                        // binding базовой серии этого же списка: заливка = цвет базовой (fill её cssStyleChart, нет — свой) с красной диагональной штриховкой
                        // (SVG-паттерн в <defs> чарта, hatchDefs_ensure; hatch_color — цвет штриха), обводка — как у базовой, чтобы контур столбика совпадал.
                        // Ключи hatch_* в стиль wijmo не попадают. Выкл: fe.ux.chartHatch = false — свой cssStyleChart, как прежде
                        if (attr.hatch_base && this.chartHatchOn()) {
                            const own = (attr.cssStyleChart && typeof attr.cssStyleChart === 'object') ? attr.cssStyleChart : {}
                            const base = attrs.find(a => a && a.binding === attr.hatch_base)
                            const bcss = (base && base.cssStyleChart && typeof base.cssStyleChart === 'object') ? base.cssStyleChart : {}
                            const hid = this.hatchId(attr.binding)
                            this._hatch[hid] = { fill: bcss.fill || own.fill || '#999999', color: attr.hatch_color || '#e53935' }
                            const hst = { ...own, fill: `url(#${hid})` }
                            if (bcss.stroke !== undefined) hst.stroke = bcss.stroke
                            if (bcss.strokeWidth !== undefined) hst.strokeWidth = bcss.strokeWidth
                            series.style = hst
                        }
                        // IE 2026 09 25 / ODOO-5800 (Igor, форма ячейки: «раскрашивай оптимальную зону как белую; показывай зелёным макс зону до верха»): полоса
                        // между сериями — у поля ключ area_base = binding серии нижней границы того же списка и / или area_top = true (верх — потолок оси серии).
                        // wijmo умеет Area только от нуля (вложенные заливки — лишь полупрозрачные и всегда с чужим цветом под ними), поэтому штатная заливка серии
                        // гасится (серия остаётся в подсказке и легенде), а полоса рисуется после отрисовки — areaBand_draw. Выкл: fe.ux.chartAreaBand = false —
                        // заливка от нуля своим cssStyleChart, как прежде
                        if ((attr.area_base || attr.area_top) && this.areaBand_on()) {
                            const own = (attr.cssStyleChart && typeof attr.cssStyleChart === 'object') ? attr.cssStyleChart : {}
                            series.style = { ...own, fill: 'none', stroke: 'none', strokeWidth: 0 }
                        }
                        // series['visible'] = true // add 'visible' property for binding
                        if (attr.chartGroup){
                            series.visibility = 3 // Hidden
                        } else if (series.binding in cacheVisibility){
                            series.visibility = cacheVisibility[series.binding].visibility
                        } else if (attr.chart_hidden){
                            series.visibility = 2 // Legend
                        }
                        // if (attr.axisY){
                        //     console.log(attr.axisY)
                        if (!attr.axisX) {   // IE 2026 09 12 / ODOO-…: серии нижней области — своя область и оси (ветка else ниже)
                            attr.axisY = attr.axisY||''
                            if (!axisY[attr.axisY]) {
                                let axisY2 = this.flex.axisY
                                if (attr.axisY) {
                                    axisY2 = new wjChart.Axis();
                                    axisY2.majorGrid = false
                                    axisY2.minorGrid = false
                                    axisY2.axisLine = true;
                                    // IE 2026 08 31 / ODOO-5884 (Work center load): именованная ось,
                                    // заведённая СКРЫТОЙ серией (chartGroup => visibility Hidden), нужна
                                    // только чтобы увести её значения из расчёта min/max основной оси —
                                    // рисовать её незачем. Колонка «Capacity, sec» (секунды рядом с часами)
                                    // иначе пририсовывала справа пустую шкалу 0..900 000.
                                    if (attr.chartGroup) {
                                        axisY2.axisLine = false;
                                        axisY2.labels = false;
                                    }
                                    // axisY2.labels = false;
                                    axisY2.position = 3 //"Right";
                                    // axisY2.title = "...";
                                    // Label format for the programmatically created right axis:
                                    // explicit 'axisY-format' on the first series of this named axis,
                                    // else that series' own numeric format (AttrDays/AttrTime use itemFormatter instead)
                                    const axisFormat = attr['axisY-format'] || ((attr.attr_type !== 'AttrDays' && attr.attr_type !== 'AttrTime') ? attr.format : null) // IE 2026 09 10 / ODOO-5800
                                    if (axisFormat) axisY2.format = axisFormat
                                }
                                // axisY2.title = 'Downloads (k)';
                                // axisY2.format = 'n0,';
                                // axisY2.min = 0;
                                
                                // IE 2026 09 13 / ODOO-5800 (замечание Игоря): диапазон оси — по показанным сериям (axisRangeCompute)
                                const rng = this.axisRangeCompute(attr, attrs, chart_data, rangeCtx)
                                axisY2.min = rng.min
                                axisY2.max = rng.max
                                // IE 2026 09 11 / ODOO-5800 (заказ Игоря): выравнивание нуля именованной оси по нулю главной
                                // делается после отрисовки (alignSecondaryAxesZero), когда actualMin/actualMax главной оси
                                // уже известны (здесь они — от прошлой отрисовки или пусты); тут только якорь данных оси.
                                if (attr.axisY) {
                                    axisY2._alignZero = { dataMin: rng.min, dataMax: rng.max, nonneg: rng.nonneg }
                                }
                                axisY[attr.axisY] = axisY2

                                if (attr.attr_type === 'AttrDays') { // attr.axisY === 'DOS'
                                    // единица оси — дни; крупные метки укрупняются в m/y
                                    // (форматтер ниже): без подписи ось читалась «в чём это?»
                                    // (вопрос Андрея 09.08 — «сколько в днях»)
                                    axisY2.title = attr['axisY-title'] || this.t('{axis} — days (m = months, y = years)', { axis: (!attr.axisY || attr.axisY === 'DOS') ? this.t('Stock cover') : attr.axisY })   // IE 2026 09 23 / ODOO-341407: i18n // IE 2026 09 25 / ODOO-5800: the named axis 'DOS' is titled «Stock cover» (Igor 25.09), the axis key is unchanged
                                    if (attr?.format === 'm') {
                                        axisY2.majorUnit = 30;
                                        axisY2.minorUnit = 30;
                                    } else {
                                        axisY2.majorUnit = 1;
                                        axisY2.minorUnit = 1;
                                    }

                                    axisY2.itemFormatter = (engine, label) => {
                                        // if (label.val >= 10000000) {
                                        //     label.cls = "high-value";
                                        // } else if (label.val < 5000000) {
                                        //     label.cls = "low-value";
                                        // }
                                        label.text = this.store.formatDaysHTML(label.val, attr)
                                        return label;
                                    };
                                } else if (attr.attr_type === 'AttrTime') {
                                    // IE 2026 09 10 / ODOO-5800 (заказ Игоря): DOS хранится в СЕКУНДАХ (AttrTime, format 'm') —
                                    // ось как у AttrDays: подписи в месяцах (formatTimeHTML), шаг 30 дней = 2 592 000 с;
                                    // без формата 'm' шаг оставляем wijmo (часы/минуты Offset), подписи — те же
                                    this.axisTime_apply(axisY2, attr)
                                }

                                // 'axisY-suffix' on the first series of this named axis: append a
                                // literal suffix (e.g. "M") to its labels — wijmo format strings
                                // can't embed literal text. Compose with an existing itemFormatter
                                // (AttrDays) instead of replacing it.
                                const axisSuffix = attr.axisY ? attr['axisY-suffix'] : null
                                if (axisSuffix) {
                                    const prevFormatter = axisY2.itemFormatter
                                    axisY2.itemFormatter = (engine, label) => {
                                        if (prevFormatter) label = prevFormatter(engine, label)
                                        label.text += axisSuffix
                                        return label
                                    }
                                }
                                // IE 2026 09 12 / ODOO-… (заказ Игоря): подписи числовой именованной оси — коротко (20 000 000 → 20M), если формат не задан явно
                                if (attr.attr_type !== 'AttrDays' && attr.attr_type !== 'AttrTime' && !attr['axisY-format'] && !axisSuffix
                                    && !this.attr['axisY-compact']) this.axisShort_apply(axisY2, attr)
                                if (attr.axisY) this.axisIconGuard(axisY2)   // IE 2026 09 11 / ODOO-5800 (замечание Игоря)
                            }
                            if (attr.axisY) {
                                series.axisY = axisY[attr.axisY];
                            }
                        } else {
                            // IE 2026 09 12 / ODOO-… (заказ Игоря): имя оси X у серии → нижняя область графика (как в примерах wijmo с
                            // несколькими PlotArea): ось X одна на весь график (wijmo рисует её под всеми рядами — подписи
                            // месяцев и полосы лет внизу), у нижней области своя ось Y слева; серии с одним именем — в одной
                            // области (стек там независим); значения положительные.
                            // Пропорции: 'plot-main-height' чарта (по умолчанию 2*) и attr.axisX_height (1*)
                            const key = String(attr.axisX)
                            if (!plotRows[key]) {
                                if (!Object.keys(plotRows).length) {
                                    const pa0 = new wjChart.PlotArea()
                                    pa0.name = 'main'; pa0.row = 0; pa0.height = this.attr['plot-main-height'] || '2*'
                                    this.flex.plotAreas.push(pa0)
                                    this._plotRowsMain = pa0; this._plotRowsMainH = pa0.height; this._sameScalePasses = 0   // IE 2026 09 12 / ODOO-…: один масштаб осей
                                    // IE 2026 09 23 / ODOO-5800 (Igor, форма ячейки: ось дат под верхней панелью): ряд-распорка (row 1, высота в px — _GridLength wijmo
                                    // принимает число) под свою ось X главного ряда (axisXMainRow_draw); высота — измеренная в прошлой отрисовке (шрифт подписей),
                                    // иначе 'axisX-mainRow-height' чарта или 40
                                    if (this.axisXMainRow_on()) {
                                        const sp = new wjChart.PlotArea()
                                        sp.name = 'axis_x'; sp.row = 1; sp.height = this._axisXMainRowH || (+this.attr['axisX-mainRow-height'] > 0 ? +this.attr['axisX-mainRow-height'] : 40)
                                        this.flex.plotAreas.push(sp)
                                        this._plotRowSpacer = sp
                                    }
                                }
                                const pa = new wjChart.PlotArea()
                                pa.name = 'px_' + key; pa.row = Object.keys(plotRows).length + 1 + (this._plotRowSpacer ? 1 : 0); pa.height = attr.axisX_height || '1*'   // IE 2026 09 23 / ODOO-5800: ряд-распорка сдвигает нижние ряды
                                this.flex.plotAreas.push(pa)
                                const ay = new wjChart.Axis(1)   // Position.Left
                                ay.plotArea = pa
                                ay.minorGrid = false
                                ay.title = attr['axisY-title'] || ''
                                this.plotRowAxisY_format(ay, attr)
                                // IE 2026 09 23 / ODOO-5800: явные границы оси ряда — 'axisY-min' / 'axisY-max' у серии, открывающей ряд (форма ячейки: авторазмах
                                // wijmo у ряда со столбиками и точечной серией начинался с 1 800, а ряд DOS получал верх соседнего ряда 3 900)
                                const rowMin = attr['axisY-min'], rowMax = attr['axisY-max']
                                if (rowMin !== undefined && rowMin !== null && rowMin !== '' && isFinite(+rowMin)) ay.min = +rowMin
                                if (rowMax !== undefined && rowMax !== null && rowMax !== '' && isFinite(+rowMax)) ay.max = +rowMax
                                // IE 2026 09 25 / ODOO-5800 (Igor: подписи оси DOS формы ячейки «0,0» и «10,0» — некрасиво): явный шаг делений оси ряда — 'axisY-majorUnit'
                                // у серии, открывающей ряд (авто-шаг wijmo на низкой панели давал две подписи); вместе с 'axisY-min' / 'axisY-max', кратными шагу
                                const rowUnit = attr['axisY-majorUnit']
                                if (rowUnit !== undefined && rowUnit !== null && rowUnit !== '' && isFinite(+rowUnit) && +rowUnit > 0) ay.majorUnit = +rowUnit
                                ay._plotRowKey = key   // IE 2026 09 12 / ODOO-…: метка оси нижней области (тождество через прокси Vue ненадёжно)
                                toRaw(this.flex).axes.push(ay)
                                this._plotRowAxes.push(ay)
                                plotRows[key] = { pa, ay, cfgH: pa.height }   // IE 2026 09 12 / ODOO-…: cfgH — заданная пропорция ряда
                            }
                            series.axisY = plotRows[key].ay
                        }
                        // }

                        // ODOO-4141: серия входит в именованную группу стека → своя
                        // PlotArea + своя ось Y (перекрывает axisY выше: стек важнее
                        // масштабной оси, иначе группы снова слипнутся).
                        const stackGroup = (attr.stacked && attr.stackGroup) ? String(attr.stackGroup) : ''
                        if (stackGroup) {
                            if (!stackGroups[stackGroup]) {
                                const pa = new wjChart.PlotArea()
                                pa.name = 'sg_' + stackGroup
                                if (stackLayout === 'rows') pa.row = Object.keys(stackGroups).length
                                // ODOO-4141: пропорции панелей — star-sizing ('3*' основная,
                                // '1*' вспомогательная). Без этого wijmo делит высоту поровну
                                // и стек столбиков схлопывается в частокол.
                                if (attr.stackGroup_height) pa.height = attr.stackGroup_height
                                this.flex.plotAreas.push(pa)

                                const axg = new wjChart.Axis(1)   // Position.Left
                                axg.plotArea = pa
                                axg.minorGrid = false
                                axg.title = attr.stackGroup_title || stackGroup
                                if (attr.attr_type === 'AttrDays') {
                                    // дни/месяцы — как на именованной оси DOS: иначе ось группы
                                    // печатала «30M» вместо «Xm» (числовой формат вместо дней)
                                    if (attr?.format === 'm') { axg.majorUnit = 30; axg.minorUnit = 30 }
                                    else { axg.majorUnit = 1; axg.minorUnit = 1 }
                                    axg.itemFormatter = (engine, label) => {
                                        label.text = this.store.formatDaysHTML(label.val, attr)
                                        return label
                                    }
                                } else if (attr.attr_type === 'AttrTime') {
                                    this.axisTime_apply(axg, attr, false) // IE 2026 09 10 / ODOO-5800: секунды → месяцы, как ось DOS
                                } else {
                                    // формат оси группы: свой 'axisY-format' меры, иначе целые —
                                    // формат меры (n2 у денежных) давал на оси «12 000 000,00»
                                    axg.format = attr['axisY-format'] || 'n0'
                                    if (this.attr['axisY-compact']) {
                                        const langG = this.store?.user?.language || 'ru'
                                        const nfG = new Intl.NumberFormat(langG, { notation: 'compact', maximumFractionDigits: 1 })
                                        axg.itemFormatter = (engine, label) => { label.text = nfG.format(label.val); return label }
                                    } else if (!attr['axisY-format']) this.axisShort_apply(axg, attr)   // IE 2026 09 12 / ODOO-…
                                }
                                this.flex.axes.push(axg)
                                stackGroups[stackGroup] = axg
                            }
                            series.axisY = stackGroups[stackGroup]
                        }

                        const dataLabel = this.flex.dataLabel
                        if ((attr.dataLabel?.position || 'None') !== 'None') {
                             dataLabel.position = attr.dataLabel.position || 'None'
                            if (attr.dataLabel?.offset   != null) dataLabel.offset = attr.dataLabel.offset
                            if (attr.dataLabel?.border   != null) dataLabel.border = attr.dataLabel.border
                            if (attr.dataLabel?.connectingLine != null) dataLabel.connectingLine = attr.dataLabel.connectingLine
                        }

                        this.flex.series.push(series)
                        this.attrs_by_binding[attr.binding] = attr
                    }
                }
                // IE 2026 09 12 / ODOO-…: wijmo при добавлении серии сам кладёт её ось в flex.axes, если ось «не привязана» (по разу на серию) —
                // с нашим push ссылка на ось повторялась (по 3 на ось), а оси прежних сборок load_data оставались навсегда.
                // Сводим raw-коллекцию: повтор ссылки — долой, ось без серии (кроме основных X/Y) — долой
                {
                    const raw = toRaw(this.flex), rawAxes = raw.axes, seen = new Set()
                    const used = new Set(); for (const sr of raw.series) { if (sr.axisX) used.add(toRaw(sr.axisX)); if (sr.axisY) used.add(toRaw(sr.axisY)) }   // оси серий могут быть прокси
                    const ax0 = toRaw(raw.axisX), ay0 = toRaw(raw.axisY)
                    for (let i = rawAxes.length - 1; i >= 0; i--) {
                        const a = toRaw(rawAxes[i])
                        if (a === ax0 || a === ay0) continue
                        if (!used.has(a)) rawAxes.removeAt(i)
                    }
                    for (let i = 0; i < rawAxes.length; i++) { const a = toRaw(rawAxes[i]); if (seen.has(a)) { rawAxes.removeAt(i); i-- } else seen.add(a) }
                }
                if (this.attr.axisY) {
                    for (let key in this.attr.axisY) {
                        this.flex.axisY[key] = this.attr.axisY[key]
                        // this.flex.axisY.majorGrid = false
                        // this.flex.axisY.minorGrid = false
                    }
                }
                // 'axisY-suffix' config key: append a literal suffix (e.g. "M") to the
                // main Y-axis labels — wijmo format strings can't embed literal text.
                // Compose with a pre-existing itemFormatter, but never with our own
                // wrapper from a previous load_data() run (tagged _axisYSuffix).
                // 'axisY-compact': автоматическое сокращение больших чисел (20 000 000 -> «20 млн»).
                // В отличие от 'axisY-format' с делителем ('n0,,' — всегда миллионы) масштаб
                // подбирается по величине значения и локализуется языком пользователя.
                // Ставится ДО суффикса, чтобы суффикс мог дописаться поверх при желании.
                const mainAxisCompact = this.attr['axisY-compact']
                if (mainAxisCompact) {
                    const lang = this.store?.user?.language || 'ru'
                    const nf = new Intl.NumberFormat(lang, { notation: 'compact', maximumFractionDigits: 1 })
                    const prev = this.flex.axisY.itemFormatter
                    const prevFormatter = (prev && !prev._axisYCompact && !prev._axisYSuffix) ? prev : null
                    const compactFormatter = (engine, label) => {
                        if (prevFormatter) label = prevFormatter(engine, label)
                        if (label.val !== undefined && label.val !== null && isFinite(label.val)) {
                            label.text = nf.format(label.val)
                        }
                        return label
                    }
                    compactFormatter._axisYCompact = true
                    this.flex.axisY.itemFormatter = compactFormatter
                }
                const mainAxisSuffix = this.attr['axisY-suffix']
                if (mainAxisSuffix) {
                    const prev = this.flex.axisY.itemFormatter
                    const prevFormatter = (prev && !prev._axisYSuffix) ? prev : null
                    const suffixFormatter = (engine, label) => {
                        if (prevFormatter) label = prevFormatter(engine, label)
                        label.text += mainAxisSuffix
                        return label
                    }
                    suffixFormatter._axisYSuffix = true
                    this.flex.axisY.itemFormatter = suffixFormatter
                }
                // IE 2026 09 12 / ODOO-… (заказ Игоря): основная ось Y — короткие подписи по умолчанию (формат/суффикс/compact заданы явно — они)
                if (!mainAxisCompact && !mainAxisSuffix && !this.attr['axisY-format']) this.axisShort_apply(this.flex.axisY, this.attr)
                else if (this.flex.axisY.itemFormatter && this.flex.axisY.itemFormatter._axisShort) this.flex.axisY.itemFormatter = null
                if (this.binding_forSelector=='') {
                    for (let attr of attrs) {
                        if (attr.attr_type=='AttrNumber' && !attr.chart_hidden) {
                            this.binding_forSelector = attr.binding
                            break
                        }
                    }
                    if (this.binding_forSelector=='') {
                        for (let attr of attrs) {
                            if (attr.attr_type=='AttrNumber') {
                                this.binding_forSelector = attr.binding
                                break
                            }
                        }
                    }
                }
                this.set_commandsActive()
                this.axisXMainRow_apply()   // IE 2026 09 23 / ODOO-5800: штатная ось X спрятана (своя рисуется под главным рядом) либо возвращена
                // IE 2026 10 22 / ODOO-5800: ось месяцев без распорки — нижнее поле под неё (plotMargin bottom), снимается, когда ключа нет
                this.monthAxisMargin_apply()   // IE 2026 10 29 / ODOO-5800 (ie-dm7 #114070, проба 5: легенда Bottom наезжала на ось X): то же поле + место под легенду wijmo сверху / снизу
                this.axesCompactApply()   // IE 2026 09 13 / ODOO-5800 (заказ Игоря): компактные оси — до снимка состояния осей (axesUnused_hide)
                this.seriesVisibilityChanged(false)
                this.buildLegendGroups()
            // }
        },
        // IE 2026 11 01 / ODOO-350449 (заказ Игоря: номер тижня на осі X теплокарти, як у REPORT2): isoWeek(d) вынесен в src/utils/isoWeek.js (та же формула, pandas Period('W').weekofyear)
        // IE 2026 10 31 / ODOO-5800 (заказ Игоря): флаг полос дат без расписания (§8: выключается без пересборки)
        chartDateGroupsNoSchedule_on() { return chartDateGroups_on(this.store?.setting ? (k, d) => this.store.setting(k, d) : null) },
        // строки годятся для полос без data_schedule: флаг включён и у каждой строки с датой разобран год (иначе wijmo завёл бы группу «undefined»)
        chartDateGroups_rowsOk() { return chartDateGroups_rowsOk(this.doc?.[this.binding], this.chartDateGroupsNoSchedule_on()) },
        set_itemsSource() {
            this.chartSettle(true)   // IE 2026 09 15 (замечание Игоря): новая выборка — скрыть до стабильной отрисовки
            // IE 2026 10 31 / ODOO-5800 (заказ Игоря): полосы год/месяц/неделя и без data_schedule — по date_Year/date_Month/date_Week самих строк
            // (их load_data считает из даты каждой строки); флаг fe.ux.chartDateGroupsNoSchedule
            if ((this.flex.bindingX=='date_parse' || this.flex.bindingX=='date') && (this.attr.data_schedule || this.chartDateGroups_rowsOk())) { //  && this.attr.freq === 'G'
                let groupDescriptions = [],
                freq = this.freq
                
                if (freq === 'D') {
                    groupDescriptions.push(new PropertyGroupDescription("date_Year"))
                    groupDescriptions.push(new PropertyGroupDescription("date_Month"))
                    groupDescriptions.push(new PropertyGroupDescription("date_Week"))
                } else if (freq === 'W') {
                    groupDescriptions.push(new PropertyGroupDescription("date_Year"))
                    groupDescriptions.push(new PropertyGroupDescription("date_Month"))
                } else if (freq === 'M') {
                    groupDescriptions.push(new PropertyGroupDescription("date_Year"))
                } else if (freq === 'A') {
                    1
                } else {
                    groupDescriptions.push(new PropertyGroupDescription("date_Year"))
                    groupDescriptions.push(new PropertyGroupDescription("date_Month"))
                    groupDescriptions.push(new PropertyGroupDescription("date_Week"))
                }

                this.flex.itemsSource = new CollectionView(this.doc[this.binding], {
                    // sortDescriptions: [new SortDescription("date_month", false)],
                    groupDescriptions
                })
            } else {
                this.flex.itemsSource = []
                this.flex.itemsSource = this.doc[this.binding]
            }
        },
        //--------------------------------- IE 2026 09 01 / ODOO-5884: круговая диаграмма (FlexPie)
        // Pie-режим включает колонка с chartType 'Pie' среди видимых серий: вместо
        // FlexChart рендерится FlexPie (v-if в шаблоне). Механики FlexChart (оси,
        // легенда-расшифровка, hslGroup, cssStyleChart, селектор) пирога не касаются.
        // Методы, не computed — по той же причине, что у легенды (см. коммент в data):
        // настройки правятся на raw-объекте стора мимо vue-прокси.
        pieAttr() {
            // та же база, что у цикла серий load_data; служебные (chartGroup)
            // и скрытые (chart_hidden) колонки пирог не включают
            const attrs = this.store.fieldsNoHierarchy(this.attr?.attrs)
            return attrs.find(a =>
                (a.attr_type === 'AttrNumber' || a.attr_type === 'AttrDays' || a.attr_type === 'AttrTime') // IE 2026 09 10 / ODOO-5800
                && a.chartType === 'Pie'
                && !a.chartGroup && !a.chart_hidden
                && a.binding !== this.attr.axisX_bindingX2) || null
        },
        isPieMode() { return !!this.pieAttr() },
        // IE 2026 09 15 / ODOO-… (заказ Игоря): режим «муравьиная логистика» — по chartType 'AntFlow' настроек чарта (viewParams.dataChart)
        isAntMode() { return (this.attr?.chartType || '') === 'AntFlow' },
        // IE 2026 09 27 / ODOO-341407: кнопка 🏷 островка — открыть / закрыть окно легенды Flow canvas; состояние окна живёт в AttrAntFlow, как было
        antLegend_toggle() {
            const ant = this.$refs.ant
            if (ant) ant.legendVisible = !ant.legendVisible
        },
        antRows() { const [doc, binding] = this.store.attr_get_link(this.WIDGET, this.attr); const rows = doc?.[binding]; return Array.isArray(rows) ? rows : [] },
        pieNameAttr() {
            // категория: первая включённая строковая колонка (use === false —
            // выключено, отсутствие use — включено, зеркало _filter_use_fields бэка).
            // IE 2026 09 01 / ODOO-5884: либо AttrStr, помеченная visibleChart —
            // колонка может быть скрыта в таблице (use false), но оставаться
            // категорией пирога (кейс WGT-wc-list: в таблице ссылка Work center,
            // титул для долек берётся из скрытой workcenter_title)
            const attrs = this.store.fieldsNoHierarchy(this.attr?.attrs)
            return attrs.find(a => a.attr_type === 'AttrStr' && (a.visibleChart || a.use !== false)) || null
        },
        initializePie(flexPie) {
            this.flexPie = flexPie
            this.flex = null // FlexChart размонтирован v-if'ом — ссылку не держим
            // IE 2026 09 01 / ODOO-5884 (заказ Игоря): классический pie с внешними
            // подписями — «Категория N%» у каждой дольки, линия-выноска к сектору;
            // легенда выключена в шаблоне, точное значение остаётся в тултипе
            const dl = flexPie.dataLabel
            dl.position = wjChart.PieLabelPosition.Outside
            dl.connectingLine = true
            dl.offset = this.store.setting('fe.chart.pieLabelOffsetPx', PIE_LABEL_OFFSET)   // IE 2026 09 05 / ODOO-336330: настройки базы fe.chart.pieLabel*
            dl.content = (ht) => this.pieLabelContent(ht)
            // IE 2026 09 01 / ODOO-5884: overlappingLabels у PieDataLabel этой версии
            // wijmo нет — перекрытия снимаем сами в rendering; список нарисованных
            // подписей обнуляем в начале каждого кадра (FlexPie._render → onRendering)
            if (!flexPie.__pieLabelsHooked) {
                flexPie.__pieLabelsHooked = true
                dl.rendering.addHandler(this.pieLabelRendering, this)
                flexPie.rendering.addHandler(this.pieLabelsReset, this)
            }
            this.content_Changed()
        },
        pieLoad() {
            this.$nextTick(() => this.attrResize())
            if (!this.doc || !this.flexPie) return
            const rows = this.doc[this.binding]
            if (!rows) return
            const pieAttr = this.pieAttr()
            if (pieAttr) this.attrs_by_binding[pieAttr.binding] = pieAttr
            // источник перевзводится «в лоб», как set_itemsSource у FlexChart:
            // правки строк в том же массиве сеттер wijmo иначе молча пропускает
            this.flexPie.itemsSource = []
            this.flexPie.itemsSource = rows
        },
        // IE 2026 09 01 / ODOO-5884: сумма модулей всех долек — ровно как wijmo
        // меряет пирог (_sums += Math.abs(v)); общая для тултипа и подписей
        pieAbsSum() {
            const pieAttr = this.pieAttr()
            let sum = 0
            for (const row of this.doc?.[this.binding] || []) {
                const v = Number(row?.[pieAttr?.binding])
                if (Number.isFinite(v)) sum += Math.abs(v)
            }
            return sum
        },
        // IE 2026 09 01 / ODOO-5884: доля дольки в процентах (от суммы модулей —
        // ровно как wijmo меряет пирог); null, если доли нет
        pieShare(value) {
            if (value == null || isNaN(value)) return null
            const sum = this.pieAbsSum()
            if (!(sum > 0)) return null
            return Math.abs(value) / sum * 100
        },
        // IE 2026 09 01 / ODOO-5884 (заказ Игоря): подпись дольки — «Категория N%»
        // (внешняя, с выноской); совсем мелкие — «<1%», чтобы не писать «0%».
        // maxChars — предел длины ИМЕНИ (процент не режется): длинные названия
        // рабочих центров и поставщиков иначе сливаются в кашу и вылезают за край
        // виджета; pieLabelRendering ужимает ещё сильнее, если места мало.
        pieLabelContent(ht, maxChars) {
            const name = String(ht?.name ?? '')
            const lim = maxChars == null ? this.store.setting('fe.chart.pieLabelMaxChars', PIE_LABEL_MAX_CHARS) : maxChars   // IE 2026 09 05 / ODOO-336330
            // lim <= 0 — совсем нет места под имя: оставляем один процент
            const short = lim <= 0 ? ''
                : name.length > lim
                    ? name.slice(0, Math.max(1, lim - 1)).replace(/\s+$/, '') + '…'
                    : name
            const share = this.pieShare(ht?.value)
            if (share == null) return short
            const pct = `${share < 1 ? '<1' : Math.round(share)}%`
            return short ? `${short} ${pct}` : pct
        },
        // IE 2026 09 01 / ODOO-5884: начало кадра — забываем подписи прошлого
        pieLabelsReset() {
            this.pieLabelRects = []
        },
        // IE 2026 09 01 / ODOO-5884: «OverlappingLabels.Auto» для пирога своими руками
        // (у PieDataLabel этой версии wijmo такого свойства нет). Порядок:
        //   1) мелкие доли не подписываем — значение читается в тултипе;
        //   2) имя ужимаем так, чтобы подпись влезла в виджет по своей стороне;
        //   3) прямоугольник подписи (та же арифметика, что в FlexChartBase._renderText)
        //      сдвигаем внутрь виджета, если он упёрся в край (выноска тянется за точкой);
        //   4) налезающую на уже нарисованную подпись — не рисуем (вместе с выноской:
        //      wijmo рисует линию только когда текст не отменён).
        pieLabelRendering(dl, e) {
            const flexPie = this.flexPie
            const ht = e?.hitTestInfo
            if (!flexPie || !e?.point || !e?.engine) return
            const share = this.pieShare(ht?.value)
            if (share != null && share < this.store.setting('fe.chart.pieLabelMinPct', PIE_LABEL_MIN_PCT)) { e.cancel = true; return }   // IE 2026 09 05 / ODOO-336330

            const host = flexPie.hostElement
            const W = host?.clientWidth || 0
            const H = host?.clientHeight || 0
            if (!(W > 0 && H > 0)) return
            // центр пирога контрол знает после отрисовки долек (подписи идут
            // последними); подстраховка — центр виджета
            let c = null
            try { c = flexPie._getCenter && flexPie._getCenter() } catch (err) { c = null }
            if (!c || !isFinite(c.x) || !isFinite(c.y)) c = { x: W / 2, y: H / 2 }

            const pt = e.point
            const ang = Math.atan2(pt.y - c.y, pt.x - c.x) * 180 / Math.PI
            const [halign, valign] = pieLabelAlign(ang)
            // сколько места до края виджета в ту сторону, куда растёт текст
            const room = halign === 0 ? W - pt.x - PIE_LABEL_PAD
                : halign === 2 ? pt.x - PIE_LABEL_PAD
                : 2 * Math.min(pt.x, W - pt.x) - 2 * PIE_LABEL_PAD
            const measure = (t) => e.engine.measureString(t, 'wj-data-label')
            let text = e.text
            let size = measure(text)
            if (size.width > room) {
                // не влезает — бинарным поиском подбираем длину имени
                let lo = this.store.setting('fe.chart.pieLabelMinChars', PIE_LABEL_MIN_CHARS), hi = this.store.setting('fe.chart.pieLabelMaxChars', PIE_LABEL_MAX_CHARS) - 1, best = null   // IE 2026 09 05 / ODOO-336330
                while (lo <= hi) {
                    const mid = (lo + hi) >> 1
                    const t = this.pieLabelContent(ht, mid)
                    const sz = measure(t)
                    if (sz.width <= room) { best = { t, sz }; lo = mid + 1 } else hi = mid - 1
                }
                if (!best) {
                    // даже обрубок имени не влезает — пробуем один процент
                    const only = this.pieLabelContent(ht, 0)
                    const sz = measure(only)
                    if (sz.width > room) { e.cancel = true; return }
                    best = { t: only, sz }
                }
                text = best.t; size = best.sz
                e.text = text
            }
            let left = pt.x - (halign === 1 ? size.width / 2 : halign === 2 ? size.width : 0)
            let top = pt.y - (valign === 1 ? size.height / 2 : valign === 2 ? size.height : 0)
            let dx = 0, dy = 0
            if (left < PIE_LABEL_PAD) dx = PIE_LABEL_PAD - left
            else if (left + size.width > W - PIE_LABEL_PAD) dx = W - PIE_LABEL_PAD - size.width - left
            if (top < PIE_LABEL_PAD) dy = PIE_LABEL_PAD - top
            else if (top + size.height > H - PIE_LABEL_PAD) dy = H - PIE_LABEL_PAD - size.height - top
            if (dx || dy) { pt.x += dx; pt.y += dy; left += dx; top += dy }

            const rect = {
                x1: left - PIE_LABEL_GAP, y1: top - PIE_LABEL_GAP,
                x2: left + size.width + PIE_LABEL_GAP, y2: top + size.height + PIE_LABEL_GAP,
            }
            for (const r of this.pieLabelRects) {
                if (rect.x1 < r.x2 && rect.x2 > r.x1 && rect.y1 < r.y2 && rect.y2 > r.y1) {
                    e.cancel = true
                    return
                }
            }
            this.pieLabelRects.push(rect)
        },
        // тултип дольки: «категория: значение (доля %)»; доля — от суммы модулей,
        // ровно как wijmo меряет дольки (_sums += Math.abs(v))
        pieTooltipContent(hti) {
            const value = hti?.value
            if (value == null || isNaN(value)) return ''
            const pieAttr = this.pieAttr()
            const sum = this.pieAbsSum() // IE 2026 09 01 / ODOO-5884: общий хелпер
            const share = sum > 0 ? ` (${(Math.abs(value) / sum * 100).toFixed(1)}%)` : ''
            const value_text = pieAttr?.attr_type === 'AttrDays'
                ? this.store.formatDaysHTML(value, pieAttr)
                : pieAttr?.attr_type === 'AttrTime'
                    ? this.store.formatTimeHTML(value, pieAttr) // IE 2026 09 10 / ODOO-5800
                    : this.store.formatCount(value)
            const name = hti?.name ?? ''
            return `<b class='tooltip-text'>${name}:</b> <b class='tooltip-text'>${value_text}${share}</b>`
        },
        //---------------------------------
        initializeChart(flex) {
            this.flex = flex
            this.flexPie = null // IE 2026 09 01 / ODOO-5884: вернулись из pie-режима — пирог размонтирован
            // IE 2026 08 20 / ODOO-336291 (mobile UX) (#4195): на телефоне подписи осей скрыты — не резервировать под них поля,
            // график заполняет виджет; тумблер осей возвращает авто-отступы (mobileChartAxes)
            this.mobilePlotMargin(flex)
            this.$watch(() => this.store.mobileChartAxes, (v) => {
                if (v && v.wid === this.WIDGET?.id) this.mobilePlotMargin(flex, v.on)
            })
            // IE 2026 09 13 / ODOO-5800 (заказ Игоря): связанная подсветка серий по странице — сигнал от другого чарта страницы
            this.$watch(() => this.store.chartHoverLink, (v) => this.hoverLinkReceive(v))
            this.uiHelp6_bindPlot(); flex.rendered.addHandler(() => this.uiHelp6_bindPlot())   // U6 (регрессия ie-dm7 #43146, 25.09): карточка «Chart area» — только над пустым местом области построения
            this.content_Changed()
            this.setSelectoinListener()
        },
        mobilePlotMargin(flex, axesOn = false) {
            if (!this.store.mobileUi?.on || !flex) return
            try {
                flex.plotMargin = axesOn ? NaN : '6 6 6 6'
                // IE 2026 09 04 / ODOO-336291 (mobile UX): B-40 chartCompact — при включённых осях раскладка
                // приводится к телефону (иначе plot схлопывается до 122×343 и подписи X идут внахлёст)
                this.mobChartCompact(flex, axesOn)
                flex.invalidate?.()
            } catch (e) { /* тип чарта без plotMargin */ }
        },
        // IE 2026 09 04 / ODOO-336291 (mobile UX): B-40 chartCompact — читаемый график на 390 px.
        // Замер 04.09 (виджет 390 px, оси включены): host 299x482, plot 50x343, легенда справа 124x176,
        // 58 подписей оси X с 57 наложениями, ШЕСТЬ вторичных осей справа с одинаковым заголовком
        // «DOS — days (m = months, y = years)» — они и съедают всю ширину. Правим САМ ЧАРТ (wijmo
        // пересчитывает plotRect), а не CSS: легенда вниз, заголовки осей сняты, из вторичных осей
        // подписи остаются у ПЕРВОЙ (остальные — дубли той же шкалы), подписи X прорежены по факту
        // ширины текста. Оригиналы лежат на контроле (_mobSaved) и возвращаются при выключении.
        // Тот же проход снимает B-41: блокировку на 2–3 с давал getBBox (2501 мс в профиле 04.09)
        // на КАЖДОЙ из 58 налезающих подписей при перерисовке после смены видимости серии.
        // Выкл: window.mobileUi.set('chartCompact', false)
        mobChartCompact(flex, on) {
            if (!this.store.mobileUi?.on || this.store.mobileUi.chartCompact === false || !flex) return
            const axX = flex.axisX, axY = flex.axisY
            // вторичные оси = только те, что стоят СПРАВА (position 3): фильтра «не axisX и не axisY»
            // мало — в коллекции axes лежат и служебные оси слева, и подписи основной Y пропадали
            const extra = (flex.axes || []).filter(a => a && a !== axX && a !== axY && a.position === 3)
            const all = [axX, axY, ...extra].filter(Boolean)
            // снимок делаем В МОМЕНТ ВКЛЮЧЕНИЯ: на initializeChart вторичных осей ещё нет
            // (их добавляет load_data), и снятый тогда снимок нечего было бы возвращать
            if (on && !flex._mobSaved) {
                flex._mobSaved = {
                    legendPos: flex.legend ? flex.legend.position : null,
                    titles: all.map(a => a.title),
                    labels: all.map(a => a.labels),
                    overlap: axX ? axX.overlappingLabels : null,
                    groups: axX ? axX.groupsOptions : null,
                    fmt: axX ? axX.itemFormatter : null,
                }
            }
            const s = flex._mobSaved
            if (!s) return
            if (!on) {
                flex._mobSaved = null
                if (flex.legend && s.legendPos != null) flex.legend.position = s.legendPos
                all.forEach((a, i) => { if (i < s.titles.length) { a.title = s.titles[i]; a.labels = s.labels[i] } })
                if (axX) { axX.overlappingLabels = s.overlap; axX.groupsOptions = s.groups; axX.itemFormatter = s.fmt }
                return
            }
            // легенда снизу: правая легенда 124 px забирает больше трети ширины виджета
            if (flex.legend) flex.legend.position = 4 // Position.Bottom
            // заголовки осей на телефоне не читают, а место стоит ~40 px каждый
            all.forEach(a => { a.title = null })
            // вторичные оси: подписи только у первой, остальные — дубли той же шкалы
            extra.forEach((a, i) => { a.labels = i === 0 ? s.labels[2 + i] !== false : false })
            if (axX) axX.overlappingLabels = 0 // OverlappingLabels.Auto — не рисовать налезающие
            // группы оси (строки недель / месяцев / годов) на 390 px нечитаемы (24-29 подписей в строке
            // внахлёст) и стоят 1007 мс измерений — на телефоне остаётся ОДНА строка подписей с датой
            if (axX) axX.groupsOptions = { display: (AxisGroupsDisplay && AxisGroupsDisplay.None != null) ? AxisGroupsDisplay.None : 0 }
            // соответствие «значение подписи → строка данных»: подпись получает дату (день, месяц, год),
            // иначе после снятия групп остались бы голые номера дней
            const srcMap = new Map()
            const isrc = axX && axX.itemsSource
            if (isrc && isrc.length && this.data && this.data.length === isrc.length) {
                for (let i = 0; i < isrc.length; i++) {
                    const v = isrc[i] && isrc[i].value
                    srcMap.set(v instanceof Date ? v.getTime() : v, this.data[i])
                }
            }
            const dateText = (row) => {
                if (!row) return null
                const m = row.date_Month ? String(row.date_Month).slice(0, 3) : ''
                const y = row.date_Year ? String(row.date_Year).slice(2) : ''
                const d = row.date_Day != null ? row.date_Day : ''
                const t = [d, m, y].filter(x => x !== '' && x != null).join(' ')
                return t || null
            }
            // прореживание по ЗНАЧЕНИЮ подписи (детерминировано: wijmo зовёт форматтер несколько раз
            // за отрисовку — по счётчику вызовов набор подписей от прохода к проходу расходился бы)
            const st = { step: 1 }
            const recalc = () => {
                const pr = flex._plotRect
                const w = (pr && pr.width) || (flex.hostElement && flex.hostElement.clientWidth) || 300
                const maxN = Math.max(3, Math.floor(w / 78)) // 78 px на подпись «1 Mar 26»
                const lo = axX && axX.actualMin, hi = axX && axX.actualMax
                let range = 0
                if (lo != null && hi != null) {
                    const a = lo instanceof Date ? lo.getTime() : lo, b = hi instanceof Date ? hi.getTime() : hi
                    if (isFinite(b - a)) range = Math.abs(b - a)
                }
                if (!range) range = (this.data && this.data.length) || 0
                st.step = range > maxN ? Math.ceil(range / maxN) : 1
            }
            recalc()
            const thin = (engine, label) => {
                if (s.fmt) label = s.fmt(engine, label)
                if (!label) return label
                const v = label.val instanceof Date ? label.val.getTime() : label.val
                const row = srcMap.get(v)
                const t = dateText(row)
                if (t) label.text = t
                // null этой версии wijmo нельзя (Axis._getHeight читает label.text) — гасим текстом
                if (st.step > 1 && typeof v === 'number' && isFinite(v) && (Math.round(v) % st.step) !== 0) label.text = ''
                return label
            }
            thin._mobThin = true
            thin._reset = recalc
            if (axX) axX.itemFormatter = thin
            if (!flex._mobThinHooked) {
                flex._mobThinHooked = true
                // перед проходом отрисовки пересчитываем шаг прореживания по фактической ширине plot
                flex.rendering.addHandler(() => { const f = flex.axisX && flex.axisX.itemFormatter; if (f && f._mobThin) f._reset() })
            }
        },
        // IE 2026 09 04 / ODOO-336291 (mobile UX): B-23 — долгое нажатие по графику (500 мс) = прежний drill-down;
        // короткое — пузырёк со значением. Контекстное меню на время удержания глушим (иначе на Android
        // long-press отдаёт contextmenu и click не приходит).
        mobChartTapInit() {
            if (!this.store.mobileUi?.on) return
            const host = this.$refs.attr_container
            if (!host || host._mobTapHooked) return
            host._mobTapHooked = true
            let timer = null, x0 = 0, y0 = 0
            const clear = () => { if (timer) { clearTimeout(timer); timer = null } }
            host.addEventListener('touchstart', (e) => {
                if (!this.store.mobileUi?.on || this.store.mobileUi.chartTapValues === false) return
                if (e.touches.length !== 1) { clear(); return }
                this._mobLongPress = false
                x0 = e.touches[0].clientX; y0 = e.touches[0].clientY
                clear()
                timer = setTimeout(() => {
                    timer = null
                    this._mobLongPress = true
                    this.mobBubbleHide()
                    if (this.store.mobileUi?.haptics !== false) { try { navigator.vibrate?.(10) } catch (err) { /* нет вибро */ } }
                }, 500)
            }, { passive: true })
            host.addEventListener('touchmove', (e) => {
                if (!timer) return
                const t = e.touches[0]
                if (t && Math.hypot(t.clientX - x0, t.clientY - y0) > 10) clear()
            }, { passive: true })
            for (const n of ['touchend', 'touchcancel']) host.addEventListener(n, clear, { passive: true })
            host.addEventListener('contextmenu', (e) => {
                if (this.store.mobileUi?.on && this.store.mobileUi.chartTapValues !== false) e.preventDefault()
            })
            // IE 2026 09 04 / ODOO-336291 (mobile UX): B-41 — тап по wijmo-легенде открывает ЛИСТ серий (строки 44 px)
            // вместо SVG-пункта 35x14 px; capture на контейнере опережает обработчик самого контрола.
            // Выкл: window.mobileUi.set('chartLegendSheet', false)
            host.addEventListener('click', (e) => {
                if (!this.store.mobileUi?.on || this.store.mobileUi.chartLegendSheet === false) return
                if (!e.target?.closest?.('.wj-legend')) return
                e.stopPropagation(); e.preventDefault()
                this.mobLegendTick++
                this.mobLegendOpen = true
                window.mobTapDone?.('chartLegendSheet') // IE 2026 09 04 / ODOO-336291 (mobile UX): P-31
            }, true)
        },
        // значение точки под пальцем: серия, категория, значение (+ соседние серии той же категории)
        mobShowValue(e) {
            const flex = this.flex
            if (!flex) return false
            let hti = null
            try { hti = flex.hitTest(e) } catch (err) { return false }
            if (!hti || !hti.item) { this.mobBubbleHide(); return false }
            const list = flex.series || []
            const series = hti.series || list[hti.seriesIndex] || null
            const rows = []
            const fmt = (v) => {
                if (v == null || v === '') return ''
                if (typeof v === 'number') return this.store.formatCount ? this.store.formatCount(v) : String(v)
                return String(v)
            }
            const add = (s) => {
                if (!s || !s.binding) return
                if (!(s.visibility === 0 || s.visibility === 1)) return
                const v = hti.item[s.binding]
                if (v == null) return
                rows.push({ name: s.name || s.binding, value: fmt(v),
                    color: legendSeriesColor(list, flex.palette, s, this.attrs_by_binding?.[s.binding]) })
            }
            add(series)
            for (const s of list) { if (s !== series && rows.length < 6) add(s) }
            if (!rows.length) { this.mobBubbleHide(); return false }
            // категория точки: текст оси X (itemsSource) или само значение bindingX
            let category = ''
            try {
                const src = flex.axisX?.itemsSource
                const i = hti.pointIndex
                if (src && src[i]) category = String(src[i].text ?? src[i].value ?? '')
                else if (flex.bindingX) category = fmt(this.store.get_value ? this.store.get_value(hti.item, flex.bindingX) : hti.item[flex.bindingX])
                if (!category && hti.x != null) category = fmt(hti.x)
            } catch (err) { /* без категории — покажем только значения */ }
            const host = this.$refs.attr_container
            const hr = host.getBoundingClientRect()
            const W = 200, H = 42 + rows.length * 20
            let x = (e.clientX ?? hr.left + hr.width / 2) - hr.left + 12
            let y = (e.clientY ?? hr.top + hr.height / 2) - hr.top - H - 12
            x = Math.max(6, Math.min(x, hr.width - W - 6))
            if (y < 6) y = Math.min(hr.height - H - 6, (e.clientY ?? 0) - hr.top + 16)
            y = Math.max(6, y)
            this.mobBubble = { category, rows, x: Math.round(x), y: Math.round(y), item: hti.item }
            this._mobBubbleOff = this._mobBubbleOff || ((ev) => {
                if (!this.mobBubble) return
                const el = this.$refs.attr_container?.querySelector('.chart-tap-bubble')
                if (el && el.contains(ev.target)) return
                this.mobBubbleHide()
            })
            document.addEventListener('pointerdown', this._mobBubbleOff, true)
            return true
        },
        mobBubbleHide() {
            this.mobBubble = null
            if (this._mobBubbleOff) document.removeEventListener('pointerdown', this._mobBubbleOff, true)
        },
        // явный drill-down из пузырька — прежняя команда widget_open (widget-row)
        mobBubbleOpenRow() {
            const item = this.mobBubble?.item
            this.mobBubbleHide()
            if (!item) return
            // IE 2026 09 23 / ODOO-341407: i18n
            const action = { 'tooltip': this.t('Open line'), 'hotKey': 'Alt F2', 'action_name': 'action-front-openLine-2024-11-30', command: 'widget_open', 'widget': 'widget-row', 'source_attr_type': 'AttrChart', 'get_currentRow': true, 'get_Parent': true, 'open_in_children_widget': true, 'cssClass': 'pi p-button-white pi-pencil', source_name: this.attr.name, 'binding': this.attr.binding, attrs: this.attr.attrs }
            action.selectedRow = { iroot: this.store.iroot(item, this.data), dataItem: item, x: 0, y: 0 }
            this.store.executeStoreMethod(this.WIDGET.vueObj, action, this.attr)
            this.tooltip_widget_opened = true
            window.mobTapDone?.('chartOpenRow') // IE 2026 09 04 / ODOO-336291 (mobile UX): P-31
        },
        // IE 2026 09 04 / ODOO-336291 (mobile UX): B-41 — переключение серии из листа: сначала кадр с состоянием
        // ожидания (строка не «молчит» 2–3 с), потом сама смена видимости и штатный seriesVisibilityChanged
        mobLegendToggle(row) {
            if (this.mobLegendBusy) return
            const series = (this.flex?.series || []).find(s => s.binding === row.binding)
            if (!series) return
            this.mobLegendBusy = row.binding
            requestAnimationFrame(() => requestAnimationFrame(() => {
                try {
                    series.visibility = row.on ? 2 : 0 // Legend <-> Visible, как штатный legendToggle
                    this.seriesVisibilityChanged()
                    this.buildLegendGroups()
                } finally {
                    this.mobLegendBusy = null
                    this.mobLegendTick++
                    window.mobTapDone?.('chartSeriesToggle') // IE 2026 09 04 / ODOO-336291 (mobile UX): P-31
                }
            }))
        },
        initializeSelector(flex) {
            this.flexSelector = flex
            // На первой загрузке селектор может инициализироваться после первого
            // рендера основного графика — синхронизируем поля после готовности plotRect.
            this.$nextTick(() => this.syncSelectorMargin(this.flex))
        },
        // Селектор-навигатор хардкодит plotMargin (right=60), а основной график
        // авторазмечает правое поле под вторичную ось Y (≈200px). Из-за этого их
        // области построения рассинхронизированы по горизонтали (постоянно, и сильнее
        // после обновления, когда меняется ширина подписей оси). Подгоняем
        // left/right поля селектора под фактический plotRect основного графика.
        syncSelectorMargin(mainFlex) {
            const sel = this.flexSelector
            if (!sel || !mainFlex) return
            const pr = mainFlex._plotRect || mainFlex.plotRect
            if (!pr || !pr.width) return
            const hostW = (sel.hostElement && sel.hostElement.clientWidth) || mainFlex.hostElement.clientWidth
            if (!hostW) return
            const left = Math.round(pr.left)
            const right = Math.round(hostW - (pr.left + pr.width))
            if (left < 0 || right < 0) return
            const margin = `NaN ${right} NaN ${left}`
            if (sel.plotMargin !== margin) {
                sel.plotMargin = margin
                sel.invalidate()
            }
        },
        initializeRangeSelector(rangeSelector) {
            // Capture the range-selector control so we can reset its thumb window to the
            // full horizon when a (re)load swaps in a different time period (see reload block).
            this.rangeSelectorCtl = rangeSelector
        },
        initializeAnimation(animation){
            this.chartAnimation = animation;
        },
        rangeChanged: function (sender) {
            this.flex.beginUpdate();
            this.flex.axisX.min = sender.min;
            this.flex.axisX.max = sender.max;
            this.flex.endUpdate();
        },
        // IE 2026 09 12 / ODOO-…: формат оси Y нижней области — как у оси группы стека (дни/секунды в месяцах, иначе целые / компактные)
        plotRowAxisY_format(ay, attr) {
            if (attr.attr_type === 'AttrDays') {
                if (attr?.format === 'm') { ay.majorUnit = 30; ay.minorUnit = 30 } else { ay.majorUnit = 1; ay.minorUnit = 1 }
                ay.itemFormatter = (engine, label) => { label.text = this.store.formatDaysHTML(label.val, attr); return label }
            } else if (attr.attr_type === 'AttrTime') {
                this.axisTime_apply(ay, attr, false)
            } else {
                ay.format = attr['axisY-format'] || 'n0'
                if (this.attr['axisY-compact']) {
                    const lang = this.store?.user?.language || 'ru'
                    const nf = new Intl.NumberFormat(lang, { notation: 'compact', maximumFractionDigits: 1 })
                    ay.itemFormatter = (engine, label) => { label.text = nf.format(label.val); return label }
                } else if (attr['axisY-trim']) {
                    // IE 2026 09 25 / ODOO-5800 (Igor: «некрасиво 10,0 и 0,0»): подписи оси ряда без хвостовых нулей — целые без дробной части, дробные
                    // со знаками формата 'axisY-format' («0 · 2,5 · 5 · 7,5 · 10»; Globalize.formatNumber с trim — разделители по культуре, как у 'n1')
                    const f = ay.format
                    ay.itemFormatter = (engine, label) => { label.text = wjcCore.Globalize.formatNumber(label.val, f, true); return label }
                } else if (!attr['axisY-format']) this.axisShort_apply(ay, attr, { spanRef: () => { const m = this.flex?.axisY; return m ? Math.max(Math.abs(m.actualMax ?? 0), Math.abs(m.actualMin ?? 0)) : 0 } })   // IE 2026 09 12 / ODOO-…: единица (K/M) — как у главной оси
            }
        },
        attrResize() {
            if (!this.isVisible) return
            // if (!this.store.hide_console) console.log('attrResize')
            // const elementForm = document.getElementById(`containerResize${this.attr.html_id}`)
            const elementForm = document.getElementById(`WIDGET${this.widget_id}`);
            const elementFlex = document.getElementById(this.attr.html_id); //this.$refs.attr_chart
            let elementFlex_selector = null
            // IE 2026 09 01 / ODOO-5884: в pie-режиме flex нет — селектора у пирога тоже
            if (this.flex && (this.flex.bindingX||'date_parse')=='date_parse') {
                elementFlex_selector = document.getElementById(`${this.attr.html_id}-selector`)
            }
            if (!elementForm || !elementFlex) {
                return
            }
            if (this.attr.height) {
                elementFlex.style.height = `${this.attr.height-60}px`
            } else {
                const elementWidget_Rect = elementForm.getBoundingClientRect()
                const elementFlex_Rect = elementFlex.getBoundingClientRect()
                let elementFlex_selector_Rect = {height:0}
                if (elementFlex_selector) {
                    elementFlex_selector_Rect = elementFlex_selector.getBoundingClientRect()
                }
                if (elementFlex_Rect.height) {
                    let newHeight = Math.floor(elementWidget_Rect.bottom - elementFlex_Rect.top) - 2
                    if (newHeight>200) {
                        newHeight -= elementFlex_selector_Rect.height
                        // this.flex.axisX.labels = true
                        // elementFlex_selector.style.display = ``
                    } else {
                        // newHeight += 25
                        // this.flex.axisX.labels = false
                        // elementFlex.style.padding = `0px`
                        // elementFlex_selector.style.display = `none`
                    }
                    if (this.attr.size) {
                        newHeight = Math.round(newHeight * this.attr.size / 100)
                    }
                    if (newHeight < 150) newHeight = 150
                    if (elementFlex_Rect.height !== newHeight) {
                        if (!this.store.hide_console) console.log('attrResize' +(elementFlex_Rect.height - newHeight))
                        elementFlex.style.height = `${newHeight}px`
                        this.flex?.invalidate()
                        this.flexPie?.invalidate() // IE 2026 09 01 / ODOO-5884: пирог перерисовать под новую высоту
                    }
                }
            }
        },
        onClick(actionMenu) {
            let vueObj = this.WIDGET.vueObj
            vueObj.store.executeStoreMethod(vueObj, actionMenu)
        },

        chartRendering(s, e) {
            // s = flexChart, e.engine = renderEngine
            const engine = e.engine;
            this.hatchDefs_ensure(engine)   // IE 2026 09 23 / ODOO-5800: паттерны штриховки серий (hatch_base) — в <defs> svg до отрисовки серий
            const axX = s.axisX;
            const axY = s.axisY;

            if (!axX || !axY) return;

            // Важно: работать в координатах plotRect
            let pr = s._plotRect || s.plotRect || s._rectChart; // запасной вариант
            if (!pr) return;
            const prAll = pr   // IE 2026 09 23 / ODOO-5800: прямоугольник ВСЕХ рядов областей — для полос drawAlarmZone с rows = 'all'

            // ODOO-4141: с раздельными стеками (PlotArea) _plotRect покрывает ВСЕ панели,
            // и зона «ниже нуля» вместе с drawAlarmZone заливала чужие панели во всю
            // высоту. Зоны относятся к главной оси — ограничиваем их её панелью.
            if (s.plotAreas && s.plotAreas.length) {
                const paMain = (axY && axY.plotArea) || s.plotAreas[0]
                const rectMain = paMain && (paMain._rect || paMain.rect)
                if (rectMain && rectMain.height > 0) {
                    pr = { left: pr.left, width: pr.width, top: rectMain.top, height: rectMain.height }
                }
            }

            const yMin = axY.actualMin;
            const yMax = axY.actualMax;

            // Если ноль не попадает в видимый диапазон — можно не рисовать (или рисовать иначе)
            // Здесь: рисуем, только если диапазон пересекает 0 или уходит ниже 0.
            const hasNegative = (yMin < 0);

            // X-границы в пикселях по plotRect
            const xLeft = pr.left;
            const xRight = pr.left + pr.width;

            // Y-позиция нуля (в пикселях)
            const yZero = axY.convert(0);

            // ---------- (1) Фоновая зона ниже нуля ----------
            // IE 2026 10 29 / ODOO-5800 (ie-dm7 #113853: «Історія змін» v2): ключ attr 'axisY-noNegBand' — без градиентной полосы «ниже нуля» (графики истории: полоса закрывала подпись нижней границы оси)
            if (hasNegative && !this.attr['axisY-noNegBand']) {
                // console.log('draw neg zone yMin=', yMin, 'yMax=', yMax)
                // Нижняя граница зоны — низ plotRect (больший y)
                const yBottom = pr.top + pr.height;

                // Если yZero выше низа, рисуем прямоугольник [yZero..bottom]
                // (в screen coords: y увеличивается вниз)
                const top = Math.max(pr.top, Math.min(yZero, yBottom));
                const h = Math.max(0, yBottom - top);

                if (h > 0) {
                    // класс задаёт fill/opacity
                    engine.drawRect(xLeft, top, pr.width, h, 
                        'neg-zone',
                        {
                            fill: 'l(0,0,0,1)#ffffff-#4DD0E1',      // вертикальный градиент (top→bottom)
                            // stroke: 'none'
                        }
                    );
                }
            }

            // ---------- (2) Усиленная линия нуля ----------
            // Рисуем если 0 в пределах видимого диапазона (или близко к нему).
            const zeroVisible = (yMin < 0 && 0 <= yMax);

            if (zeroVisible) {
                // Небольшая “подстройка” на crispEdges:
                // 0.5 пикселя иногда делает линию резче на svg
                const y = Math.round(yZero) + 0.5;

                const delta = 5; // пикселей от краёв plotRect
                engine.drawLine(xLeft - delta, y, xRight + delta, y, 'zero-line');
            }

            // ---------- (3) Зоны drawAlarmZone — рисуются ПОД графиком ----------
            if (this.attr.drawAlarmZone) {
                const xMin = axX.actualMin.valueOf()
                const xMax = axX.actualMax.valueOf()
                const yRange = yMax - yMin
                for (let zone of this.attr.drawAlarmZone) {
                    let zxMin = zone.xMin, zxMax = zone.xMax
                    if (typeof zxMin === 'string') zxMin = this.dateToIndex(zxMin)
                    if (typeof zxMax === 'string') zxMax = this.dateToIndex(zxMax)
                    // IE 2026 09 23 / ODOO-5800 (Igor: панели чарта друг под другом): полоса через ВСЕ ряды областей (zone.rows = 'all' — месяц ячейки,
                    // месяц провала формы ячейки): по x — осью, по y — от верха первого ряда до низа последнего (_plotRect при нескольких PlotArea
                    // покрывает все панели); прочие полосы, как прежде, — в области главной оси
                    if (zone.rows === 'all' && s.plotAreas && s.plotAreas.length) {
                        const px1 = s.dataToPoint(zxMin ?? xMin, yMin).x, px2 = s.dataToPoint(zxMax ?? xMax, yMin).x
                        if (!isNaN(px1) && !isNaN(px2)) {
                            const st = typeof zone.style === 'string' ? this.store.normalizeStyle(zone.style) : (zone.style ?? '')
                            engine.drawRect(Math.min(px1, px2), prAll.top, Math.abs(px2 - px1), prAll.height, zone.cssClass, st)
                        }
                        continue
                    }
                    let zyMin = zone.yMin, zyMax = zone.yMax
                    if (typeof zyMin === 'string' && zyMin.endsWith('%')) zyMin = yMin + yRange * parseFloat(zyMin) / 100
                    if (typeof zyMax === 'string' && zyMax.endsWith('%')) zyMax = yMin + yRange * parseFloat(zyMax) / 100
                    this.drawAlarmZone(s, e.engine, zxMin ?? xMin, zyMin ?? yMin, zxMax ?? xMax, zyMax ?? yMax, zone.cssClass, zone.style ?? '', zone.marging ?? 0, zone.rx ?? 0, zone.ry ?? 0)
                }
            }
            try { this.planStart_band(s, e.engine, prAll) } catch (err) { this._planStartX = null }   // IE 2026 09 29 / ODOO-343343 (заказ Игоря: начало плана штриховкой)
        },

        // зоны/selection и т.д.
        // IE 2026 09 15 / ODOO-… (замечание Игоря: графики страницы дёргаются несколько кадров): проходы выравнивания нуля осей и
        // общего масштаба областей перерисовывают график по 1–3 раза; на время проходов график прозрачен (opacity, разметка
        // и замеры wijmo не страдают) и показывается один раз — стабильным; страховка — снятие через 600 мс
        chartSettle(on) {
            if (on) { if (!this.settling) this.settling = true; clearTimeout(this._settleT); this._settleT = setTimeout(() => { this.settling = false }, 600) }
            else if (this.settling) { clearTimeout(this._settleT); this.settling = false }
        },
        chartRendered(s, e) {
            if (this.alignSecondaryAxesZero(s)) { this.chartSettle(true); return }   // IE 2026 09 11 / ODOO-5800: оси поправлены — остальное сделает перерисовка
            if (this.plotRowsSameScale(s)) { this.chartSettle(true); return }   // IE 2026 09 12 / ODOO-…: оси областей приведены к одному масштабу — остальное сделает перерисовка
            if (this.axisXMainRow_draw(s, e.engine)) { this.chartSettle(true); return }
            if (this.monthAxis_on() && (this._ieLegPass || 0) < 2 && this.monthAxisMargin_apply()) { this._ieLegPass = (this._ieLegPass || 0) + 1; this.chartSettle(true); return }   // IE 2026 10 29 / ODOO-5800 (ie-dm7 #114070, проба 5): высота легенды стала известна после раскладки — поле под неё, одна-две перерисовки
            this._ieLegPass = 0
            this.monthAxis_draw(s, e.engine)   // IE 2026 10 22 / ODOO-5800: ось месяцев + полоса лет без распорки (ключ axisX-monthAxis)   // IE 2026 09 23 / ODOO-5800: ось X под главным рядом; высота распорки подогнана — перерисовка
            try { this.planStart_flag(s) } catch (err) { /* без флажка */ }   // IE 2026 09 29 / ODOO-343343 (заказ Игоря: начало плана штриховкой)
            this.stackOverlay_draw(s, e.engine)   // IE 2026 09 24 / ODOO-5800: накладки-стеки (stack_on) поверх базовых столбиков
            this.areaBand_draw(s, e.engine)      // IE 2026 09 25 / ODOO-5800: полосы между сериями (area_base / area_top) — зоны запасов формы ячейки
            if (this.attr.chartRendered) {
                let xMin = s.axisX.actualMin.valueOf(),
                    xMax = s.axisX.actualMax.valueOf(),
                    yMax = s.axisY.actualMax;
                if(!isNaN(xMin) && !isNaN(xMax)) {
                    this.drawAlarmZone(s, e.engine, xMin, 0, xMax, yMax, 'green-zone');
                    // this.drawAlarmZone(s, e.engine, xMin, yMin, xMax, 0, 'red-zone');
                }
            }
            this.getSelectionWorkspace_date()
            this.axesCompactLabels(s)   // IE 2026 09 13 / ODOO-5800 (заказ Игоря): компактные оси — деления Y внутрь области
            this.chartSettle(false)   // IE 2026 09 15: стабильная отрисовка — показать
            this.drawnLabels = []
            // Основной график только что пере-разметился (в т.ч. после обновления
            // данных/ресайза) — подгоняем поля селектора под его актуальный plotRect.
            this.syncSelectorMargin(s)
            this.hoverSeriesReapply(s)   // IE 2026 09 26 / ODOO-… (замечание Игоря: выделение серий графика): перерисовка стёрла классы наведения — вернуть
            this.hoverValuesAfterRender()   // IE 2026 09 27 / ODOO-… (заказ Игоря: вариант A наведения на серии): вертикаль и плашка — по новой раскладке
        },

        // IE 2026 09 11 / ODOO-5800 (заказ Игоря): ноль именованных осей Y (правая шкала DOS и т.п.) — на уровне нуля главной оси.
        // Доля главной оси ниже нуля r0 = −min/(max−min) (actualMin/actualMax после отрисовки); именованная ось получает тот же
        // r0: неотрицательные данные — max прежний, min = −r0·max/(1−r0); смешанный знак — общий размах S = max(−dataMin/r0,
        // dataMax/(1−r0)), min = −r0·S. При заданном majorUnit min округляется до кратного ему (с ростом max), чтобы деления
        // проходили через 0. Главная ось без нуля (все значения одного знака) — оси остаются в диапазоне данных.
        // Возвращает true, если оси изменены и запрошена перерисовка (не более трёх проходов на цикл).
        // IE 2026 09 12 / ODOO-… (замечание Игоря): оси Y обеих областей графика — в ОДНОМ масштабе (единиц на пиксель). Ряды PlotArea wijmo делят
        // высоту по звёздным весам без зазоров, plotrect оси = высота ряда, поэтому «высоты ∝ диапазонам осей» = равный масштаб.
        // Нижняя область в заданной пропорции (plot-main-height : axisX_height) получает диапазон R_i = R_main · w_i / w_main;
        // не помещаются её данные — ряд растёт: веса рядов = диапазоны (главный — actualMax−actualMin, нижний — данные,
        // округлённые вверх до «красивого» шага). Отключение: 'axisX-sameScale': false у чарта.
        // IE 2026 09 15 / ODOO-… (замечание Игоря): нижняя область — ПО ВЫСОТЕ СВОИХ ДАННЫХ: веса рядов = диапазоны осей всегда (главный —
        // actualMax−actualMin, нижний — размах данных, округлённый вверх до «красивого» шага с запасом ≥ 5 %), так что самый высокий
        // столбик почти касается верха области, а освободившееся место достаётся главной области; раньше при данных, помещавшихся в
        // заданную пропорцию (2*:1*), ряд держал пропорцию, а ось растягивалась — столбики занимали половину высоты. Пол высоты ряда —
        // 'plot-row-minHeight' чарта (px, 48): ряд ниже пола получает диапазон под долю minPx/H (масштаб общий, столбики ниже края);
        // пустая область — ряд у пола. Заданная пропорция — только первая отрисовка. Выкл (прежнее: пропорция, рост лишь когда данные
        // не помещаются): window.feSettings.set('fe.ux.plotRowFit', false).
        // Возвращает true, если оси/веса изменены и запрошена перерисовка (не более трёх проходов на цикл)
        plotRowsSameScale(flex) {
            const rows = this._plotRows
            if (!flex || !flex.axisY || !rows || !Object.keys(rows).length || this.attr?.['axisX-sameScale'] === false) return false
            const main = flex.axisY, pa0 = this._plotRowsMain
            const R1 = (main.actualMax ?? NaN) - (main.actualMin ?? NaN)
            if (!pa0 || !isFinite(R1) || R1 <= 0) return false
            const star = (h) => { const s = String(h ?? '1*'); return s.endsWith('*') ? (parseFloat(s) || 1) : NaN }
            const w1cfg = star(this._plotRowsMainH)
            const items = (this.data && this.data.length) ? this.data : (flex.collectionView?.items || [])   // chart_data сборки (itemsSource ставится позже)
            const stacked = flex.stacking === 1 || flex.stacking === 2
            const eq = (a, b) => Math.abs((a ?? NaN) - b) <= 1e-6 * Math.max(1, Math.abs(b))
            const fit = this.plotRowFitOn()   // IE 2026 09 15 / ODOO-… (замечание Игоря): область по высоте своих данных
            const minPx = fit ? (Math.max(0, +(this.attr?.['plot-row-minHeight'] ?? 48)) || 0) : 0   // IE 2026 09 15 / ODOO-…: пол высоты ряда, px
            const H = fit ? ((main._plotrect?.height || 0) + Object.values(rows).reduce((s, r) => s + (r?.ay?._plotrect?.height || 0), 0)) : 0   // IE 2026 09 15 / ODOO-…: высота всех рядов (после отрисовки)
            const plan = []
            let grow = false
            for (const [rowKey, r] of Object.entries(rows)) {
                if (!r || !r.pa || !r.ay) continue
                // серии области — по метке оси (x.axisY приходит прокси-обёрткой, === с raw-осью ложно)
                const srs = (flex.series || []).filter(x => x && x.binding && x.axisY && x.axisY._plotRowKey === rowKey && x.visibility !== 2 && x.visibility !== 3)
                let lo = 0, hi = 0
                for (const it of items) {
                    let pos = 0, neg = 0
                    for (const x of srs) {
                        const v = +it?.[x.binding]
                        if (!isFinite(v)) continue
                        if (stacked) { if (v > 0) pos += v; else neg += v } else { if (v > hi) hi = v; if (v < lo) lo = v }
                    }
                    if (stacked) { if (pos > hi) hi = pos; if (neg < lo) lo = neg }
                }
                const need = hi - lo
                if (fit) {   // IE 2026 09 15 / ODOO-… (замечание Игоря): вес ряда = размах данных с запасом ≥ 5 % до «красивого» шага; пустая область — 5 % главного диапазона (до пола)
                    const step = this.niceStep((need > 0 ? need : R1) / 8)
                    const max = hi > 0 ? Math.ceil((hi + need * 0.05) / step) * step : 0
                    const min = lo < 0 ? Math.floor((lo - need * 0.05) / step) * step : 0
                    plan.push({ r, min, max: max > min ? max : min + R1 * 0.05 }); grow = true
                    continue
                }
                const wcfg = star(r.cfgH)
                let Rcfg = NaN
                if (isFinite(w1cfg) && isFinite(wcfg)) Rcfg = R1 * wcfg / w1cfg
                else { const h1 = main._plotrect?.height, h2 = r.ay._plotrect?.height; if (h1 > 0 && h2 > 0) Rcfg = R1 * h2 / h1 }
                if (!isFinite(Rcfg) || Rcfg <= 0) continue
                if (need <= Rcfg) plan.push({ r, min: lo, max: lo + Rcfg })
                else {
                    const step = this.niceStep(need / 4)
                    const max = Math.ceil(hi / step) * step, min = lo < 0 ? Math.floor(lo / step) * step : 0
                    plan.push({ r, min, max }); grow = true
                }
            }
            if (!plan.length) return false
            // IE 2026 09 15 / ODOO-… (замечание Игоря): пол высоты ряда — ряд ниже minPx получает диапазон, при котором его доля высоты
            // равна minPx / H (веса остальных прежние); масштаб остаётся общим, столбики просто ниже верхнего края
            if (fit && minPx > 0 && H > minPx * (plan.length + 1)) {
                for (const p of plan) {
                    const others = R1 + plan.reduce((s, q) => s + (q === p ? 0 : q.max - q.min), 0)
                    const w = p.max - p.min
                    if (H * w / (w + others) < minPx) p.max = p.min + minPx * others / (H - minPx)
                }
            }
            let changed = false
            const sameStar = (cur, w) => { const s = String(cur ?? ''); return s.endsWith('*') && eq(parseFloat(s), w) }   // IE 2026 09 15 / ODOO-…: вес сравнивать числом, не строкой
            for (const p of plan) {
                if (!eq(p.r.ay.min, p.min)) { p.r.ay.min = p.min; changed = true }
                if (!eq(p.r.ay.max, p.max)) { p.r.ay.max = p.max; changed = true }
                if (grow) { const w = p.max - p.min; if (!sameStar(p.r.pa.height, w)) { p.r.pa.height = w + '*'; changed = true } }   // IE 2026 09 15 / ODOO-…
                else if (String(p.r.pa.height) !== String(p.r.cfgH)) { p.r.pa.height = p.r.cfgH; changed = true }
            }
            if (grow) { if (!sameStar(pa0.height, R1)) { pa0.height = R1 + '*'; changed = true } }   // IE 2026 09 15 / ODOO-…
            else if (String(pa0.height) !== String(this._plotRowsMainH)) { pa0.height = this._plotRowsMainH; changed = true }
            if (changed) {
                this._sameScalePasses = (this._sameScalePasses || 0) + 1
                if (this._sameScalePasses <= 3) { flex.invalidate(); return true }
            } else this._sameScalePasses = 0
            return false
        },
        // IE 2026 10 01 / ODOO-5800 (Igor: «в продолжении не нужно показывать непокрытые запасы, если их нет … если непокрытые движения закрылись, то далее
        // не показываем кривую непокрытых запасов»): «Stock uncovered» (<binding_stock>_uncovered, у разреза — <…>_uncovered::<значение>) — только до последней
        // даты с непокрытыми движениями (<binding_in>_uncovered / <binding_out>_uncovered того же значения разреза, нет таких колонок — без разреза) плюс
        // точка-связка следующей даты (запас на начало несёт итог этих движений). Колонки прихода uncovered в данных может не быть (585_001: IN uncovered
        // use = false — в строках чарта только OUT_uncovered), поэтому движение месяца t узнаётся ещё и по смене разрыва «Stock uncovered» − «Stock» между
        // t и t + 1 (разрыв = накопленные непокрытые приходы − расходы; его гашение движком при покрытии — тоже смена). Дальше значения в строках чарта гасятся (null — линия обрывается, ось
        // и подсказка их не видят); непокрытых движений нет вовсе — серия пустая и легенда её не показывает (chartLegend: hasAnyValue). Исходные значения —
        // в this._uncCutOrig (WeakMap строка → {ключ: значение}) и возвращаются в начале каждого прогона: повторный load_data на тех же строках и
        // выключение флага дают прежнее. Нет ни колонок непокрытых движений, ни колонки Stock — не судим (как прежде). Тот же флаг и правило — у графика формы ячейки
        // (cellChart.uncLineCut). Выкл: window.feSettings.set('fe.ux.uncovCurveOnlyWhileOpen', false)
        uncovCurveCut(rows, attrs, binding_stock, binding_in, binding_out) {
            if (!Array.isArray(rows)) return
            const orig = this._uncCutOrig
            if (orig) for (const r of rows) { const o = r && orig.get(r); if (o) { Object.assign(r, o); orig.delete(r) } }
            let on = true
            try { on = this.store?.setting?.('fe.ux.uncovCurveOnlyWhileOpen', true) !== false } catch (e) { on = true }
            if (!on || !rows.length) return
            const sb = (binding_stock || 'open_balance') + '_uncovered'
            const moveKeys = (sfx) => [(binding_in || 'IN') + '_uncovered' + sfx, (binding_out || 'OUT') + '_uncovered' + sfx]
            const present = (keys) => keys.filter(k => rows.some(r => r && r[k] !== undefined))
            const sk = binding_stock || 'open_balance', n0 = (v) => { const x = Number(v); return (v == null || v === '' || !Number.isFinite(x)) ? 0 : x }
            for (const a of attrs || []) {
                const b = a && a.binding
                if (typeof b !== 'string' || !(b === sb || b.startsWith(sb + '::'))) continue
                const sfx = b.slice(sb.length)
                let mk = present(moveKeys(sfx))
                if (!mk.length) mk = present(moveKeys(''))
                const stk = sk + sfx
                const gapOk = rows.some(r => r && r[stk] !== undefined)
                if (!mk.length && !gapOk) continue
                let last = -1
                rows.forEach((r, i) => { if (r && mk.some(k => { const v = Number(r[k]); return Number.isFinite(v) && v !== 0 })) last = i })
                if (gapOk) for (let i = 1; i < rows.length; i++) {
                    const p = rows[i - 1], r = rows[i]
                    if (p && r && Math.abs((n0(r[b]) - n0(r[stk])) - (n0(p[b]) - n0(p[stk]))) > 0.5) last = Math.max(last, i - 1)
                }
                if (!this._uncCutOrig) this._uncCutOrig = new WeakMap()
                rows.forEach((r, i) => {
                    if (!r || (last >= 0 && i <= last + 1) || r[b] == null) return   // IE 2026 10 01 / ODOO-5800: last = -1 (нет непокрытых движений) — гасится вся серия, первая точка не остаётся «связкой»
                    const o = this._uncCutOrig.get(r) || {}
                    if (!(b in o)) o[b] = r[b]
                    this._uncCutOrig.set(r, o)
                    r[b] = null
                })
            }
        },
        // IE 2026 09 15 / ODOO-… (замечание Игоря): нижняя область графика по высоте своих данных (default ON). Выкл: window.feSettings.set('fe.ux.plotRowFit', false)
        plotRowFitOn() { try { return this.store?.setting?.('fe.ux.plotRowFit', true) !== false } catch (e) { return true } },
        // IE 2026 09 12 / ODOO-…: «красивый» шаг шкалы (1 / 2 / 2.5 / 5 × 10^k), не меньше x
        niceStep(x) {
            if (!(x > 0) || !isFinite(x)) return 1
            const p = Math.pow(10, Math.floor(Math.log10(x))), f = x / p
            return (f <= 1 ? 1 : f <= 2 ? 2 : f <= 2.5 ? 2.5 : f <= 5 ? 5 : 10) * p
        },
        // IE 2026 09 13 / ODOO-5800 (замечание Игоря): диапазон оси Y по данным её серий — вынесен из load_data, чтобы пересчитывать
        // при переключении видимости серий. Скрытая серия (chart_hidden / выключена в легенде) диапазон НЕ тянет: у чарта
        // Узбекистана ось уходила до −35 000 из-за спрятанной «Stock uncovered». ctx: isStockChart, binding_stock/in/out, woOf,
        // stack2, shown(attr) — показана ли серия, shownOnly — флаг режима. Выкл: window.feSettings.set('fe.ux.chartAxisRangeShown', false)
        axisRangeCompute(attr, attrs, chart_data, ctx) {
            let min = Infinity;
            let max = -Infinity;
            const { isStockChart, binding_stock, binding_in, binding_out, woOf, stack2, shown } = ctx

            for (let attr2 of attrs) {
                if ((attr2.axisY||'') === (attr.axisY||'') && !attr2.axisX) {   // IE 2026 09 12 / ODOO-…: нижняя область — своя ось
                    if (!shown(attr2)) continue   // IE 2026 09 13 / ODOO-5800 (замечание Игоря): скрытая серия диапазон оси не тянет
                    for (let j = 0; j < chart_data.length; j++) {
                        let v = chart_data[j][attr2.binding];
                        if (isStockChart && attr2.binding === binding_stock) {
                            const v1 = (v || 0) + (chart_data[j][binding_in] || 0) // - (chart_data[j][binding_out] || 0)
                            if (v1 < min) min = v1;
                            if (v1 > max) max = v1;

                            const v2 = (v || 0) + (chart_data[j][binding_in] || 0) - (chart_data[j][binding_out] || 0) - woOf(chart_data[j])   // IE 2026 09 11 / ODOO-5800
                            if (v2 < min) {
                                min = v2;
                            }
                            if (v2 > max) max = v2;
                        }
                        // chart_down: серия рисуется производным
                        // __down-ключом (отрицательные) — без него
                        // ось получала min>=0 и стек вниз обрезался.
                        // Исходное (положительное) значение в расчёт оси
                        // НЕ идёт: на этой высоте серия не рисуется, а max
                        // от неё раздувался (ODOO-4646)
                        // (в режимах B/C зеркала нет — мера идёт обычной
                        // веткой ниже, она рисуется ВВЕРХ своим значением)
                        if (attr2['chart_down'] && stack2 === 'down') {
                            const vd = chart_data[j][attr2.binding + '__down'];
                            if (vd != null && !isNaN(vd)) {
                                if (vd < min) min = vd;
                                if (vd > max) max = vd;
                            }
                            continue;
                        }
                        if (v == null || isNaN(v)) continue;

                        if (v < min) min = v;
                        if (v > max) max = v;
                    }
                }
            }

            // fallback, если данных нет
            if (min === Infinity || max === -Infinity) {
                min = 0;
                max = 0;
            }

            // For stacked series the axis max must cover the sum of all stacked values per row
            // ODOO-4646: в режимах B/C меры второго стека в ОСНОВНОЙ стек не
            // входят (рисуются своей колонкой) — их сумму считаем отдельно ниже
            const stackedAttrsOnAxis = attrs.filter(a => (a.axisY||'') === (attr.axisY||'') && a.stacked && !a.axisX   // IE 2026 09 12 / ODOO-…
                && !(a['chart_down'] && stack2 !== 'down') && shown(a))   // IE 2026 09 13 / ODOO-5800
            if (stackedAttrsOnAxis.length > 1) {
                for (let j = 0; j < chart_data.length; j++) {
                    let positiveSum = 0, negativeSum = 0
                    for (let a of stackedAttrsOnAxis) {
                        // ODOO-4646: chart_down-серия стоит в стеке ВНИЗ —
                        // складывать надо её отрисованное (__down) значение.
                        // По исходному ключу расход попадал в positiveSum:
                        // верх оси раздувался на сумму OUT, а низ не набирался
                        // вовсе (одиночный минимум вместо суммы стека вниз).
                        const v = a['chart_down']
                            ? chart_data[j][a.binding + '__down']
                            : chart_data[j][a.binding]
                        if (v == null || isNaN(v)) continue
                        if (v > 0) positiveSum += v
                        else negativeSum += v
                    }
                    if (positiveSum > max) max = positiveSum
                    if (negativeSum < min) min = negativeSum
                }
            }

            // ODOO-4646 (B/C): второй стек рисуется ВВЕРХ от нуля своей
            // колонкой — в ось должна влезать его сумма по строке, иначе
            // колонка уезжает за пределы области (та же ошибка, что была
            // у стека вниз в варианте A)
            if (stack2 !== 'down') {
                const stack2Attrs = attrs.filter(a => (a.axisY||'') === (attr.axisY||'') && a['chart_down'] && !a.axisX && shown(a))   // IE 2026 09 12 / ODOO-…, IE 2026 09 13 / ODOO-5800
                for (let j = 0; j < chart_data.length && stack2Attrs.length; j++) {
                    let sum2 = 0
                    for (let a of stack2Attrs) {
                        const v = chart_data[j][a.binding]
                        if (v == null || isNaN(v)) continue
                        sum2 += v
                    }
                    if (sum2 > max) max = sum2
                    if (sum2 < min) min = sum2
                }
            }

            // “воздух” по краям
            // IE 2026 09 13 / ODOO-5800 (замечание Игоря): все значения нули (нет данных у серий) — шкала 0…1, а не 0…0,05
            if (max === 0 && min === 0 && ctx.shownOnly) max = 1
            const pad = (max - min) || Math.abs(max) || 1;

            let axMin = min - (min < 0 ? pad * 0.05 : 0);
            let axMax = max + pad * 0.05;

            // Якорить вторичную ось (напр. Qty) в 0, когда все её
            // значения неотрицательны — бары остаются пропорциональны и
            // низкие значения видны (конвенция столбчатых графиков).
            // Прежняя логика выравнивала ноль secondary по нулю main axisY,
            // что при main min > 0 (нуля на экране нет) выдавливало min
            // secondary в плюс и обрезало низкие бары.
            if (min >= 0) {
                axMin = 0;
            }
            return { min: axMin, max: axMax, nonneg: min >= 0 }

        },
        axisRangeShownOnly() {
            try { return this.store?.setting?.('fe.ux.chartAxisRangeShown', true) !== false } catch (e) { return true }
        },
        chartEmptyShown() {
            if (this.isPieMode() || !this.chartEmpty) return false
            try { return this.store?.setting?.('fe.ux.chartEmptyMessage', true) !== false } catch (e) { return true }
        },
        chartEmptyText() { return this.chartEmpty === 'zero' ? this.t('All values are zero for the current filters') : this.t('No data for the current filters') },   // IE 2026 09 23 / ODOO-341407: i18n
        // все показываемые меры (не chart_hidden, включённые) во всех строках — 0 / пусто
        chartAllZero(rows, attrs) {
            const ms = (attrs || []).filter(a => a && (a.attr_type === 'AttrNumber' || a.attr_type === 'AttrDays' || a.attr_type === 'AttrTime')
                && !a.chart_hidden && !a.chartGroup && a.use !== false && a.binding !== this.attr?.axisX_bindingX2)
            if (!rows.length) return false
            if (!ms.length) {
                // IE 2026 09 14 / ODOO-5800: разрезные серии (series_dimension) с нулевыми значениями бэк отбрасывает целиком
                // (widgets.py: filtered по max/min) — строки есть, серий нет: это «все нули», а не «нет данных» и не тишина
                const hasSplit = (nodes) => (nodes || []).some(n => n && typeof n === 'object' && ((n.use !== false && n.series_dimension && !n.chart_hidden) || hasSplit(n.attrs)))
                return hasSplit(this.WIDGET?.record?.doc?.viewList)
            }
            for (const r of rows) for (const a of ms) { const v = r?.[a.binding]; if (v !== null && v !== undefined && v !== '' && +v !== 0 && !isNaN(+v)) return false }
            return true
        },
        // IE 2026 09 13 / ODOO-5800 (заказ Игоря): опция чарта 'axes-compact' (панель настроек → Axes: Compact) — вся площадь виджета
        // под график: подписи оси X только годы (полоса лет, месяцы пустые), оси Y без заголовков, их деления — ВНУТРИ области у
        // линии оси (wijmo рисует подписи снаружи, plotMargin оставляет им нет места — после отрисовки они переносятся внутрь,
        // axesCompactLabels); теги наведения — тоже внутри (значение Y справа от левой оси / слева от правой, дата над осью X).
        // На телефоне действует свой режим (mobilePlotMargin / mobChartCompact) — опция там не применяется.
        // IE 2026 09 15 / ODOO-… (заказ Игоря): «Compact» отдельно у оси X (кнопка в ряду Axis X position: только годы, дата наведения внутри)
        // и у осей Y (ряд Axis Y position: без заголовков, деления и значение наведения внутри); прежний общий флаг axes-compact — запасной.
        // Ключи compact-axisX / compact-axisY — «axisY-compact» уже занят сокращением чисел на оси Y
        axesCompactX() { if (this.store?.mobileUi?.on) return false; const v = this.attr?.['compact-axisX']; return (v !== undefined && v !== null) ? !!v : !!this.attr?.['axes-compact'] },
        axesCompactY() { if (this.store?.mobileUi?.on) return false; const v = this.attr?.['compact-axisY']; return (v !== undefined && v !== null) ? !!v : !!this.attr?.['axes-compact'] },
        axesCompactOn() { return this.axesCompactX() || this.axesCompactY() },
        // Поля под подписи wijmo считает по ИЗМЕРЕННОМУ тексту подписей (Axis._getHeight → itemFormatter с engine.readOnly = true);
        // plotMargin при нескольких областях графика (нижний ряд) он игнорирует вовсе (_layoutMultiple). Поэтому в компактном
        // режиме форматтер оси Y отдаёт пустой текст на измерении и настоящий — на отрисовке: поле под ось = деление + отступ,
        // а подписи (нарисованные снаружи, в это поле не помещающиеся) переносятся внутрь после отрисовки (axesCompactLabels).
        axesCompactApply() {
            const flex = this.flex
            if (!flex || this.store?.mobileUi?.on) return
            const on = this.axesCompactY(), onX = this.axesCompactX()   // IE 2026 09 15: Y и X — отдельно
            for (const a of [flex.axisY, ...(toRaw(flex).axes || [])]) {
                if (!a || a.axisType === 0) continue   // AxisType.X — подписи X пустые с load_data
                const prev = a.itemFormatter
                const base = (prev && prev._ieCompact) ? prev._iePrev : prev
                if (on) {
                    if (a.title) a.title = ''
                    const f = (engine, label) => {
                        if (base) label = base(engine, label) || label
                        if (engine && engine.readOnly) label.text = ''   // измерение → поля без места под подписи
                        return label
                    }
                    f._ieCompact = true; f._iePrev = base
                    a.itemFormatter = f
                } else if (prev && prev._ieCompact) {
                    a.itemFormatter = base || null
                }
                // IE 2026 09 14 / ODOO-5800 (заказ Игоря): в компактном режиме область графика прижата к краям виджета —
                // поле под ось Y (Axis._getHeight: 2×labelPadding + ширина подписи + 6 + деление ≈ 16–20 px даже при пустых
                // подписях) урезается до места под линию оси и деления; подписи всё равно переносятся внутрь (axesCompactLabels).
                // Действует и при одной области графика (_layoutSingle), и с нижним рядом (_layoutMultiple, где plotMargin
                // игнорируется). Выкл: window.feSettings.set('fe.ux.chartCompactTight', false)
                const prevH = a._getHeight
                const baseH = (prevH && prevH._ieCompact) ? prevH._iePrev : prevH
                if (on && this.axesCompactTightOn() && typeof baseH === 'function') {
                    const h = function (engine, maxw) { return Math.min(baseH.call(this, engine, maxw), 5) }
                    h._ieCompact = true; h._iePrev = baseH; h._ieOwn = Object.prototype.hasOwnProperty.call(a, '_getHeight') && !(prevH && prevH._ieCompact)
                    a._getHeight = h
                } else if (prevH && prevH._ieCompact) {
                    if (prevH._ieOwn) a._getHeight = baseH
                    else delete a._getHeight   // назад к методу прототипа
                }
            }
            // IE 2026 09 14 / ODOO-5800 (заказ Игоря): компактная полоса лет под осью X — от оси до края виджета чуть больше
            // высоты текста года. У wijmo ось X = 2×labelPadding + высота (пустых) подписей + деления, ниже группы (_AxisGroups:
            // поле 8 + текст + поле 8, скобки «└─2025─┘»). В компактном режиме: labelPadding 0, поля групп 1 px, вместо скобок —
            // вертикальные границы годов от делений до низа текста (renderLinesX группы). Тот же выключатель fe.ux.chartCompactTight
            const COMPACT_GROUP_GAP = 3   // IE 2026 09 14 / ODOO-5800: зазор над и под текстом года в компактной полосе
            const compactGroupLines = function (engine, axis, i) {
                const top = axis._axrect ? axis._axrect.top + 1 : i - this.height   // IE 2026 09 14: от линии оси
                const xs = new Set()
                if (this.labels.length) xs.add(axis.convert(this.labels[0].start))
                for (const l of this.labels) xs.add(axis.convert(l.end))
                for (const x of xs) this.drawLine(engine, x, top, x, i)
            }
            for (const a of [flex.axisX, ...(toRaw(flex).axes || [])]) {
                if (!a || a.axisType !== 0) continue
                const prevH = a._getHeight
                const baseH = (prevH && prevH._ieCompact) ? prevH._iePrev : prevH
                if (onX && this.axesCompactTightOn() && typeof baseH === 'function') {
                    if (a._ieLabelPadding === undefined) a._ieLabelPadding = a.labelPadding
                    a.labelPadding = 0
                    const h = function (engine, maxw) {
                        if (!this._groupsPanel && wjChart._AxisGroups && this.groupsOptions && this.groupsOptions.display !== AxisGroupsDisplay.None) this._groupsPanel = new wjChart._AxisGroups(this)
                        if (this._groupsPanel) this._groupsPanel._margin = COMPACT_GROUP_GAP
                        let v = baseH.call(this, engine, maxw)
                        const groups = (this._groupsPanel && this._groupsPanel.groups) || []
                        for (const g of groups) g.renderLinesX = compactGroupLines
                        // IE 2026 09 14 / ODOO-5800 (замечание Игоря): полоса лет = высота текста года + зазор сверху и снизу.
                        // Базовая высота держит ещё ряд пустых подписей оси (14 px): срезаем его, когда подписей нет (annoSize.width 0)
                        if (groups.length && this._annoSize && !(this._annoSize.width > 0)) {
                            const text = groups.reduce((s, g) => s + (g.height || 0), 0)
                            if (text > 0) v = text + 2 * COMPACT_GROUP_GAP + (this._szTitle ? this._szTitle.height : 0)
                        }
                        return v
                    }
                    h._ieCompact = true; h._iePrev = baseH; h._ieOwn = Object.prototype.hasOwnProperty.call(a, '_getHeight') && !(prevH && prevH._ieCompact)
                    a._getHeight = h
                } else if (prevH && prevH._ieCompact) {
                    if (prevH._ieOwn) a._getHeight = baseH
                    else delete a._getHeight
                    if (a._ieLabelPadding !== undefined) { a.labelPadding = a._ieLabelPadding; delete a._ieLabelPadding }
                    if (a._groupsPanel) { a._groupsPanel._margin = 8; for (const g of (a._groupsPanel.groups || [])) delete g.renderLinesX }
                }
            }
            flex._ieAxesCompact = on || onX
        },
        axesCompactTightOn() {
            try { return this.store?.setting?.('fe.ux.chartCompactTight', true) !== false } catch (e) { return true }
        },
        axesCompactLabels(flex) {
            const host = flex?.hostElement
            const pr = flex?._plotRect || flex?.plotRect
            if (!host || !pr || !this.axesCompactY()) return
            for (const t of host.querySelectorAll('.wj-axis-y text')) {
                const x = parseFloat(t.getAttribute('x'))
                if (!Number.isFinite(x)) continue
                if (x <= pr.left + 1) { t.setAttribute('x', String(pr.left + 4)); t.setAttribute('text-anchor', 'start'); t.style.textAnchor = 'start'; t.classList.add('chart-axis-inside') }
                else if (x >= pr.right - 1) { t.setAttribute('x', String(pr.right - 4)); t.setAttribute('text-anchor', 'end'); t.style.textAnchor = 'end'; t.classList.add('chart-axis-inside') }
            }
        },
        // ---- IE 2026 09 23 / ODOO-5800 (Igor, форма ячейки: «uncovered — тот же цвет, что у базовой серии, с красной штриховкой») ----
        // Штриховка серии: у поля ключ hatch_base = binding базовой серии этого же списка (и hatch_color, по умолчанию красный). Заливка серии —
        // SVG-паттерн url(#id) (wijmo отдаёт fill в атрибут как есть): квадрат 7×7 цвета базовой заливки + линия штриховки, повёрнут на 45°.
        // Паттерны живут в <defs> svg чарта — движок wijmo переносит один и тот же узел <defs> из отрисовки в отрисовку (beginRender), поэтому
        // паттерн заводится / обновляется в обработчике rendering (до серий); url(#…) разрешается лениво. Внутри паттерна — служебный
        // <stop stop-color="url(#id)">: панель легенды (ChartLegendPanel.actualColor) цвет заливки url(#…) читает по первому <stop> — и получает
        // тот же паттерн для своего свотча (одна HTML-страница: ссылка url(#id) действует и из другого inline-svg). Выкл: fe.ux.chartHatch = false
        chartHatchOn() { try { return this.store?.setting?.('fe.ux.chartHatch', true) !== false } catch (e) { return true } },
        hatchId(binding) { return 'hatch-' + String(`${this.WIDGET?.id ?? ''}-${this.attr?.id ?? ''}-${binding}`).replace(/[^A-Za-z0-9_-]/g, '_') },
        // IE 2026 09 29 / ODOO-343343 (заказ Игоря: начало плана штриховкой) (заказ Игоря: начало плана штриховкой): полоса шириной разрыва таблицы (15 px) на границе последнего периода факта и первого периода
        // плана (середина между точками), под сериями, через все области; дата — attr.plan_start (бэк: params.date_fact_stock виджета / стола).
        // Только графики с осью дат. Выключатель fe.ux.planStartMark (по умолчанию вкл). Счётчики — window.__planStart
        planStart_stat() {
            if (!window.__planStart) window.__planStart = { cols: 0, charts: 0, refused: 0, reason: '', colIds: {}, chartIds: {} }
            return window.__planStart
        },
        planStart_color() {
            let c = ''
            try { c = getComputedStyle(document.body).getPropertyValue('--plan-start-color').trim() } catch (e) { /* без стилей */ }
            return c || '#7b1fa2'
        },
        planStart_band(flex, engine, pr) {
            this._planStartX = null
            const st = this.planStart_stat(), no = (why) => { st.refused++; st.reason = why; return false }
            if (this.store.setting('fe.ux.planStartMark', true) === false) return no('off (fe.ux.planStartMark)')
            const day = String(this.attr.plan_start || '').slice(0, 10)
            if (!day) return no('no plan_start in the chart data')
            const bx = flex.bindingX
            if (bx !== 'date_parse' && bx !== 'date') return no('no date axis')
            const data = this.data
            if (!data || !data.length || !flex.axisY || !pr) return no('no data')
            const dstr = (v) => typeof v === 'string' ? v.slice(0, 10) : (v instanceof Date && !isNaN(v) ? v.toISOString().slice(0, 10) : String(v || '').slice(0, 10))
            const i = data.findIndex(d => dstr(d.date) >= day)
            if (i < 0) return no('plan start is beyond the chart horizon')
            if (i === 0) return no('plan start is before the first period')
            const yMin = flex.axisY.actualMin
            const x0 = flex.dataToPoint(this.dataIndexToDate(i - 1), yMin).x, x1 = flex.dataToPoint(this.dataIndexToDate(i), yMin).x
            const xb = (x0 + x1) / 2
            if (isNaN(xb)) return no('axis not ready')
            const color = this.planStart_color(), W = 15
            const defs = (engine && engine._defs) || flex.hostElement?.querySelector('svg > defs')
            if (!defs) return no('no svg defs')
            const NS = 'http://www.w3.org/2000/svg', pid = `plan-start-hatch-${this.widget_id || 'x'}`
            let p = defs.querySelector(`[id="${pid}"]`)
            if (!p) {
                p = document.createElementNS(NS, 'pattern')
                p.setAttribute('id', pid); p.setAttribute('patternUnits', 'userSpaceOnUse'); p.setAttribute('width', '7'); p.setAttribute('height', '7'); p.setAttribute('patternTransform', 'rotate(45)')
                const l = document.createElementNS(NS, 'line'); l.setAttribute('x1', '6'); l.setAttribute('y1', '0'); l.setAttribute('x2', '6'); l.setAttribute('y2', '7'); l.setAttribute('stroke-width', '2')   // IE 2026 09 30 / ODOO-343343 (заказ Игоря: элемент Plan start одинаковый во всех формах): штрих в середине плитки (x = шаг − толщина/2), а не на её краю — край обрезал штрих вдвое (измерено по пикселям: доля краски 0.144 против 0.288 у таблицы)
                p.appendChild(l); defs.appendChild(p)
            }
            { const old = p.querySelector('rect'); if (old) old.remove() }   // IE 2026 09 30 / ODOO-343343 (заказ Игоря: элемент Plan start одинаковый во всех формах): подложка штрихов — белая рамка капсулы, а не тонированный фон
            { const ln = p.querySelector('line'); ln.setAttribute('stroke', color); ln.setAttribute('x1', '6'); ln.setAttribute('x2', '6') }   // IE 2026 09 30 / ODOO-343343 (заказ Игоря: элемент Plan start одинаковый во всех формах): и у ранее созданного паттерна
            // капсула как у таблицы (src/utils/planStartCapsule.js): рамка 1 px + радиус 4 + белая подложка, штрихи с отступом 2 px, сверху зона флажка (сам флажок и глухая шапка — planStart_flag поверх серий)
            const cx = xb - PS.W / 2, HD = PS.FRAME + PS.HEAD
            const fr = engine.drawRect(cx + PS.FRAME / 2, pr.top + PS.FRAME / 2, PS.W - PS.FRAME, Math.max(0, pr.height - PS.FRAME), 'plan-start-band', { fill: planStartGround(), stroke: planStartFrame(color) })   // IE 2026 10 02 / ODOO-343343 (заказ Игоря: внутренность полосы — цветом бордюра)
            if (fr && fr.setAttribute) { fr.setAttribute('rx', PS.RADIUS); fr.setAttribute('ry', PS.RADIUS); fr.setAttribute('stroke-width', PS.FRAME); fr.setAttribute('pointer-events', 'none') }
            const ih = pr.height - HD - PS.FRAME - PS.PAD
            if (ih > 0) {
                const el = engine.drawRect(cx + PS.FRAME + PS.PAD, pr.top + HD, PS.W - 2 * (PS.FRAME + PS.PAD), ih, 'plan-start-band plan-start-hatch', { fill: `url(#${pid})`, stroke: 'none' })
                if (el && el.setAttribute) el.setAttribute('pointer-events', 'none')
            }
            this._planStartX = { x: xb, top: pr.top, h: pr.height, color }   // IE 2026 09 30 / ODOO-343343 (заказ Игоря: начало плана штриховкой — объяснение по Alt у флажков): h — высота полосы (попадание курсора по Alt)
            st.chartIds[this.widget_id || 'x'] = 1; st.charts = Object.keys(st.chartIds).length
            return true
        },
        // IE 2026 09 30 / ODOO-343343 (заказ Игоря: начало плана штриховкой — объяснение по Alt у флажков): Alt-объяснение начала плана — курсор (x, y — окно) на флажке (всегда) либо на полосе там, где под курсором нет серии (hoverPick):
        // запись chart.planStart; иначе null (дальше — карточка «Chart area» / значения). Флажок и полоса — pointer-events: none, поэтому по точке из uiHelp6_plotTip
        planStart_tip(x, y) {
            const g = this._planStartX, flex = this.flex
            if (!g || !flex || !flex.hostElement || this.store.setting('fe.ux.planStartMark', true) === false) return null
            const r = flex.hostElement.getBoundingClientRect(), mx = x - r.left, my = y - r.top
            if (mx < g.x - 7.5 || mx > g.x + 7.5 || my < g.top || my > g.top + (g.h || 0)) return null
            if (my > g.top + 16 && this.hoverPick(flex, { clientX: x, clientY: y })) return null
            const html = uiHelp_html('chart.planStart')
            if (!html) return null
            const st = this.planStart_stat(); st.chartTips = (st.chartTips || 0) + 1
            return { content: html, rect: new wjcCore.Rect(x - 8, y - 8, 16, 16), noLinger: true }
        },
        // флажок на белой плашке 15×15 у верхнего края полосы — поверх серий (после отрисовки)
        planStart_flag(flex) {
            const g = this._planStartX
            if (!g) return
            const svg = flex.hostElement?.querySelector('svg')
            if (!svg) return
            svg.querySelectorAll('.plan-start-flag').forEach(n => n.remove())
            // IE 2026 09 30 / ODOO-343343 (заказ Игоря: элемент Plan start одинаковый во всех формах): глухая шапка капсулы (белая, рамка сверху и по бокам) + флажок — поверх серий; геометрия общая с таблицей
            const gg = document.createElementNS('http://www.w3.org/2000/svg', 'g')
            gg.setAttribute('class', 'plan-start-flag'); gg.setAttribute('pointer-events', 'none')
            gg.innerHTML = planStartHeadSvg({ x: g.x - PS.W / 2, y: g.top, color: g.color })
            svg.appendChild(gg)
        },
        hatchDefs_ensure(engine) {
            const map = this._hatch
            if (!map || !Object.keys(map).length) return
            const defs = (engine && engine._defs) || this.flex?.hostElement?.querySelector('svg > defs')
            if (!defs) return
            const NS = 'http://www.w3.org/2000/svg'
            for (const id of Object.keys(map)) {
                const h = map[id]
                let p = defs.querySelector(`[id="${id}"]`)
                if (!p) {
                    p = document.createElementNS(NS, 'pattern')
                    p.setAttribute('id', id); p.setAttribute('patternUnits', 'userSpaceOnUse'); p.setAttribute('width', '7'); p.setAttribute('height', '7'); p.setAttribute('patternTransform', 'rotate(45)')
                    const r = document.createElementNS(NS, 'rect'); r.setAttribute('width', '7'); r.setAttribute('height', '7')
                    const l = document.createElementNS(NS, 'line'); l.setAttribute('x1', '0'); l.setAttribute('y1', '0'); l.setAttribute('x2', '0'); l.setAttribute('y2', '7'); l.setAttribute('stroke-width', '2')
                    p.appendChild(r); p.appendChild(l); p.appendChild(document.createElementNS(NS, 'stop'))
                    defs.appendChild(p)
                }
                const r = p.querySelector('rect'), l = p.querySelector('line'), st = p.querySelector('stop')
                if (r) r.setAttribute('fill', h.fill)
                if (l) l.setAttribute('stroke', h.color)
                if (st) st.setAttribute('stop-color', `url(#${id})`)
            }
        },
        // ---- IE 2026 09 24 / ODOO-5800 (Igor, форма ячейки, п. 3.1: «стек прихода — IN (обычный) и над ним IN_expired») ----
        // Накладка-стек: у поля ключ stack_on = binding базовой серии-столбика того же списка. Сама серия не рисуется (chart_hidden → visibility Legend:
        // в подсказке есть, кластер столбиков не сдвигает), а после отрисовки (rendered) её значение кладётся ПОВЕРХ базового столбика — прямоугольником
        // той же ширины на верхнюю долю value / base его высоты; заливка — штриховка серии (hatch_base / hatch_color, паттерн hatchDefs_ensure) либо свой
        // cssStyleChart.fill. Геометрия базового столбика — из DOM серии (series.hostElement → rect по центру категории axisX.convert(i)): wijmo стекует
        // только серии типа чарта на главной оси, а столбики движений формы ячейки — кластер (IN / OUT рядом), штатный стек сложил бы всё в один столбик.
        // Группа накладки встаёт в DOM сразу за группой базовой серии — линии запаса остаются сверху. Выкл: fe.ux.chartStackOverlay = false
        stackOverlay_on() { try { return this.store?.setting?.('fe.ux.chartStackOverlay', true) !== false } catch (e) { return true } },
        stackOverlay_draw(flex, engine) {
            if (!flex || !engine || !this.stackOverlay_on()) return
            const attrs = Object.values(this.attrs_by_binding || {}).filter(a => a && a.stack_on && a.binding)
            if (!attrs.length) return
            const rows = this.data || [], axX = flex.axisX
            if (!rows.length || !axX) return
            const on = (s) => s && (s.visibility === 0 || s.visibility === 1)
            for (const attr of attrs) {
                const base = (flex.series || []).find(s => s && s.binding === attr.stack_on && on(s))
                const host = base && base.hostElement
                if (!host || !host.parentNode) continue
                const rects = [...host.querySelectorAll('rect')].map(r => ({ x: +r.getAttribute('x'), y: +r.getAttribute('y'), w: +r.getAttribute('width'), h: +r.getAttribute('height') })).filter(r => r.w > 0 && r.h > 0)
                if (!rects.length) continue
                const hid = this.hatchId(attr.binding), hatched = !!(this._hatch && this._hatch[hid]) && this.chartHatchOn()
                const own = (attr.cssStyleChart && typeof attr.cssStyleChart === 'object') ? attr.cssStyleChart : {}
                const bst = (base.style && typeof base.style === 'object') ? base.style : {}
                const grp = engine.startGroup('wj-series-group cell-stack-overlay')
                engine.fill = hatched ? `url(#${hid})` : (own.fill || '#8e24aa')
                engine.stroke = bst.stroke || own.stroke || null
                engine.strokeWidth = bst.strokeWidth != null ? bst.strokeWidth : 0
                let n = 0
                rows.forEach((row, i) => {
                    const v = +row[attr.binding], b = +row[attr.stack_on]
                    if (!(v > 0) || !(b > 0)) return
                    const cx = axX.convert(i); if (!Number.isFinite(cx)) return
                    let best = null, bd = Infinity
                    for (const r of rects) { const d = Math.abs(r.x + r.w / 2 - cx); if (d < bd) { bd = d; best = r } }
                    if (!best || bd > best.w) return
                    const h = best.h * Math.min(1, v / b)
                    if (h > 0.5) { engine.drawRect(best.x, best.y, best.w, h, 'cell-stack-overlay-rect'); n++ }
                })
                engine.endGroup()
                if (grp && grp.parentNode) { if (n) host.parentNode.insertBefore(grp, host.nextSibling); else grp.parentNode.removeChild(grp) }
            }
        },
        // ---- IE 2026 09 25 / ODOO-5800 (Igor, форма ячейки: «раскрашивай оптимальную зону как белую; показывай зелёным макс зону до верха») ----
        // Полоса между сериями: у поля ключ area_base = поле строки с нижней границей (обычно binding соседней серии; пусто / не число — от нуля) и / или
        // area_top = true — верхняя граница = потолок оси серии (actualMax; при явном 'axisY-max' — он), иначе — своё значение. wijmo рисует Area только
        // от нуля, поэтому штатная заливка серии погашена (load_data), а после отрисовки (rendered) полоса кладётся многоугольником по точкам категорий
        // (axisX.convert(i), ось серии convert(v)) — те же точки, что у соседних Area: стыки без зазоров и наложений; пустое значение серии (null / не число)
        // рвёт полосу, как у Area. Заливка / обводка — cssStyleChart серии (fill none / transparent — полоса не рисуется). Группа полосы — ПЕРВЫЙ ребёнок
        // <g> самой серии: z-порядок серии сохранён (соседние серии и линии поверх), притушение / подсветка серии при наведении (классы на hostElement)
        // действуют и на полосу, клип области ряда — тот же. Рисуется при КАЖДОЙ отрисовке (ресайз, свёртка блока, пересчёт осей, пересоздание чарта) —
        // верх полосы всегда следует за осью. Выкл: fe.ux.chartAreaBand = false
        // IE 2026 10 01 / ODOO-5800 (Igor 01.10: сверхнормативная зона формы ячейки): area_cap = поле строки — верх полосы не выше его значения (зелёная Max
        // кончается на пороге excess, выше — синяя Excess); не число — верх как прежде (потолок оси / своё значение); выше потолка оси полоса не выходит
        areaBand_on() { try { return this.store?.setting?.('fe.ux.chartAreaBand', true) !== false } catch (e) { return true } },
        areaBand_draw(flex, engine) {
            if (!flex || !engine || !this.areaBand_on()) return
            const attrs = Object.values(this.attrs_by_binding || {}).filter(a => a && a.binding && (a.area_base || a.area_top))
            if (!attrs.length) return
            const rows = this.data || [], axX = flex.axisX
            if (!rows.length || !axX) return
            const on = (s) => s && (s.visibility === 0 || s.visibility === 1)
            const num = (x) => (x === null || x === undefined || x === '' ? NaN : +x)   // +null = 0 — пустое значение не должно становиться нулём
            const keep = { fill: engine.fill, stroke: engine.stroke, strokeWidth: engine.strokeWidth }
            for (const attr of attrs) {
                const sr = (flex.series || []).find(s => s && s.binding === attr.binding && on(s))
                const host = sr && sr.hostElement
                if (!host) continue
                const own = (attr.cssStyleChart && typeof attr.cssStyleChart === 'object') ? attr.cssStyleChart : {}
                const fill = own.fill
                if (!fill || fill === 'none' || fill === 'transparent') continue
                const ay = sr.axisY || flex.axisY
                if (!ay || typeof ay.convert !== 'function') continue
                const top = attr.area_top ? ay.convert(ay.actualMax) : null
                if (attr.area_top && !Number.isFinite(top)) continue
                const grp = engine.startGroup('cell-area-band')
                engine.fill = fill
                engine.stroke = (own.stroke && own.stroke !== 'none') ? own.stroke : null
                engine.strokeWidth = own.strokeWidth != null ? own.strokeWidth : 0
                let n = 0, xs = [], hi = [], lo = []
                const flush = () => { if (xs.length >= 2) { engine.drawPolygon(xs.concat([...xs].reverse()), hi.concat([...lo].reverse()), 'cell-area-band-poly'); n++ } xs = []; hi = []; lo = [] }
                rows.forEach((row, i) => {
                    const v = num(row && row[attr.binding])
                    if (!Number.isFinite(v)) { flush(); return }
                    const b0 = attr.area_base ? num(row[attr.area_base]) : 0, b = Number.isFinite(b0) ? b0 : 0
                    const cx = axX.convert(i), yb = ay.convert(b)
                    let yt = top != null ? top : ay.convert(v)
                    const c0 = attr.area_cap ? num(row[attr.area_cap]) : NaN, yc = Number.isFinite(c0) ? ay.convert(c0) : NaN   // IE 2026 10 01 / ODOO-5800: area_cap
                    if (Number.isFinite(yc) && Number.isFinite(yt)) yt = Math.max(yt, yc)   // экранные y: больше — ниже; верх = меньшее из потолка и значения поля
                    if (!Number.isFinite(cx) || !Number.isFinite(yb) || !Number.isFinite(yt)) { flush(); return }
                    xs.push(cx); hi.push(Math.min(yt, yb)); lo.push(yb)   // экранные y: меньше — выше; граница ниже основания — полоса нулевой высоты
                })
                flush()
                engine.endGroup()
                if (grp && grp.parentNode) { if (n) host.insertBefore(grp, host.firstChild); else grp.parentNode.removeChild(grp) }
            }
            engine.fill = keep.fill; engine.stroke = keep.stroke; engine.strokeWidth = keep.strokeWidth
        },
        // ---- IE 2026 09 23 / ODOO-5800 (Igor, форма ячейки: «ось дат — под верхней панелью, как у чарта страницы») ----
        // wijmo кладёт любую нижнюю ось X только под ВЕСЬ plot (_layoutMultiple группирует оси X по колонке PlotArea, не по ряду). Поэтому при ключе
        // чарта 'axisX-mainRow': true и наличии нижних рядов: штатная ось X прячется (подписи, деления, линия, полоса лет; объект оси жив —
        // axisX.convert(i) по-прежнему даёт колонки Ганта формы ячейки), между главным рядом и первым нижним встаёт ряд-распорка PlotArea 'axis_x'
        // (см. load_data; высота в px: первая отрисовка — 'axisX-mainRow-height' или 40, дальше — по измеренной высоте подписей, один лишний проход),
        // и после отрисовки (rendered) в неё рисуется своя ось: линия по низу главного ряда, деления на границах колонок, месяцы (MMM) по центру
        // колонок с прореживанием по ширине текста (шаг — делитель 12, январь подписан всегда), ниже — полоса лет как полоса групп wijmo (год один
        // раз на свой отрезок, скобки на границах). Классы wijmo (wj-axis-x, wj-label, wj-line, wj-tick) — те же шрифты и цвета; наведение
        // выделяет и эти подписи (hoverAxisXLabel). Без нижних рядов (_layoutSingle) — штатная ось, как прежде. Выкл: fe.ux.chartAxisXMainRow = false
        axisXMainRow_on() { try { return !!this.attr?.['axisX-mainRow'] && this.store?.setting?.('fe.ux.chartAxisXMainRow', true) !== false } catch (e) { return false } },
        // прямоугольник главного ряда (plotrect главной оси Y), когда своя ось активна; иначе null
        axisXMainRow_rect(flex) {
            const sp = this._plotRowSpacer, rr = flex?.axisY?._plotrect
            return (sp && rr && rr.height > 0 && this.axisXMainRow_on()) ? rr : null
        },
        // подпись колонки своей оси: месяц (MMM), у дневных / недельных / годовых частот — как у штатной оси
        axisXMainRow_label(r) {
            if (!r) return ''
            const f = this.freq_text
            if (f === 'D') return r.date_Day != null ? String(r.date_Day) : ''
            if (f === 'W') return String(r.date_Week || '')
            if (f === 'A') return String(r.date_Year || '')
            return monthAxis_label(String(r.date || ''), this.store.ui_locale()) || String(r.date_Month || '').slice(0, 3)   // IE 2026 10 16 / ODOO-5800: общий хелпер (три буквы названия месяца на языке интерфейса); date не YYYY-MM — как прежде, из date_Month
        },
        axisXMainRow_apply() {
            const ax = this.flex?.axisX
            if (!ax) return
            const on = (this.axisXMainRow_on() && !!this._plotRowSpacer) || this.monthAxis_on()   // IE 2026 10 22 / ODOO-5800: и ось месяцев без распорки
            if (on) {
                if (!ax._ieMainRow) ax._ieMainRow = { labels: ax.labels, axisLine: ax.axisLine, majorTickMarks: ax.majorTickMarks, majorGrid: ax.majorGrid, groupsOptions: ax.groupsOptions }
                ax.labels = false; ax.axisLine = false; ax.majorTickMarks = wjChart.TickMark ? wjChart.TickMark.None : 0; ax.majorGrid = false
                ax.groupsOptions = { display: AxisGroupsDisplay.None }
            } else if (ax._ieMainRow) {
                const st = ax._ieMainRow; ax._ieMainRow = null
                for (const k of Object.keys(st)) if (ax[k] !== st[k]) ax[k] = st[k]
            }
        },
        // своя ось X под главным рядом; true — запрошена перерисовка (высота распорки подогнана под шрифт подписей)
        // IE 2026 10 22 / ODOO-5800: ось «месяцы + полоса лет» в нижнем поле главной области БЕЗ ряда-распорки — ключ чарта 'axisX-monthAxis' (флаг fe.ux.chartMonthAxis, дефолт ВКЛ; действует
        // только при ключе, прочие графики платформы не меняются): штатная ось X спрятана (axisXMainRow_apply), под plot rect отведено monthAxis_height px (plotMargin bottom,
        // load_data), рисуется в rendered той же процедурой, что ось главного ряда (axisXMainRow_render). При рядах-распорках не действует (там — axisXMainRow_draw)
        monthAxis_on() { try { return !!this.attr?.['axisX-monthAxis'] && !this._plotRowSpacer && this.store?.setting?.('fe.ux.chartMonthAxis', true) !== false } catch (e) { return false } },
        monthAxis_height() { return monthAxis_height(12) + 4 },
        // IE 2026 10 29 / ODOO-5800 (ie-dm7 #114070, проба 5: легенда Bottom наезжала на ось X): явный plotMargin отключает автоотступ wijmo под легенду
        // (легенда Top / Bottom рисуется в поле margin и ложилась на подписи оси месяцев) — к полю добавляется высота легенды (legend._sz после раскладки, до неё — одна строка 24 px);
        // Left / Right / Auto / None поля не меняют. Возвращает признак «поле поменялось»
        monthAxisLegendPad(fx) {
            try {
                const lg = fx && fx.legend, pos = lg ? lg.position : 0
                const h = Math.ceil((lg && lg._sz && lg._sz.height > 0 ? lg._sz.height : 24)) + 4
                const P = wjChart.Position
                if (pos === P.Bottom || pos === P.BottomLeft || pos === P.BottomRight) return { top: 'NaN', bottom: this.monthAxis_height() + h }
                if (pos === P.Top || pos === P.TopLeft || pos === P.TopRight) return { top: h, bottom: this.monthAxis_height() }
            } catch (e) { /* без легенды */ }
            return { top: 'NaN', bottom: this.monthAxis_height() }
        },
        monthAxisMargin_apply() {
            try {
                const fx = this.flex
                if (!fx) return false
                if (this.monthAxis_on()) {
                    if (fx._ieMonthAxisMargin === undefined) fx._ieMonthAxisMargin = fx.plotMargin
                    const pad = this.monthAxisLegendPad(fx), m = pad.top + ' NaN ' + pad.bottom + ' NaN'
                    if (fx.plotMargin === m) return false
                    fx.plotMargin = m
                    return true
                }
                if (fx._ieMonthAxisMargin !== undefined) { fx.plotMargin = fx._ieMonthAxisMargin; fx._ieMonthAxisMargin = undefined; return true }
            } catch (e) { /* тип чарта без plotMargin */ }
            return false
        },
        monthAxis_draw(flex, engine) {
            if (!flex || !engine || !this.monthAxis_on()) return false
            const rr = flex.axisY && flex.axisY._plotrect
            if (!flex.axisX || !rr || !(rr.height > 0) || !(this.data || []).length) return false
            return this.axisXMainRow_render(flex, engine, rr, null)
        },
        axisXMainRow_draw(flex, engine) {
            const sp = this._plotRowSpacer
            if (!sp || !engine || !this.axisXMainRow_on()) return false
            const axX = flex && flex.axisX, rr = flex && flex.axisY && flex.axisY._plotrect, sr = sp._rect
            const rows = this.data || [], n = rows.length
            if (!axX || !rr || !sr || !(sr.height > 0) || !n) return false
            return this.axisXMainRow_render(flex, engine, rr, sp)
        },
        // IE 2026 10 22 / ODOO-5800 (Igor 22.10: ось «месяц / год» у графиков ВЕРСІЇ / ПЛАНИ формы ячейки на AttrChart): общая отрисовка оси месяцев + полосы лет под областью rr —
        // для оси главного ряда (sp — ряд-распорка, его высота подгоняется) и для оси без распорки (monthAxis_draw, sp null)
        axisXMainRow_render(flex, engine, rr, sp) {
            const axX = flex.axisX, rows = this.data || [], n = rows.length
            const CLS_G = 'wj-axis-x cell-chart-axis-x', CLS_L = 'wj-label', CLS_LINE = 'wj-line', CLS_TICK = 'wj-tick'
            const TICK = 4, GAP = 2, BAND = 5, STUB = 4   // px: деление, зазор, полоса лет над годом, скобки / штрих полосы
            const measure = (t) => { try { return engine.measureString(t, CLS_L, 'wj-axis-x') } catch (e) { return { width: 0, height: 12 } } }
            const th = measure('May').height || 12
            const need = monthAxis_height(th)   // деления + подписи + полоса лет (линия, скобки, год); IE 2026 10 16 / ODOO-5800: общий хелпер monthAxis
            if (sp && Math.abs((+sp.height || 0) - need) > 1 && (this._axisXMainRowPass || 0) < 2) {
                this._axisXMainRowPass = (this._axisXMainRowPass || 0) + 1
                this._axisXMainRowH = need; sp.height = need
                flex.invalidate()
                return true
            }
            const x = (i) => axX.convert(i)
            const x0 = x(0), x1 = n > 1 ? x(1) : NaN
            const cw = (Number.isFinite(x0) && Number.isFinite(x1) && x1 > x0) ? x1 - x0 : rr.width
            if (!Number.isFinite(cw) || cw <= 0) return false
            const y0 = rr.bottom, left = rr.left, right = rr.right
            const clampX = (v) => Math.min(right, Math.max(left, v))
            engine.startGroup(CLS_G, flex._chartRectId || null)
            engine.stroke = null; engine.strokeWidth = null; engine.textFill = null; engine.fill = null   // цвета — из CSS-классов wijmo
            engine.drawLine(left, y0, right, y0, CLS_LINE)
            for (let i = 0; i <= n; i++) { const px = clampX(x(Math.min(i, n - 1)) + (i < n ? -cw / 2 : cw / 2)); engine.drawLine(px, y0, px, y0 + TICK, CLS_TICK) }
            // подписи: шаг прореживания — по самой широкой; у месяцев шаг — делитель 12 (Jan / Apr / Jul / Oct при шаге 3)
            const texts = rows.map(r => this.axisXMainRow_label(r))
            let lw = 0; for (const t of new Set(texts)) if (t) lw = Math.max(lw, measure(t).width)
            // IE 2026 09 24 / ODOO-5800 (форма ячейки, п. 4: широкое окно оси): 'axisX-mainRow-step' чарта — шаг не меньше заданного; 'axisX-mainRow-keep' (YYYY-MM) —
            // месяц ячейки подписан всегда (класс cell-axis-keep), соседи ближе шага уступают ему
            const minStep = Math.max(1, Math.floor(+this.attr['axisX-mainRow-step'] || 1))
            let step = Math.max(minStep, Math.ceil((lw + 6) / cw))
            const monthly = !this.freq_text || this.freq_text === 'M'
            if (monthly) step = monthAxis_step(step)   // IE 2026 10 16 / ODOO-5800: общий хелпер monthAxis
            const keepYm = String(this.attr['axisX-mainRow-keep'] || '').slice(0, 7)
            const keepI = keepYm.length === 7 ? rows.findIndex(r => String((r && r.date) || '').slice(0, 7) === keepYm) : -1
            const yl = y0 + TICK + GAP + th   // низ текста подписи
            // IE 2026 10 16 / ODOO-5800: какие подписи показаны — общий хелпер (месячные — по номеру месяца, иначе по индексу; keep всегда, соседи ближе шага уступают)
            const shown = monthAxis_shown(rows.map((r, i) => monthly ? String((r && r.date) || '') : String(i + 1).padStart(2, '0')), step, keepI)
            for (let i = 0; i < n; i++) {
                const t = texts[i]
                if (!t || !shown[i]) continue
                engine.drawString(t, new wjcCore.Point(x(i) - measure(t).width / 2, yl), i === keepI ? CLS_L + ' cell-axis-keep' : CLS_L)
            }
            // полоса лет (как полоса групп wijmo): линия над годом на отрезке года, скобки вверх на границах, штрих к году в центре; год — раз на отрезок
            if (this.freq_text !== 'A') {
                const yb = yl + BAND
                for (const b of monthAxis_yearBands(rows.map(r => (r && r.date_Year) || ''))) {   // IE 2026 10 16 / ODOO-5800: отрезки годов — общий хелпер monthAxis
                    const yr = b.year, i0 = b.i0, i1 = b.i1
                    const xs = clampX(x(i0) - cw / 2) + STUB, xe = clampX(x(i1) + cw / 2) - STUB
                    if (xe > xs) {
                        engine.drawLine(xs, yb, xe, yb, CLS_LINE); engine.drawLine(xs, yb, xs, yb - STUB, CLS_LINE); engine.drawLine(xe, yb, xe, yb - STUB, CLS_LINE)
                        const xc = (xs + xe) / 2
                        engine.drawLine(xc, yb, xc, yb + STUB, CLS_LINE)
                        if (yr) { const w = measure(yr).width; if (w <= xe - xs) engine.drawString(yr, new wjcCore.Point(xc - w / 2, yb + STUB + th), CLS_L) }
                    }
                }
            }
            engine.endGroup()
            return false
        },
        // показана ли серия колонки: по живой серии чарта, иначе по снимку видимости прошлой сборки, иначе по chart_hidden
        axisSeriesShown(attr, cacheVisibility) {
            if (!this.axisRangeShownOnly()) return true
            if (attr.chartGroup) return false
            const vis = (v) => v === 0 || v === 1
            const b = attr.binding, bd = attr.binding + '__down'
            const live = (this.flex?.series || []).find(s => s && (s.binding === b || s.binding === bd))
            if (live) return vis(live.visibility)
            const cv = cacheVisibility ? (cacheVisibility[b] || cacheVisibility[bd]) : null
            if (cv) return vis(cv.visibility)
            return !attr.chart_hidden
        },
        // пересчёт диапазонов осей по показанным сериям (после переключения видимости) — контекст сборки хранится с load_data
        axisRangesRefresh() {
            const rc = this._axisRangeCtx, flex = this.flex
            if (!rc || !flex || !this.axisRangeShownOnly()) return
            const ctx = { ...rc, shown: (a) => this.axisSeriesShown(a, null), shownOnly: true }
            let changed = false
            for (const [key, ax] of Object.entries(this.axisY || {})) {
                if (!ax) continue
                const first = rc.attrs.find(a => (a.axisY || '') === key && !a.axisX && (a.attr_type === 'AttrNumber' || a.attr_type === 'AttrDays' || a.attr_type === 'AttrTime') && a.binding !== this.attr.axisX_bindingX2)
                if (!first) continue
                const rng = this.axisRangeCompute(first, rc.attrs, this.data || [], ctx)
                // у именованной оси min/max после отрисовки уже сдвинуты выравниванием нуля — сравниваем с её якорем данных
                const cur = (key && ax._alignZero) ? [ax._alignZero.dataMin, ax._alignZero.dataMax] : [ax.min, ax.max]
                if (cur[0] !== rng.min || cur[1] !== rng.max) { ax.min = rng.min; ax.max = rng.max; changed = true }
                if (key) ax._alignZero = { dataMin: rng.min, dataMax: rng.max, nonneg: rng.nonneg }
            }
            if (changed) { this._alignZeroPasses = 0; this._sameScalePasses = 0; flex.invalidate() }
        },
        alignSecondaryAxesZero(flex) {
            if (!chartAlignZeroOn() || !flex || !flex.axisY) return false
            const axes = Object.values(this.axisY || {}).filter(ax => ax && ax !== flex.axisY && ax._alignZero)
            if (!axes.length) return false
            const minM = flex.axisY.actualMin, maxM = flex.axisY.actualMax
            const eq = (a, b) => Math.abs((a ?? NaN) - b) <= 1e-9 * Math.max(1, Math.abs(b))
            let changed = false
            for (const ax of axes) {
                const z = ax._alignZero
                let min2 = z.dataMin, max2 = z.dataMax
                if (isFinite(minM) && isFinite(maxM) && minM < 0 && maxM > 0) {
                    const r0 = -minM / (maxM - minM)
                    if (r0 < 0.95) {
                        const unit = ax.majorUnit > 0 ? ax.majorUnit : 0
                        if (z.nonneg) {
                            // ноль в доле r0 сверху вниз: S = max/(1−r0); с делениями — S = k·unit/r0, k — целое
                            let S = z.dataMax / (1 - r0)
                            if (unit) S = Math.ceil(S * r0 / unit) * unit / r0
                            min2 = -r0 * S; max2 = S + min2
                        } else {
                            let S = Math.max(-z.dataMin / r0, z.dataMax / (1 - r0))
                            if (unit) S = Math.ceil(S * r0 / unit) * unit / r0
                            min2 = -r0 * S; max2 = S + min2
                        }
                    }
                }
                if (!eq(ax.min, min2) || !eq(ax.max, max2)) { ax.min = min2; ax.max = max2; changed = true }
                if (z.nonneg && !ax._alignZeroFmt) {
                    // отрицательной части у данных нет — подписи ниже нуля не показываем (шкала месяцев «−2m» сбивала бы с толку)
                    const prev = ax.itemFormatter
                    ax.itemFormatter = (engine, label) => {
                        if (label.val < 0) { label.text = ''; return label }
                        return prev ? prev(engine, label) : label
                    }
                    ax._alignZeroFmt = true
                }
            }
            if (changed) {
                this._alignZeroPasses = (this._alignZeroPasses || 0) + 1
                if (this._alignZeroPasses <= 3) { flex.invalidate(); return true }
            } else {
                this._alignZeroPasses = 0
            }
            return false
        },

        //---------------------------------   SELECTION  ---------------------------------
        setSelectoinListener() {
            const flex = this.flex
            flex.addEventListener(flex.hostElement, 'contextmenu', (e) => this.ctxMenu_chart(e))   // IE 2026 10 12 / ODOO-343342 (заказ Игоря: правая кнопка на остальных элементах — график / узел карты)
            flex.addEventListener(flex.hostElement, 'mouseenter', () => {
                this.mouseSelecting.lmVisible = true
            })
            flex.addEventListener(flex.hostElement, 'mouseleave', () => {
                this.mouseSelecting.lmVisible = false
                this.hoverSeriesUpdate(null)   // IE 2026 09 11 / ODOO-5800
            })
            
            let isSelecting = false,
            x1, y1, x2, y2, pt1, pt2, i1, i2,
            padding = 5
            // flex_rect = flex.hostElement.getBoundingClientRect(),
            
            flex.addEventListener(flex.hostElement, 'mousedown', (event) => {
                x1 = event.clientX
                y1 = event.clientY
                let plotArea_rect = flex.hostElement.querySelector('.wj-plot-area').getBoundingClientRect()

                if (plotArea_rect.left-padding <= x1 && x1 <= plotArea_rect.right+padding
                 && plotArea_rect.top-padding <= y1 && y1 <= plotArea_rect.bottom+padding
                ) {
                    isSelecting = true
                    if (event.shiftKey) {
                        i2 = this.mouseSelecting.pointIndex
                        if (this.mouseSelecting.i2 !== i2) {
                            this.mouseSelecting.i2 = i2
                            this.setSelection(this.mouseSelecting.i1||0, i2, i2)
                        }
                    } else {
                        i1 = this.mouseSelecting.i1 = this.mouseSelecting.i2 = this.mouseSelecting.pointIndex
                        this.setSelection(i1, i1, i1)
                    }
                    // pt1 = flex.pointToData(x1, y1)
                    // if (!this.store.hide_console) console.log(pt1.x)
                    // i1 = this.dateToDataIndex(pt1.x1)
                }
            })
            flex.addEventListener(flex.hostElement, 'mouseup', (event) => {
                if (isSelecting) {
                    isSelecting = false
                    x2 = event.clientX
                    y2 = event.clientY

                    i2 = this.mouseSelecting.pointIndex
                    if (this.mouseSelecting.i2 !== i2) {
                        this.mouseSelecting.i2 = i2
                        this.setSelection(this.mouseSelecting.i1, i2, i2)
                    }
                }
            })
            flex.addEventListener(flex.hostElement, 'mousemove', (event) => {
                if (isSelecting) {
                    x2 = event.clientX
                    y2 = event.clientY

                    i2 = this.mouseSelecting.pointIndex
                    if (this.mouseSelecting.i2 !== i2) {
                        this.mouseSelecting.i2 = i2
                        this.setSelection(this.mouseSelecting.i1, i2, i2)
                    }
                    if (this.hoverValuesOn()) this.hoverValuesUpdate(event)   // IE 2026 09 27 / ODOO-… (заказ Игоря: вариант A наведения на серии): и при выборе периода
                } else {
                    this.hoverSeriesUpdate(event)   // IE 2026 09 11 / ODOO-5800
                }
            })
        },

        // IE 2026 09 11 / ODOO-5800 (замечание Игоря): иконки тулбара чарта (легенда, настройки) живут в верхнем правом
        // углу и ложились на верхнюю подпись правой (именованной) оси — «34m» под иконкой. Подпись, попадающая в этот
        // угол (верхние 28 px, правые 72 px хоста), не рисуется; остальные подписи и деления — как были.
        // IE 2026 09 12 / ODOO-… (заказ Игоря): подписи числовой оси Y в коротком формате фронта (как значения в легенде: store.formatCount —
        // 20 000 000 → 20M, 250 000 → 250K): экономит место под ось и расширяет область графика. Единица подбирается по
        // размаху оси (все подписи в одной единице — не «5000K» рядом с «10.0M»), хвост «.0» не пишется; оси с размахом
        // меньше 100 000 — как были. Отключение: 'axisY-short': false у чарта (основная ось) или у поля (именованная ось).
        // Совмещается с прежним форматтером (не со своим же от предыдущего load_data — метка _axisShort)
        axisShort_apply(axis, attr, opts = {}) {   // IE 2026 09 12 / ODOO-…: opts.spanRef() — размах другой оси для выбора единицы
            if (!axis || (attr && attr['axisY-short'] === false) || this.attr?.['axisY-short'] === false) return
            const prev = axis.itemFormatter
            const prevFormatter = (prev && !prev._axisShort) ? prev : null
            const units = [[1e15, 'Q', 1], [1e12, 'T', 1], [1e9, 'B', 1], [1e6, 'M', 1], [1e3, 'K', 0]]
            const thresholds = { Q: 1e15, T: 1e13, B: 1e10, M: 1e7, K: 1e5 }   // как в store.formatCount
            const fmt = (engine, label) => {
                if (prevFormatter) label = prevFormatter(engine, label)
                const v = label && label.val
                if (typeof v !== 'number' || !isFinite(v)) return label
                if (v === 0) { label.text = '0'; return label }   // ноль — без единицы
                const span = Math.max(Math.abs(axis.actualMax ?? axis.max ?? 0), Math.abs(axis.actualMin ?? axis.min ?? 0), Math.abs(v), (opts.spanRef ? (opts.spanRef() || 0) : 0))
                const u = units.find(x => span >= thresholds[x[1]])
                if (!u) return label
                let t = (Math.abs(v) / u[0]).toFixed(u[2])
                if (u[2]) t = t.replace(/\.0$/, '')
                label.text = (v < 0 ? '-' : '') + t + u[1]
                return label
            }
            fmt._axisShort = true
            axis.itemFormatter = fmt
        },
        axisIconGuard(axis) {
            if (!axis || axis._iconGuard) return
            const prev = axis.itemFormatter
            axis.itemFormatter = (engine, label) => {
                // IE 2026 09 11 / ODOO-… (замечание Игоря: подпись правой оси ложилась на метки, метки резались краем): на проходе ИЗМЕРЕНИЯ
                // wijmo зовёт форматтер с engine.readOnly и позицией (plot.right, 0) для ВСЕХ меток — она попадала в «угол»,
                // метки мерились пустыми, и поле под ось выходило 34 px вместо ~60. Прячем метку только при отрисовке
                if (engine && engine.readOnly) return prev ? prev(engine, label) : label
                const host = this.flex?.hostElement
                const pos = label && label.pos
                if (host && pos && pos.y <= 28 && pos.x >= host.clientWidth - 72) { label.text = ''; return label }
                return prev ? prev(engine, label) : label
            }
            axis._iconGuard = true
        },

        // IE 2026 09 11 / ODOO-5800 (заказ Игоря): серия под курсором. hitTest wijmo даёт ближайшую серию/точку (distance);
        // серия считается «под курсором» на её элементе (Series/SeriesSymbol) или в пределах 15 px от точки.
        // Подсветка — классами на SVG-группах серий (series.hostElement) и оси серии (axis.hostElement), ярлык с именем
        // серии — HTML-элемент над осью; чарт не перерисовывается. event = null — снять подсветку.
        hoverSeriesUpdate(event) {
            const flex = this.flex
            if (!flex || !flex.hostElement) return
            // IE 2026 09 15 (заказ Игоря: селективные серии): курсор на бейдже точки — наведение не снимать (иначе чекбокс не нажать)
            if (event && event.target && event.target.closest && event.target.closest('.chart-hover-badge')) { this.hoverBadgeKeep(); return }
            // по пути от точки к бейджу курсор проходит над другими точками — серию под курсором не менять, пока он в «мостике» точка → бейдж
            if (event && this.hoverBadgeBridge(event)) { this.hoverBadgeKeep(); return }
            // IE 2026 09 27 / ODOO-… (заказ Игоря: вариант A наведения на серии): проход мышью ничего не перекрашивает — вертикаль, точки линий,
            // подпись даты и плашка значений всех серий (hoverValuesUpdate); режим выключили на лету — его элементы убрать
            if (this.hoverValuesOn()) { this.hoverValuesUpdate(event); return }
            if (this._hvShown || flex.hostElement.classList.contains('chart-hover-values')) this.hoverValuesHide()
            let sr = null, ht = null
            if (event && chartHoverOn()) {
                // свой подбор вместо flex.hitTest: у серии остатка (Column с собственной отрисовкой ступени) невидимые столбцы
                // от нуля до значения накрывают линии под ней, и hitTest всегда отдавал «Stock»
                ht = this.hoverPick(flex, event)
                sr = ht ? ht.series : null
            }
            this.hoverSeriesApply(sr, ht)
        },
        // IE 2026 09 13 / ODOO-5800 (заказ Игоря): связанная подсветка серий по странице. Опция чарта 'hover-link' = 'page' (панель ⚙ →
        // Series highlight: Linked on the page). Серия под курсором (на чарте или на строке окна легенды) рассылается через
        // store.chartHoverLink = {page, wid, name}; каждый чарт с этой опцией на той же странице находит у себя показанную серию с тем же
        // именем (у разрезных серий имя = значение разреза, напр. страна) и подсвечивает её как при своём наведении — притушение
        // остальных серий, ярлык с именем у оси, строка в окне легенды; тегов значения точки у принявшего чарта нет (точки нет).
        // Уход курсора (null) снимает подсветку везде. Выкл целиком: window.feSettings.set('fe.ux.chartHoverLink', false)
        // IE 2026 09 14 / ODOO-5800: закреплённые цвета значений разреза (см. цикл серий в load_data).
        // Выкл: window.feSettings.set('fe.ux.chartSeriesColorPinned', false)
        seriesColorPinnedOn() {
            try { return this.store?.setting?.('fe.ux.chartSeriesColorPinned', true) !== false } catch (e) { return true }
        },
        hoverLinkOn() {
            if (this.attr?.['hover-link'] !== 'page') return false
            try { return this.store?.setting?.('fe.ux.chartHoverLink', true) !== false } catch (e) { return true }
        },
        hoverLinkSend(sr) {
            const W = this.WIDGET
            if (!W) return
            const attr = sr ? (this.attrs_by_binding?.[sr.binding] || {}) : {}
            this.store.chartHoverLink = { page: W.page, wid: W.id, name: sr ? (sr.name || attr.title || sr.binding) : null, ts: Date.now() }
        },
        hoverLinkReceive(v) {
            const W = this.WIDGET, flex = this.flex
            if (!v || !W || !flex || !flex.hostElement || v.wid === W.id || v.page !== W.page || !this.hoverLinkOn()) return
            const sr = v.name ? (flex.series || []).find(x => x && x.name === v.name && (x.visibility === 0 || x.visibility === 1)) : null
            this._hoverRemote = true
            try { this.hoverSeriesApply(sr || null, null) } finally { this._hoverRemote = false }
        },
        // IE 2026 09 12 / ODOO-… (заказ Игоря): наведение на строку серии в окне легенды — та же подсветка серии на чарте, что при наведении
        // на неё в самом чарте (подписей точки нет — точки нет); null — снять
        onLegendSeriesHover(binding) {
            const flex = this.flex
            if (!flex || !flex.hostElement) return
            const sr = binding ? (flex.series || []).find(x => x && x.binding === binding) : null
            this.hoverSeriesApply(sr || null, null)
        },
        // IE 2026 09 12 / ODOO-… (замечание Игоря): серии-спутники серии под курсором — они не притушаются вместе с остальными: у ступени остатка
        // (режим остатка) это столбцы прихода, расхода и списания (и их зеркала chart_down) — это данные самой серии
        hoverKinBindings(sr) {
            const kin = new Set()
            const a = this.attr || {}
            if (!sr || !a.chartType || sr.binding !== (a.binding_stock || 'open_balance')) return kin
            const wo = a.binding_wo === false ? '' : (a.binding_wo || 'WO_OUT')
            for (const b of [a.binding_in || 'IN', a.binding_out || 'OUT', wo]) if (b) { kin.add(b); kin.add(b + '__down') }
            return kin
        },
        // IE 2026 09 26 / ODOO-… (замечание Игоря: выделение серий графика): «не выделять серию, если она одна; не выделять текущую серию, а приглушать
        // другие». Режим soft — наведённая серия и её ось вид не меняют, остальные серии гаснут до одной мягкой прозрачности с переходом в обе стороны;
        // одна видимая серия с данными не выделяется вовсе. Выкл: window.feSettings.set('fe.ux.chartHoverDimOthers', false) — прежняя подсветка
        // (drop-shadow наведённой серии, жирная ось, притушение .28). Прозрачность приглушённых: fe.ux.chartHoverDimOpacity (0.35; 0.05…0.9)
        hoverDimOn() {
            try { return this.store?.setting?.('fe.ux.chartHoverDimOthers', true) !== false } catch (e) { return true }
        },
        hoverDimOpacity() {   // IE 2026 09 26 / ODOO-… (замечание Игоря: выделение серий графика)
            let v = 0.35
            try { v = Number(this.store?.setting?.('fe.ux.chartHoverDimOpacity', 0.35)) } catch (e) { v = 0.35 }
            return Number.isFinite(v) ? Math.min(0.9, Math.max(0.05, v)) : 0.35
        },
        // IE 2026 09 26 / ODOO-… (замечание Игоря: выделение серий графика): «одна серия» = одна видимая серия (visibility Visible / Plot,
        // отрисована), у которой в текущих строках есть хоть одно конечное НЕнулевое значение: серия из одних пустых / нулей — столбики нулевой высоты,
        // маркер на нуле — не «вторая серия» (у «Виручка $» так выглядят «Базова лінія $» и «Бюджет$» рядом с «Продажі $»). Кэш — по строкам и составу серий
        hoverLoneSeries(flex) {
            const data = toRaw(this.data) || []
            const list = (flex.series || []).filter(s => s && s.binding && s.hostElement && s.visibility !== 2 && s.visibility !== 3)
            const sig = list.map(s => s.binding).join('|')
            const c = this._hoverLoneCache
            if (c && c.data === data && c.sig === sig) return c.lone
            let n = 0
            for (const s of list) {
                const b = s.binding
                for (const row of data) {
                    const v = row ? row[b] : null
                    if (v !== null && v !== undefined && v !== '' && +v !== 0 && Number.isFinite(+v)) { n++; break }
                }
                if (n > 1) break
            }
            this._hoverLoneCache = { data, sig, lone: n <= 1 }
            return n <= 1
        },
        // IE 2026 09 26 / ODOO-… (замечание Игоря: выделение серий графика): перерисовка wijmo (данные, оси, ресайз) пересоздаёт группы серий
        // и осей — классы наведения пропадали, пока курсор стоял на той же серии (hoverSeriesApply повторов не делает: серия та же), и приглушение
        // «мигало» до перехода на другую серию (замер chartemph_check: перерисовка сразу после наведения). Режим soft — вид текущей серии под курсором
        // возвращается после каждой отрисовки (chartRendered); другим графикам страницы (hover-link) повторно не рассылается
        hoverSeriesReapply(flex) {
            const key = this._hoverSeriesKey
            if (!key || !flex || !flex.hostElement || !this.hoverDimOn()) return
            const sr = (flex.series || []).find(x => x && x.binding === key) || null
            const pIdx = this._hoverPointIndex
            this._hoverSeriesKey = undefined
            this._hoverPointIndex = undefined
            this._hoverRemote = true
            try { this.hoverSeriesApply(sr, (sr && pIdx != null) ? { pointIndex: pIdx, item: this.data?.[pIdx] } : null) } finally { this._hoverRemote = false }
        },
        // IE 2026 09 27 / ODOO-… (заказ Игоря: вариант A наведения на серии) — «делай А» (макет «Серии под курсором», вариант «Перекрестие»,
        // handoff-files/chart-emphasis-2026-09-26/mockup): проход мышью по графику НИЧЕГО не перекрашивает — ни приглушения серий, ни ярлыка с именем
        // у оси, ни тегов точки; вместо них вертикаль на ближайшей дате, точки линий на ней, подпись даты на оси X и плашка со значениями ВСЕХ серий
        // этой даты (по убыванию, серии другой оси — ниже), строка серии у курсора отмечена. Окно легенды открыто — плашки нет: окно идёт за датой
        // под курсором (legendHoverIndex), строка серии у курсора отмечена в нём. Фокус серии (приглушение остальных) — только намеренный: строка окна
        // легенды или связанный график страницы (hover-link). Бейдж селектора разрезной серии — после остановки курсора на её точке, не на проходе.
        // Не действует: график формы ячейки / вкладки Analysis ('tooltip-inline' — своя подсказка), мобильный профиль (пузырёк по тапу), chart.hover=false.
        // Выкл: window.feSettings.set('fe.ux.chartHoverValues', false) — прежнее наведение (приглушение остальных серий, fe.ux.chartHoverDimOthers).
        // Строк в плашке не больше fe.data.chartHoverValuesRows (14) и по высоте графика; задержка бейджа — fe.data.chartHoverBadgeDwellMs (450)
        hoverValuesOn() {
            if (!chartHoverOn() || this.attr?.['tooltip-inline'] || this.store?.mobileUi?.on) return false
            try { return this.store?.setting?.('fe.ux.chartHoverValues', true) !== false } catch (e) { return true }
        },
        // IE 2026 09 29 / ODOO-343341 (заказ Игоря: «не показывай tooltip для точки (скрин 1) — при необходимости можно открыть легенду и увидеть его там (скрин 2)»):
        // у графика, где есть окно легенды (кнопка 🏷, isLegendGroupedActive), плашки значений p199A у точки нет — вертикаль, точки линий, дата на оси X, выделение
        // серии и колонка наведения в окне легенды остаются; своей подсказки wijmo у такого графика и так нет (tooltip_widget = widget-row: tooltipContent пуст).
        // График без окна легенды, 'tooltip-inline' (график формы ячейки), телефон — как было. Выключатель fe.ux.chartPointTipOff (false — плашка как прежде)
        chartPointTipOff() {
            if (!this.hoverValuesOn() || !this.isLegendGroupedActive()) return false
            try { return this.store?.setting?.('fe.ux.chartPointTipOff', true) !== false } catch (e) { return true }
        },
        hoverValuesSetting(key, def, lo, hi) {   // IE 2026 09 27 / ODOO-… (заказ Игоря: вариант A наведения на серии)
            let v = def
            try { v = Number(this.store?.setting?.(key, def)) } catch (e) { v = def }
            return Number.isFinite(v) ? Math.min(hi, Math.max(lo, v)) : def
        },
        // тип серии — линия (точка на вертикали ставится только линиям: столбики и области стекуются, их значения — в плашке)
        hoverValuesIsLine(ct) {   // IE 2026 09 27 / ODOO-… (заказ Игоря: вариант A наведения на серии)
            return [2, 3, 4, 9, 10, 'Scatter', 'Line', 'LineSymbols', 'Spline', 'SplineSymbols'].includes(ct)
        },
        // элементы режима: вертикаль, плашка, пул точек — HTML в хосте wijmo (перерисовка SVG их не стирает); хост пересоздан — заново
        hoverValuesEls() {   // IE 2026 09 27 / ODOO-… (заказ Игоря: вариант A наведения на серии)
            const host = this.flex?.hostElement
            if (!host) return null
            let els = this._hvEls
            if (!els || !els.line.isConnected || els.host !== host) {
                const mk = (cls) => { const el = document.createElement('div'); el.className = cls; el.style.display = 'none'; host.appendChild(el); return el }
                els = this._hvEls = { host, line: mk('chart-hv-line'), plate: mk('chart-hv-plate'), dots: [] }
                if (getComputedStyle(host).position === 'static') host.style.position = 'relative'
            }
            return els
        },
        // теги точки (X — дата, Y, кольцо) — те же элементы, что у hoverPointTags (создаются тем же порядком, если их ещё нет)
        hoverValuesTagEls() {   // IE 2026 09 27 / ODOO-… (заказ Игоря: вариант A наведения на серии)
            const host = this.flex.hostElement
            let tags = this._hoverTagEls
            if (!tags || !tags.x || !tags.x.isConnected) {
                tags = this._hoverTagEls = {}
                for (const k of ['x', 'y', 'dot']) {
                    const el = document.createElement('div')
                    el.className = 'chart-hover-tag chart-hover-tag-' + k
                    host.appendChild(el)
                    tags[k] = el
                }
                if (getComputedStyle(host).position === 'static') host.style.position = 'relative'
            }
            return tags
        },
        // дата под курсором: ближайшая по X точка ряда в пределах области построения (при зуме навигатора — только видимые); null — вне области
        hoverValuesSnap(flex, event) {   // IE 2026 09 27 / ODOO-… (заказ Игоря: вариант A наведения на серии)
            const host = flex.hostElement, pr = flex._plotRect || flex.plotRect, data = this.data || []
            if (!host || !pr || !data.length) return null
            const r = host.getBoundingClientRect()
            const mx = event.clientX - r.left, my = event.clientY - r.top
            if (mx < pr.left - 2 || mx > pr.right + 2 || my < pr.top - 2 || my > pr.bottom + 2) return null
            const bx = flex.bindingX
            let best = -1, bd = Infinity, bpx = NaN
            for (let i = 0; i < data.length; i++) {
                let x
                try { x = flex.axisX.convert(this.hoverXNum(bx ? data[i]?.[bx] : i, i)) } catch (e) { x = NaN }
                if (!Number.isFinite(x) || x < pr.left - 1 || x > pr.right + 1) continue
                const d = Math.abs(x - mx)
                if (d < bd) { bd = d; best = i; bpx = x }
            }
            return best < 0 ? null : { i: best, px: bpx, pr }
        },
        // цвет серии, как он нарисован (однотонные DOS-линии, палитра разреза, градиент столбиков); кэш — до следующей отрисовки
        hoverValuesColor(sr) {   // IE 2026 09 27 / ODOO-… (заказ Игоря: вариант A наведения на серии)
            const cache = this._hvColors || (this._hvColors = new Map())
            if (cache.has(sr.binding)) return cache.get(sr.binding)
            let c = null, fill0 = null, stroke0 = null   // IE 2026 09 27 / ODOO-… (p199b): заливка / обводка элемента серии как есть — для паттерна штриховки
            try {
                const el = sr.hostElement && sr.hostElement.querySelector('polyline, path, rect, ellipse, circle')
                if (el) {
                    const stroke = el.getAttribute('stroke')
                    let fill = el.getAttribute('fill')
                    fill0 = fill; stroke0 = stroke   // IE 2026 09 27 / ODOO-… (p199b)
                    if (fill && String(fill).startsWith('url(')) {
                        const id = String(fill).match(/url\(["']?#([^"')]+)/)?.[1]
                        const stop = id && this.flex.hostElement.querySelector(`[id="${id}"] stop`)
                        fill = stop ? (stop.getAttribute('stop-color') || null) : null
                    }
                    c = el.tagName === 'rect' ? (fill || stroke) : ((stroke && stroke !== 'none') ? stroke : fill)
                    if (c === 'none') c = null
                }
            } catch (e) { c = null }
            if (!c) {
                const attr = this.attrs_by_binding?.[sr.binding] || {}
                c = attr.cssStyleChart?.stroke || attr.cssStyleChart?.fill || sr.style?.stroke || sr.style?.fill || legendSeriesColor(this.flex.series, this.flex.palette, sr, attr) || '#6b7280'
            }
            // IE 2026 09 27 / ODOO-… (p199b, дефект с боя #47409): заливка SVG-паттерном штриховки (hatch_base — «Sales uncovered» 585_001): служебный
            // <stop> паттерна отдаёт url(#hatch-…) — CSS-фоном он недействителен, квадрат плашки был пустым. Свотч строки — полосы, как у легенды формы
            // ячейки (cellChart_legend), в кэше под ключом '\u0000' + binding (hoverValuesSwatch); точке и рамке бейджа — цвет штриха. Градиент — как был.
            const ref = [fill0, c].find(v => v && String(v).startsWith('url('))
            if (ref) {
                const pat = this.hoverValuesPattern(ref, stroke0)
                if (pat) { cache.set('\u0000' + sr.binding, `repeating-linear-gradient(45deg, ${pat.fill} 0 3px, ${pat.color} 3px 4px)`); c = pat.color }
            }
            if (c && String(c).startsWith('url(')) c = (stroke0 && stroke0 !== 'none' && !String(stroke0).startsWith('url(')) ? stroke0 : '#6b7280'   // IE 2026 09 27 / ODOO-… (p199b): ссылка — не цвет CSS
            cache.set(sr.binding, c)
            return c
        },
        // IE 2026 09 27 / ODOO-… (p199b): фон свотча строки плашки — полосы штриховки у серии с заливкой паттерном, иначе цвет серии (hoverValuesColor)
        hoverValuesSwatch(sr) {
            const c = this.hoverValuesColor(sr)
            return (this._hvColors && this._hvColors.get('\u0000' + sr.binding)) || c
        },
        // IE 2026 09 27 / ODOO-… (p199b): паттерн штриховки по ссылке url(#id) — {fill, color}: описание сборки (this._hatch, hatchDefs_ensure), иначе сам
        // <pattern> в <defs> графика (прямоугольник — базовая заливка, линия — штрих); недостающий цвет — обводка серии. Не паттерн (градиент) — null
        hoverValuesPattern(ref, stroke) {
            const id = String(ref || '').match(/url\(["']?#([^"')]+)/)?.[1]
            if (!id) return null
            const col = (v) => (v && v !== 'none' && !String(v).startsWith('url(')) ? String(v) : null
            const h = this._hatch && this._hatch[id]
            let fill = col(h && h.fill), color = col(h && h.color)
            if (!h) {
                let p = null
                try { p = this.flex?.hostElement?.querySelector(`[id="${id}"]`) || document.getElementById(id) } catch (e) { p = null }
                if (!p || String(p.tagName || '').toLowerCase() !== 'pattern') return null
                fill = col(p.querySelector('rect')?.getAttribute('fill')); color = col(p.querySelector('line')?.getAttribute('stroke'))
            }
            const s = col(stroke)
            fill = fill || s || color; color = color || s || fill
            return fill && color ? { fill, color } : null
        },
        // строки плашки на дату i: показанные серии со значением (столбики / области без нуля), зеркала chart_down — без знака «вниз»;
        // порядок — ось главной шкалы первой, внутри оси по убыванию значения
        hoverValuesRows(i) {   // IE 2026 09 27 / ODOO-… (заказ Игоря: вариант A наведения на серии)
            const flex = this.flex, row = this.data?.[i]
            if (!flex || !row) return []
            const axes = [flex.axisY], out = []
            for (const sr of flex.series || []) {
                if (!sr || !sr.binding || !sr.hostElement || !(sr.visibility === 0 || sr.visibility === 1)) continue
                const attr = this.attrs_by_binding?.[sr.binding] || {}
                if (attr.chart_hidden_tooltip) continue
                const vPlot = row[sr.binding]
                if (vPlot === null || vPlot === undefined || vPlot === '' || !Number.isFinite(+vPlot)) continue
                const v = +this.chartDownUnmirror(sr.binding, +vPlot)
                const isLine = this.hoverValuesIsLine(sr.chartType ?? flex.chartType)
                if (!isLine && v === 0) continue
                const ax = sr.axisY || flex.axisY
                let ai = axes.indexOf(ax)
                if (ai < 0) { axes.push(ax); ai = axes.length - 1 }
                out.push({ sr, b: sr.binding, v, isLine, ai, attr, name: sr.name || attr.title || sr.binding })
            }
            out.sort((a, b) => (a.ai - b.ai) || (b.v - a.v))
            return out
        },
        hoverValuesText(r) {   // IE 2026 09 27 / ODOO-… (заказ Игоря: вариант A наведения на серии): как значения окна легенды — длительности своим форматтером, числа коротко
            const attr = r.attr || {}
            if (attr.attr_type === 'AttrDays') return this.store.formatDaysHTML(r.v, attr)
            if (attr.attr_type === 'AttrTime') return this.store.formatTimeHTML(r.v, attr)
            const x = Math.abs(r.v) < 100 ? Math.round(r.v * 100) / 100 : Math.round(r.v)
            return this.store.formatCount ? this.store.formatCount(x) : String(x)
        },
        // заголовок плашки: месяц и год (шаг M), год (A), день (D / W / S; у недели — номер недели); не дата — подпись оси X строки
        hoverValuesDate(i) {   // IE 2026 09 27 / ODOO-… (заказ Игоря: вариант A наведения на серии)
            const row = this.data?.[i]
            if (!row) return ''
            const bx = this.flex?.bindingX
            const d0 = (row.date !== null && row.date !== undefined && row.date !== '') ? row.date : null
            const ds = d0 instanceof Date ? d0.toISOString() : String(d0 ?? '')
            const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(ds)
            if (!m) {
                const lab = bx && bx !== 'date_parse' ? row[bx] : null
                return String((lab && typeof lab === 'object') ? (lab.title ?? lab.value ?? '') : (lab ?? ds))
            }
            const dt = new Date(+m[1], +m[2] - 1, +m[3])
            const loc = this.store.ui_locale ? this.store.ui_locale() : undefined
            const f = this.freq
            try {
                if (f === 'A') return m[1]
                if (f === 'M' || (!f && m[3] === '01')) return dt.toLocaleDateString(loc, { month: 'long', year: 'numeric' })
                const s = dt.toLocaleDateString(loc, { day: 'numeric', month: 'short', year: 'numeric' })
                return (f === 'W' && row.date_Week) ? s + ' · ' + row.date_Week : s
            } catch (e) { return ds.slice(0, 10) }
        },
        // главный шаг: мышь над графиком (event) / ушла (null)
        hoverValuesUpdate(event) {   // IE 2026 09 27 / ODOO-… (заказ Игоря: вариант A наведения на серии)
            const flex = this.flex, host = flex && flex.hostElement
            if (!host) return
            if (!event) { this.hoverValuesHide(true); return }
            this._hvLast = { clientX: event.clientX, clientY: event.clientY }
            if (!host.classList.contains('chart-hover-values')) host.classList.add('chart-hover-values')   // перекрестие LineMarker в режиме не рисуется (CSS)
            const snap = this.hoverValuesSnap(flex, event)
            if (!snap) { this.hoverValuesHide(true); return }   // над осями / полями — ничего
            const els = this.hoverValuesEls()
            if (!els) return
            const near = this.hoverPick(flex, event)
            const nearB = near && near.series ? near.series.binding : null
            const legendShown = this.isLegendPanelShown()
            const tipOff = !legendShown && this.chartPointTipOff()   // IE 2026 09 29 / ODOO-343341 (заказ Игоря: вкладка расшифровки в окне легенды): плашки у точки нет — у графика есть окно легенды
            const st = this._hvState || {}
            this._hvShown = true
            this._hvSnap = { i: snap.i, px: snap.px }
            // теги прежнего наведения (режим включили на лету) — убрать: значения теперь в плашке
            const tags = this._hoverTagEls
            if (tags && st.i === undefined) { if (tags.y) tags.y.style.display = 'none'; if (tags.dot) tags.dot.style.display = 'none' }
            const moved = st.i !== snap.i || st.px !== snap.px
            if (moved) this.hoverValuesDraw(flex, snap)
            // окно легенды идёт за ДАТОЙ под курсором; строка серии у курсора отмечена в нём (перекраски графика нет)
            if (legendShown) {
                if (this.legendHoverIndex !== snap.i) { this.legendHoverIndex = snap.i; if (this.legendPointIndex == null) this.legendTetherUpdate() }
                if (this.legendHoverBinding !== nearB) { this.legendHoverBinding = nearB; this._hvLegendRow = nearB }
                if (els.plate.style.display !== 'none') els.plate.style.display = 'none'
            } else {
                if (this._hvLegendRow) { if (this.legendHoverBinding === this._hvLegendRow) this.legendHoverBinding = null; this._hvLegendRow = null }
                // IE 2026 09 29 / ODOO-343341 (заказ Игоря: «не показывай tooltip для точки — при необходимости можно открыть легенду и увидеть его там»): у графика с окном
                // легенды плашки нет (вертикаль, точки линий и дата на оси остаются); без окна легенды — как было. Выключатель fe.ux.chartPointTipOff
                if (tipOff) { if (els.plate.style.display !== 'none') els.plate.style.display = 'none'; if (moved) this.chartDrill_count?.('tipOffMoves') }
                else if (moved || st.near !== nearB || !st.plate) this.hoverValuesPlate(flex, snap, nearB)
            }
            this._hvState = { i: snap.i, px: snap.px, near: nearB, plate: !legendShown && !tipOff }   // IE 2026 09 29 / ODOO-343341 (заказ Игоря: вкладка расшифровки в окне легенды): + tipOff
            this.hoverValuesDwell(near, event)
        },
        // вертикаль, точки линий, подпись даты на оси X
        hoverValuesDraw(flex, snap) {   // IE 2026 09 27 / ODOO-… (заказ Игоря: вариант A наведения на серии)
            const els = this._hvEls, pr = snap.pr, px = snap.px, host = flex.hostElement
            els.line.style.left = Math.round(px) + 'px'
            els.line.style.top = Math.round(pr.top) + 'px'
            els.line.style.height = Math.max(0, Math.round(pr.height)) + 'px'
            els.line.style.display = 'block'
            const row = this.data?.[snap.i] || {}
            let k = 0
            for (const sr of flex.series || []) {
                if (!sr || !sr.binding || !sr.hostElement || !(sr.visibility === 0 || sr.visibility === 1)) continue
                if (!this.hoverValuesIsLine(sr.chartType ?? flex.chartType) || this.attrs_by_binding?.[sr.binding]?.chart_hidden_tooltip) continue   // точка = строка плашки
                const v = row[sr.binding]
                if (v === null || v === undefined || v === '' || !Number.isFinite(+v)) continue
                let py
                try { py = (sr.axisY || flex.axisY).convert(+v) } catch (e) { py = NaN }
                if (!Number.isFinite(py) || py < pr.top - 2 || py > pr.bottom + 2) continue
                let d = els.dots[k]
                if (!d || !d.isConnected) { d = els.dots[k] = document.createElement('div'); d.className = 'chart-hv-dot'; host.appendChild(d) }
                d.style.left = px + 'px'; d.style.top = py + 'px'; d.style.background = this.hoverValuesColor(sr); d.style.display = 'block'
                k++
            }
            for (let j = k; j < els.dots.length; j++) if (els.dots[j].style.display !== 'none') els.dots[j].style.display = 'none'
            // подпись даты: своя подпись оси X — жирным в рамке (нейтральный цвет: дата общая для всех серий), прорежена — тег с датой
            let markLbl = true
            try { markLbl = this.store?.setting?.('fe.ux.chartHoverMarkAxisLabel', true) !== false } catch (e) { markLbl = true }
            const xl = markLbl ? this.hoverAxisXLabel(flex, snap.i, px) : null
            this.hoverXLabelMark(xl, '#4b5563')
            this._hvMarked = !!xl
            const tx = this.hoverValuesTagEls().x
            if (xl) { tx.style.display = 'none'; this._hvXTag = false; return }
            const item = this.data?.[snap.i] || {}
            const d0 = item.date || item[flex.bindingX] || ''
            const ds = String(d0 instanceof Date ? d0.toISOString() : d0)
            const mon = (d3) => { const m = /^(\d{4})-(\d{2})(?:-(\d{2}))?/.exec(d3); if (!m) return ''; const nm = new Date(+m[1], +m[2] - 1, 1).toLocaleString(this.store.ui_locale(), { month: 'short' }); return (m[3] && m[3] !== '01') ? nm + ' ' + String(+m[3]) : nm }
            tx.textContent = (this.axesCompactX() && mon(ds)) ? mon(ds) : (/^\d{4}-\d{2}-01/.test(ds) ? ds.slice(0, 7) : (ds.length >= 10 ? ds.slice(0, 10) : ds))
            tx.style.borderColor = '#4b5563'; tx.style.display = 'block'
            const mr = this.axisXMainRow_rect(flex)
            tx.style.top = (mr ? Math.min(mr.bottom + 2, host.clientHeight - 16) : (this.axesCompactX() ? Math.max(pr.bottom - 18, 0) : Math.min(pr.bottom + 2, host.clientHeight - 16))) + 'px'
            tx.style.left = Math.max(px - tx.offsetWidth / 2, 0) + 'px'
            this._hvXTag = true
        },
        // плашка значений: дата, строки «цвет · значение · серия»; справа от вертикали (у правого края — слева), не под островком кнопок графика
        hoverValuesPlate(flex, snap, nearB) {   // IE 2026 09 27 / ODOO-… (заказ Игоря: вариант A наведения на серии)
            const plate = this._hvEls.plate, host = flex.hostElement
            const rows = this.hoverValuesRows(snap.i)
            if (!rows.length) { plate.style.display = 'none'; return }
            const esc = (x) => String(x ?? '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]))
            const hostW = host.clientWidth, hostH = host.clientHeight, pr = snap.pr
            plate.style.maxWidth = Math.max(120, Math.min(260, hostW - 8)) + 'px'
            const dateText = esc(this.hoverValuesDate(snap.i))
            const build = (cap) => {
                let shown = rows
                if (rows.length > cap) {
                    shown = rows.slice(0, cap)
                    if (nearB && !shown.some(r => r.b === nearB)) { const nr = rows.find(r => r.b === nearB); if (nr) shown = [...rows.slice(0, Math.max(0, cap - 1)), nr] }   // строка у курсора остаётся
                }
                let html = `<div class="chart-hv-date">${dateText}</div><table class="chart-hv-table"><tbody>`
                for (const r of shown) {
                    html += `<tr${r.b === nearB ? ' class="chart-hv-near"' : ''}><td class="chart-hv-k"><i class="chart-hv-key${r.isLine ? '' : ' chart-hv-key-box'}" style="background:${esc(this.hoverValuesSwatch(r.sr))}"></i></td>`   // IE 2026 09 27 / ODOO-… (p199b): полосы у штрихованной серии
                        + `<td class="chart-hv-val">${this.hoverValuesText(r)}</td><td class="chart-hv-name">${esc(r.name)}</td></tr>`
                }
                html += '</tbody></table>'
                const more = rows.length - shown.length
                if (more > 0) html += `<div class="chart-hv-more">${esc(this.tn(more, '+{n} more', '+{n} more'))}</div>`
                plate.innerHTML = html
                return shown.length
            }
            plate.style.left = '0px'; plate.style.top = '0px'; plate.style.display = 'block'
            const maxRows = Math.min(rows.length, this.hoverValuesSetting('fe.data.chartHoverValuesRows', 14, 1, 60))
            // строки — сколько влезает по высоте от top до низа графика; сторона — справа от вертикали, у правого края — слева
            const place = (top0) => {
                let cap = maxRows, n = build(cap)
                const avail = Math.max(40, hostH - top0 - 4)
                for (let guard = 0; guard < 4 && plate.offsetHeight > avail && n > 1; guard++) {
                    const tr = plate.querySelector('tr')
                    const rowH = Math.max(12, tr ? tr.offsetHeight : 17)
                    cap = Math.max(1, n - Math.ceil((plate.offsetHeight - avail) / rowH) - (rows.length > n ? 0 : 1))
                    n = build(cap)
                }
                const w = plate.offsetWidth
                let left = snap.px + 14, side = 'right'
                if (left + w > hostW - 4) { left = snap.px - 14 - w; side = 'left' }
                if (left < 4) left = Math.max(4, Math.min(hostW - w - 4, snap.px + 14))
                return { left, side, w, h: plate.offsetHeight }
            }
            // препятствия у верхнего края: островок кнопок графика (легенда, шестерёнка) и островки парящей шапки виджета (Float: бейдж, заголовок,
            // панель, меню ≡) — плашка ниже них, строки пересчитываются под меньшую высоту
            const obst = []
            try {
                const hr = host.getBoundingClientRect()
                const add = (el) => {
                    const r = el.getBoundingClientRect()
                    if (!(r.width > 0 && r.height > 0)) return
                    const cs = getComputedStyle(el)
                    if (cs.visibility === 'hidden' || cs.display === 'none' || +cs.opacity < 0.05) return
                    obst.push({ l: r.left - hr.left, t: r.top - hr.top, r: r.right - hr.left, b: r.bottom - hr.top })
                }
                const ac = this.$refs.attr_container
                if (ac) ac.querySelectorAll(':scope > .corner-island').forEach(add)
                const wdiv = this.WIDGET && document.getElementById('WIDGET' + this.WIDGET.id)
                if (wdiv && wdiv.classList.contains('widget-float-header')) wdiv.querySelectorAll(':scope > .widget-container > *').forEach(add)
            } catch (e) { /* без препятствий */ }
            let top = Math.max(2, Math.round(pr.top))
            let pl = place(top)
            for (let guard = 0; guard < 3; guard++) {
                const hit = obst.filter(o => o.b < hostH / 2 && pl.left < o.r && pl.left + pl.w > o.l && top < o.b && top + pl.h > o.t)
                if (!hit.length) break
                top = Math.round(Math.max(...hit.map(o => o.b)) + 4)
                pl = place(top)
            }
            if (top + pl.h > hostH - 2) top = Math.max(2, hostH - 2 - pl.h)
            plate.style.left = Math.round(pl.left) + 'px'; plate.style.top = Math.round(top) + 'px'
            this._hvPlateSide = pl.side
            this._hvPlateBuilds = (this._hvPlateBuilds || 0) + 1
        },
        // бейдж селектора разрезной серии (селективные серии 15.09) — только после остановки курсора на её точке: на проходе не мелькает
        // «остановка» = курсор у той же точки и сдвинулся не больше чем на 3 px с начала отсчёта (медленное ведение мышью бейдж не вызывает)
        hoverValuesDwell(near, event) {   // IE 2026 09 27 / ODOO-… (заказ Игоря: вариант A наведения на серии)
            const sr = near && near.series
            const key = sr ? sr.binding + '|' + near.pointIndex : null
            const x = event ? event.clientX : 0, y = event ? event.clientY : 0, p0 = this._hvDwellPos
            const still = !!p0 && Math.abs(x - p0.x) <= 3 && Math.abs(y - p0.y) <= 3
            if (key === this._hvDwellKey && (still || this._hvBadge)) return   // стоит (или бейдж этой точки уже показан)
            this._hvDwellPos = { x, y }
            if (key !== this._hvDwellKey && this._hvBadge) { this.hoverBadgeHideSoon(); this._hvBadge = false }
            this._hvDwellKey = key
            clearTimeout(this._hvDwellT); this._hvDwellT = null
            if (!sr || !this.seriesSel(sr)) return
            const i = near.pointIndex
            this._hvDwellT = setTimeout(() => {
                this._hvDwellT = null
                if (this._hvDwellKey === key && this._hvShown) this.hoverValuesBadge(sr, i)
            }, this.hoverValuesSetting('fe.data.chartHoverBadgeDwellMs', 450, 0, 3000))
        },
        hoverValuesBadge(sr, i) {   // IE 2026 09 27 / ODOO-… (заказ Игоря: вариант A наведения на серии)
            const flex = this.flex, item = this.data?.[i]
            if (!flex || !item || !sr.hostElement) return
            const vPlot = item[sr.binding]
            if (vPlot === null || vPlot === undefined || vPlot === '') return
            let px, py
            try { px = flex.axisX.convert(this.hoverXNum(flex.bindingX ? item[flex.bindingX] : i, i)); py = (sr.axisY || flex.axisY).convert(+vPlot) } catch (e) { return }
            if (!Number.isFinite(px) || !Number.isFinite(py)) return
            this._hoverPt = { px, py }   // якорь «мостика» точка → бейдж (hoverBadgeBridge)
            const side = (this._hvState && this._hvState.plate && this._hvPlateSide === 'right') ? 'left' : 'right'   // с другой стороны точки, чем плашка
            this.hoverBadgeShow(sr, px, py, this.hoverValuesColor(sr), this.chartDownUnmirror(sr.binding, vPlot), this.attrs_by_binding?.[sr.binding] || {}, side)
            this._hvBadge = true
        },
        // убрать элементы режима; keepClass = false — режим выключен (перекрестие LineMarker снова рисуется)
        hoverValuesHide(keepClass = false) {   // IE 2026 09 27 / ODOO-… (заказ Игоря: вариант A наведения на серии)
            const host = this.flex && this.flex.hostElement
            if (!keepClass && host) host.classList.remove('chart-hover-values')
            clearTimeout(this._hvDwellT); this._hvDwellT = null; this._hvDwellKey = null; this._hvDwellPos = null
            if (!this._hvShown) return
            const els = this._hvEls
            if (els) { els.line.style.display = 'none'; els.plate.style.display = 'none'; for (const d of els.dots) d.style.display = 'none' }
            if (this._hvXTag && this._hoverTagEls && this._hoverTagEls.x) this._hoverTagEls.x.style.display = 'none'
            this._hvXTag = false
            if (this._hvMarked) { this.hoverXLabelMark(null); this._hvMarked = false }
            if (this._hvBadge) { this.hoverBadgeHideSoon(); this._hvBadge = false }
            if (this._hvLegendRow) { if (this.legendHoverBinding === this._hvLegendRow) this.legendHoverBinding = null; this._hvLegendRow = null }
            this._hvShown = false; this._hvState = null; this._hvSnap = null
            if (this.legendHoverIndex != null) {
                this.legendHoverIndex = null
                if (this.legendPointIndex == null && this.isLegendPanelShown()) this.legendTetherUpdate()
            }
        },
        // перерисовать по последнему положению мыши: окно легенды открыли / закрыли, график перерисован (данные, оси, ресайз)
        hoverValuesRefresh() {   // IE 2026 09 27 / ODOO-… (заказ Игоря: вариант A наведения на серии)
            if (!this._hvShown || !this._hvLast) return
            if (!this.hoverValuesOn()) { this.hoverValuesHide(); return }
            this._hvState = null
            this.hoverValuesUpdate(this._hvLast)
        },
        hoverValuesAfterRender() {   // IE 2026 09 27 / ODOO-… (заказ Игоря: вариант A наведения на серии): цвета серий могли смениться, координаты — точно
            this._hvColors = null
            if (this._hvShown) this.hoverValuesRefresh()
        },
        // IE 2026 09 12 / ODOO-…: применение подсветки серии — общий шаг наведения в чарте (sr + точка ht) и в окне легенды (sr без точки)
        hoverSeriesApply(sr, ht) {
            const flex = this.flex
            if (!flex || !flex.hostElement) return
            const key = sr ? sr.binding : null
            const pIdx = (sr && ht && ht.pointIndex != null && ht.pointIndex >= 0) ? ht.pointIndex : null
            if (this._hoverSeriesKey === key && this._hoverPointIndex === pIdx) return
            const sameSeries = this._hoverSeriesKey === key
            this._hoverSeriesKey = key
            this._hoverPointIndex = pIdx
            const host = flex.hostElement
            // IE 2026 09 13 / ODOO-5800 (заказ Игоря): опция «Series highlight: Linked on the page» — смена серии под курсором (чарт или
            // строка легенды) рассылается чартам той же страницы; принятый сигнал (_hoverRemote) дальше не рассылается
            if (!sameSeries && !this._hoverRemote && this.hoverLinkOn()) this.hoverLinkSend(sr)
            this.hoverPointTags(flex, sr, pIdx, ht)   // IE 2026 09 11 / ODOO-5800: подписи значения точки на осях X и Y
            // IE 2026 09 13 / ODOO-5800 (замечание Игоря): окно легенды без зафиксированной точки следует за точкой под курсором —
            // значения и дата в заголовке колонки (hoverIndex), линия-привязка — к самой точке (той, у которой подписи на осях)
            const hIdx = (sr && pIdx != null && this._hoverPt) ? pIdx : null
            if (this.legendHoverIndex !== hIdx) this.legendHoverIndex = hIdx
            if (this.legendPointIndex == null && this.isLegendPanelShown()) this.legendTetherUpdate()
            if (sameSeries) return
            // IE 2026 09 26 / ODOO-… (замечание Игоря: выделение серий графика): режим soft — класс chart-hover-soft на хосте (держится
            // и после ухода мыши: переход прозрачности — в обе стороны), наведённая серия и её ось вид не меняют (классы-метки, CSS их не красит),
            // остальные гаснут до --chart-hover-dim; одна серия с данными (hoverLoneSeries) — ни классов, ни ярлыка с именем, ни подсветки строки легенды
            const soft = this.hoverDimOn()   // IE 2026 09 26 / ODOO-… (замечание Игоря: выделение серий графика)
            host.classList.toggle('chart-hover-soft', soft)   // IE 2026 09 26 / ODOO-… (замечание Игоря: выделение серий графика)
            const dimOp = soft ? String(this.hoverDimOpacity()) : ''   // IE 2026 09 26 / ODOO-… (замечание Игоря: выделение серий графика)
            if (soft && host.style.getPropertyValue('--chart-hover-dim') !== dimOp) host.style.setProperty('--chart-hover-dim', dimOp)   // IE 2026 09 26 / ODOO-… (замечание Игоря: выделение серий графика)
            const mark = (soft && sr && this.hoverLoneSeries(flex)) ? null : sr   // IE 2026 09 26 / ODOO-… (замечание Игоря: выделение серий графика): одна серия — без выделения
            // серии
            // series.hostElement — <g> серии внутри ОБЩЕЙ группы .wj-series-group (одна на все серии), поэтому притушение
            // вешается классом на каждую серию, а не на группу
            const kin = this.hoverKinBindings(mark)   // IE 2026 09 12 / ODOO-…: столбики на ступени остатка — не притушать
            for (const x of flex.series || []) {
                const g = x.hostElement
                if (!g || !g.classList) continue
                g.classList.toggle('chart-series-hover', !!mark && x === mark)   // IE 2026 09 26 / ODOO-… (замечание Игоря: выделение серий графика): в режиме soft — только метка
                g.classList.toggle('chart-series-dim', !!mark && x !== mark && !kin.has(x.binding))   // IE 2026 09 26 / ODOO-… (замечание Игоря: выделение серий графика)
            }
            host.classList.toggle('chart-series-hovering', !!mark)   // IE 2026 09 26 / ODOO-… (замечание Игоря: выделение серий графика)
            // ось серии
            const axes = [flex.axisY, ...(flex.axes || [])].filter(Boolean)
            const ax = mark ? (mark.axisY || flex.axisY) : null   // IE 2026 09 26 / ODOO-… (замечание Игоря: выделение серий графика): в режиме soft ось — только метка (не жирнеет)
            for (const a of axes) {
                const g = a.hostElement || a._hostElement
                if (g && g.classList) g.classList.toggle('chart-axis-hover', a === ax)
            }
            // ярлык с именем серии у её оси
            let label = this._hoverLabelEl
            if (!label) {
                label = this._hoverLabelEl = document.createElement('div')
                label.className = 'chart-hover-axis-label'
                host.appendChild(label)
                if (getComputedStyle(host).position === 'static') host.style.position = 'relative'
            }
            if (mark && ax) {   // IE 2026 09 26 / ODOO-… (замечание Игоря: выделение серий графика): одна серия — ярлыка с именем нет
                const attr = this.attrs_by_binding?.[mark.binding] || {}
                const color = attr.cssStyleChart?.stroke || attr.cssStyleChart?.fill || mark.style?.stroke || mark.style?.fill || '#444'
                label.textContent = mark.name || attr.title || mark.binding
                label.style.borderColor = color
                label.style.color = color
                const pr = flex._plotRect || flex.plotRect || null
                const right = ax !== flex.axisY && (ax.position === wjChart.Position.Right || ax.position === 3)
                // IE 2026 09 13 / ODOO-5800 (замечание Игоря): ярлык — над областью САМОЙ оси (ax._plotrect — ряд PlotArea оси: у оси
                // нижнего графика — вверху нижнего графика), а не в левом верхнем углу всего чарта; без своего ряда — как прежде
                const prA = (ax._plotrect && ax._plotrect.height > 0) ? ax._plotrect : pr
                // IE 2026 09 13 / ODOO-5800 (замечание Игоря): у нижнего ряда над областью места нет — там отрицательная зона верхнего
                // графика; ярлык нижнего ряда — ВНУТРИ его области у верхнего края, ярлык верхнего ряда — над областью, как прежде
                const _lowerRow = !!(prA && pr && prA.top > pr.top + 1)
                // IE 2026 09 13 / ODOO-5800 (заказ Игоря): компактные оси — над областью места нет, ярлык внутри у верхнего края;
                // у правой оси — ниже кнопок чарта (список, шестерёнка) в правом верхнем углу
                const _compactLbl = this.axesCompactY()
                label.style.top = (prA ? (_lowerRow ? prA.top + 2 : (_compactLbl ? prA.top + (right ? 26 : 2) : Math.max(prA.top - 20, 0))) : 0) + 'px'
                if (right) { label.style.left = 'auto'; label.style.right = (pr ? Math.max(host.clientWidth - pr.right, 0) : 0) + 'px' }
                else { label.style.right = 'auto'; label.style.left = (pr ? Math.max(pr.left, 0) : 0) + 'px' }
                label.style.display = ''
            } else {
                label.style.display = 'none'
            }
            this.legendHoverBinding = mark ? mark.binding : null   // IE 2026 09 26 / ODOO-… (замечание Игоря: выделение серий графика): одна серия — строка легенды не подсвечивается
        },

        // IE 2026 09 11 / ODOO-5800: серия под курсором — по расстоянию до ближайшей по X точки: линии/сплайны/области —
        // расстояние до точки (≤ 15 px), столбцы — попадание в столбик (по X ≤ 8 px, по Y между 0 и значением);
        // серия остатка (ступень) — как линия по значению открытия. Возвращает {series, pointIndex, item} или null.
        // значение X строки → число для axisX.convert: Date / число / строка даты (date_parse) / индекс
        hoverXNum(xv, i) {
            if (xv instanceof Date) return xv.valueOf()
            if (typeof xv === 'number') return xv
            if (typeof xv === 'string' && xv) { const t = Date.parse(xv); return isNaN(t) ? i : t }
            return i
        },
        // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U6 (регрессия ie-dm7 #43146, 25.09): карточка «Chart area» (chart.line.plot) — НЕ директивой
        // на хосте wijmo: регистрация на хосте (1) глушила собственную подсказку графика (App.vue считает хост с __wjTipFn «ленивой» подсказкой: без Alt /
        // Show tooltips не показывает, при Show tooltips подменяет содержимое) и (2) у графика формы ячейки перебивала расшифровку точки cellChartAlt
        // (тот же хост; uiHelp._refreshShown при перерисовке по наведению). Теперь — источник altTooltip «по точке» на корне SVG: карточка только над
        // ПУСТЫМ местом области построения; над точкой / столбиком / зоной (hoverPick — тот же подбор, что подсветка серии и cellChartAlt) и вне области
        // построения (оси, поля) источник молчит — altTooltip идёт выше по DOM (хост графика формы — cellChartAlt); курсор в области владельца
        // (data-alt-owner, uiHelp_ownerYields) — уступает полностью. Подсказка — у курсора, без дожития после Alt (как у карты / графа / потока);
        // SVG wijmo может пересоздать — привязка повторяется после каждой отрисовки
        uiHelp6_bindPlot() {
            const host = this.flex && this.flex.hostElement
            const svg = host && host.querySelector('svg')
            if (!svg || svg.__altTipAt) return
            svg.__altTipAt = (x, y) => this.uiHelp6_plotTip(x, y)
            svg.setAttribute('data-alt-tip-at', '')
            svg.setAttribute('data-help-at', 'chart.line.plot')
        },
        uiHelp6_plotEmpty(x, y) {
            const flex = this.flex
            if (!flex || !flex.hostElement) return false
            try {
                const pr = flex._plotRect || flex.plotRect
                const r = flex.hostElement.getBoundingClientRect()
                const mx = x - r.left, my = y - r.top
                if (!pr || mx < pr.left || mx > pr.right || my < pr.top || my > pr.bottom) return false
                return !this.hoverPick(flex, { clientX: x, clientY: y })
            } catch (e) { return false }
        },
        uiHelp6_plotTip(x, y) {
            const flex = this.flex
            if (!flex || !flex.hostElement || !uiHelp_enabled()) return null
            if (uiHelp_ownerYields(flex.hostElement, x, y)) return null
            { const _pst = this.planStart_tip(x, y); if (_pst) return _pst }   // IE 2026 09 30 / ODOO-343343 (заказ Игоря: начало плана штриховкой — объяснение по Alt у флажков)
            const hv = this.hoverValuesOn()   // IE 2026 09 27 / ODOO-… (заказ Игоря: вариант A наведения на серии)
            if (!this.uiHelp6_plotEmpty(x, y)) {
                if (!hv || !this.hoverValuesSnap(flex, { clientX: x, clientY: y })) return null
                const hvHtml = uiHelp_html('chart.line.hoverValues', { vars: { tipOff: this.chartPointTipOff() ? 1 : 0 } })   // IE 2026 09 29 / ODOO-343341 (заказ Игоря: вкладка расшифровки в окне легенды): vars.tipOff — плашки у точки нет
                return hvHtml ? { content: hvHtml, rect: new wjcCore.Rect(x - 8, y - 8, 16, 16), noLinger: true } : null
            }
            const html = uiHelp_html('chart.line.plot', { ...(hv ? { state: 'values' } : {}), vars: { drill: this.chartDrill_helpMode(), tipOff: this.chartPointTipOff() ? 1 : 0 } })   // IE 2026 09 26 / ODOO-… (заказ Игоря: расшифровка кусочка графика): vars.drill — клик открывает форму расшифровки · IE 2026 09 29 / ODOO-343341 (заказ Игоря: вкладка расшифровки в окне легенды): drill 2 — вкладка Breakdown окна легенды, tipOff — плашки у точки нет
            return html ? { content: html, rect: new wjcCore.Rect(x - 8, y - 8, 16, 16), noLinger: true } : null
        },
        hoverPick(flex, event) {
            const host = flex.hostElement
            const pr = flex._plotRect || flex.plotRect
            const data = this.data || []
            if (!host || !pr || !data.length) return null
            const r = host.getBoundingClientRect()
            const mx = event.clientX - r.left, my = event.clientY - r.top
            if (mx < pr.left - 2 || mx > pr.right + 2 || my < pr.top - 2 || my > pr.bottom + 2) return null
            const bx = flex.bindingX
            const xs = data.map((row, i) => { try { return flex.axisX.convert(this.hoverXNum(bx ? row[bx] : i, i)) } catch (e) { return NaN } })
            let iNear = -1, dxBest = Infinity
            for (let i = 0; i < xs.length; i++) { const d = Math.abs(xs[i] - mx); if (d < dxBest) { dxBest = d; iNear = i } }
            if (iNear < 0) return null
            const binding_stock = this.attr.binding_stock || 'open_balance'
            let best = null
            for (const sr of flex.series || []) {
                if (!sr || !sr.binding || !sr.hostElement || sr.visibility === 2 || sr.visibility === 3) continue
                const ax = sr.axisY || flex.axisY
                const ct = sr.chartType ?? flex.chartType
                const isBar = (ct === 0 || ct === 1 || ct === 'Column' || ct === 'Bar') && sr.binding !== binding_stock
                let cand = null
                const pyOf = (i) => {
                    if (i < 0 || i >= data.length) return NaN
                    const v = data[i][sr.binding]
                    if (v === null || v === undefined || v === '' || isNaN(+v)) return NaN
                    try { const py = ax.convert(+v); return Number.isFinite(py) ? py : NaN } catch (e) { return NaN }
                }
                if (isBar) {
                    const py = pyOf(iNear)
                    if (!isNaN(py)) {
                        let y0; try { y0 = ax.convert(0) } catch (e) { y0 = py }
                        const inside = Math.abs(xs[iNear] - mx) <= 8 && my >= Math.min(y0, py) - 2 && my <= Math.max(y0, py) + 2
                        if (inside) cand = { d: Math.abs(xs[iNear] - mx), i: iNear }
                    }
                } else {
                    // линия/сплайн: расстояние до отрезков между соседними точками (курсор лежит на кривой между точками),
                    // точка серии — ближний конец отрезка
                    for (const [i1, i2] of [[iNear - 1, iNear], [iNear, iNear + 1]]) {
                        const y1 = pyOf(i1), y2 = pyOf(i2)
                        if (isNaN(y1) || isNaN(y2)) continue
                        const x1 = xs[i1], x2 = xs[i2]
                        const L2 = (x2 - x1) ** 2 + (y2 - y1) ** 2
                        const t = L2 ? Math.max(0, Math.min(1, ((mx - x1) * (x2 - x1) + (my - y1) * (y2 - y1)) / L2)) : 0
                        const d = Math.hypot(mx - (x1 + t * (x2 - x1)), my - (y1 + t * (y2 - y1)))
                        const i = t < 0.5 ? i1 : i2
                        if (d <= 15 && (!cand || d < cand.d)) cand = { d, i }
                    }
                    const py = pyOf(iNear)
                    if (!isNaN(py)) { const d = Math.hypot(xs[iNear] - mx, py - my); if (d <= 15 && (!cand || d < cand.d)) cand = { d, i: iNear } }
                }
                if (cand && (!best || cand.d < best.d)) best = { d: cand.d, series: sr, pointIndex: cand.i, item: data[cand.i] }
            }
            return best
        },

        // IE 2026 09 11 / ODOO-5800 (заказ Игоря): для точки серии, ближайшей к вертикали курсора (hitTest.pointIndex),
        // подписи значения на осях: тег даты под осью X и тег значения у оси Y серии, маркер на самой точке.
        // HTML-элементы поверх чарта, без перерисовки.
        hoverPointTags(flex, sr, pIdx, ht) {
            const host = flex.hostElement
            let tags = this._hoverTagEls
            if (!tags) {
                tags = this._hoverTagEls = {}
                for (const k of ['x', 'y', 'dot']) {
                    const el = document.createElement('div')
                    el.className = 'chart-hover-tag chart-hover-tag-' + k
                    host.appendChild(el)
                    tags[k] = el
                }
                if (getComputedStyle(host).position === 'static') host.style.position = 'relative'
            }
            const hide = () => { for (const k in tags) tags[k].style.display = 'none'; this.hoverXLabelMark(null); this._hoverPt = null; this.hoverBadgeHideSoon() }   // IE 2026 09 15: бейдж — с задержкой (курсор идёт к чекбоксу)
            const item = (sr && pIdx != null) ? (this.data?.[pIdx] ?? ht?.item) : null
            const pr = flex._plotRect || flex.plotRect
            if (!item || !pr) { hide(); return }
            const attr = this.attrs_by_binding?.[sr.binding] || {}
            const vPlot = item[sr.binding]
            const vRaw = this.chartDownUnmirror ? this.chartDownUnmirror(sr.binding, vPlot) : vPlot
            if (vPlot === null || vPlot === undefined || vPlot === '') { hide(); return }
            const ax = sr.axisY || flex.axisY
            let px = null, py = null
            try {
                px = flex.axisX.convert(this.hoverXNum(flex.bindingX ? item[flex.bindingX] : pIdx, pIdx))
                py = ax.convert(+vPlot)
            } catch (e) { px = null }
            if (!(px >= pr.left - 1 && px <= pr.right + 1) || !Number.isFinite(py)) { hide(); return }
            this._hoverPt = { px, py }   // IE 2026 09 13 / ODOO-5800: точка под курсором (координаты чарта) — якорь привязки окна легенды
            const color = attr.cssStyleChart?.stroke || attr.cssStyleChart?.fill || sr.style?.stroke || sr.style?.fill || '#444'
            // X: дата точки (месяц) под осью
            const d = item.date || item[flex.bindingX] || ''
            const ds = String(d instanceof Date ? d.toISOString() : d)
            // IE 2026 09 15 (замечание Игоря): при компактной оси X (полоса лет под осью) тег даты — только месяц («Aug», у дневных «Aug 15»):
            // год виден под ним
            const _mon = (d3) => { const m = /^(\d{4})-(\d{2})(?:-(\d{2}))?/.exec(d3); if (!m) return ''; const nm = new Date(+m[1], +m[2] - 1, 1).toLocaleString(this.store.ui_locale(), { month: 'short' });   /* IE 2026 09 24 / ODOO-341407: месяц — на языке интерфейса */ return (m[3] && m[3] !== '01') || (!/^\d{4}-\d{2}-01/.test(d3) && m[3]) ? nm + ' ' + String(+m[3]) : nm }
            const xText = this.axesCompactX() && _mon(ds) ? _mon(ds) : (/^\d{4}-\d{2}-01/.test(ds) ? ds.slice(0, 7) : (ds.length >= 10 ? ds.slice(0, 10) : ds))
            const tx = tags.x
            // IE 2026 09 13 / ODOO-5800 (замечание Игоря): у оси X уже есть подпись этой точки (месяц / день / неделя) — выделяем ЕЁ
            // (жирным, в рамке цвета серии), тег с датой не рисуем; тег остаётся, когда подписи нет (прорежена wijmo при нехватке
            // места, ось без подписей). Выкл: window.feSettings.set('fe.ux.chartHoverMarkAxisLabel', false)
            let _markLbl = true
            try { _markLbl = this.store?.setting?.('fe.ux.chartHoverMarkAxisLabel', true) !== false } catch (e) { _markLbl = true }
            const xl = _markLbl ? this.hoverAxisXLabel(flex, pIdx, px) : null
            this.hoverXLabelMark(xl, color)
            const _compactX = this.axesCompactX(), _compactY = this.axesCompactY()   // IE 2026 09 13 / ODOO-5800 (заказ Игоря): компактные оси — теги внутри области графика; 15.09 — X и Y отдельно
            if (xl) tx.style.display = 'none'
            else {
                tx.textContent = xText; tx.style.borderColor = color; tx.style.display = 'block'   // в CSS тег скрыт по умолчанию
                const mr = this.axisXMainRow_rect(flex)   // IE 2026 09 23 / ODOO-5800: своя ось под главным рядом — тег даты под ним
                tx.style.top = (mr ? Math.min(mr.bottom + 2, host.clientHeight - 16) : (_compactX ? Math.max(pr.bottom - 18, 0) : Math.min(pr.bottom + 2, host.clientHeight - 16))) + 'px'
                tx.style.left = Math.max(px - tx.offsetWidth / 2, 0) + 'px'
            }
            // Y: значение точки у оси серии
            const ty = tags.y
            let yHTML
            if (attr.attr_type === 'AttrDays') yHTML = this.store.formatDaysHTML(vRaw, attr)
            else if (attr.attr_type === 'AttrTime') yHTML = this.store.formatTimeHTML(vRaw, attr)
            else yHTML = this.store.formatCount ? this.store.formatCount(Math.abs(+vRaw) < 100 ? Math.round(+vRaw * 100) / 100 : Math.round(+vRaw)) : String(vRaw)
            ty.innerHTML = yHTML; ty.style.borderColor = color; ty.style.display = 'block'
            ty.style.top = Math.max(py - 9, 0) + 'px'
            const right = ax !== flex.axisY && (ax.position === wjChart.Position.Right || ax.position === 3)
            // тег лежит поверх подписей оси (вне области графика): правая ось — справа от линии оси, левая — слева;
            // компактные оси — внутри области: у левой оси справа от линии, у правой — слева
            if (_compactY) { ty.style.right = 'auto'; ty.style.left = (right ? Math.max(pr.right - ty.offsetWidth - 3, 0) : pr.left + 3) + 'px' }
            else if (right) { ty.style.right = 'auto'; ty.style.left = Math.min(pr.right + 3, host.clientWidth - ty.offsetWidth) + 'px' }
            else { ty.style.right = 'auto'; ty.style.left = Math.max(pr.left - ty.offsetWidth - 3, 0) + 'px' }
            // маркер точки
            const dot = tags.dot
            dot.style.display = 'block'; dot.style.borderColor = color
            dot.style.left = (px - 5) + 'px'; dot.style.top = (py - 5) + 'px'
            // IE 2026 09 15 (заказ Игоря: селективные серии): бейдж точки с чекбоксом селектора — «[☐] серия: значение», как подпись
            // точки на карте; клик по чекбоксу — значение разреза серии в чипс стола (Alt — только оно)
            this.hoverBadgeShow(sr, px, py, color, vRaw, attr)
        },
        // ---- IE 2026 09 15 / ODOO-… (заказ Игоря: селективные серии) ----
        // серия разреза (binding «мера::значение») → измерение (series_dimension меры) и значение; селектор ставится, если у виджета
        // есть строка Selection → Fields по этому измерению с «Selector: Set» (или измерение в Set dimensions); Others — не значение
        seriesSel(sr) {
            const b = sr && sr.binding ? String(sr.binding) : ''
            const i = b.indexOf('::')
            if (i < 0) return null
            const a = this.attrs_by_binding?.[b] || {}
            const measure = a.series_binding || b.slice(0, i)
            const viewList = this.WIDGET?.record?.doc?.viewList || []
            const dim = this.attrs_by_binding?.[measure]?.series_dimension || this.store.fieldsNoHierarchy(viewList).find(f => f.binding === measure)?.series_dimension
            if (!dim) return null
            const params = this.WIDGET?.record?.doc?.params || {}
            const sf = (params.selection_fields || []).find(x => x && x.use !== false && x.binding === dim && x.selector_set)
            const fs = (params.fieldSelectors || []).find(x => x && x.binding === dim)
            if (!sf && !fs) return null
            const key = b.slice(i + 2)
            if (!key || /^(Others|__others__|other)$/i.test(key)) return null
            const field = this.store.fieldsNoHierarchy(viewList).find(f => f.binding === dim) || {}
            return { dim, key, title: a.series_raw_title || sr.name || key, segment: sf?.segment || field.relation_segment || '', fieldTitle: field.title || dim }
        },
        // строка чипса стола по измерению (как у карты: AttrChipWhere 'in' — та же, что у списка-селектора)
        seriesSelRow(dim) {
            const WHERE = this.store.WORKSPACES?.[this.WIDGET?.workspace]?.record?.doc?.params?.WHERE
            if (!Array.isArray(WHERE) || !dim) return null
            return WHERE.find(w => w && (w.leftValue || {}).value === dim && (w.condition || 'in') === 'in' && w.type !== 'selector_map_dimensions') || null
        },
        seriesSelKeys(dim) {
            const row = this.seriesSelRow(dim), out = new Set()
            if (!row || !row.use) return out
            for (const a of (row.attrs || [])) { const v = a?.rightValue?.value; if (v && typeof v !== 'object' && a.use !== false) out.add(String(v)) }
            return out
        },
        seriesSelSig() {
            const WHERE = this.store.WORKSPACES?.[this.WIDGET?.workspace]?.record?.doc?.params?.WHERE || []
            return this.seriesSelEpoch + '|' + WHERE.filter(w => w && (w.condition || 'in') === 'in' && w.leftValue).map(w => w.leftValue.value + ':' + (w.use ? 1 : 0) + ':' + (w.attrs || []).map(a => a?.rightValue?.value).join(',')).join(';')
        },
        // состояние для окна легенды: {on} у селективной серии, null — чекбокса нет
        legendSelState(s) {
            const sr = (this.flex?.series || []).find(x => x && x.binding === s?.binding)
            const sel = sr ? this.seriesSel(sr) : null
            return sel ? { on: this.seriesSelKeys(sel.dim).has(String(sel.key)), title: sel.title } : null
        },
        onLegendSeriesSelect(s, alt) {
            const sr = (this.flex?.series || []).find(x => x && x.binding === s?.binding)
            if (sr) this.seriesSelToggle(sr, !!alt)
        },
        // клик по чекбоксу: добавить / снять значение в чипсе стола; Alt — оставить только его (запись стола не сохраняется —
        // чипс живёт в params.WHERE сессии, как отбор из списка-селектора / карты)
        seriesSelToggle(sr, exclusive) {
            const s = this.seriesSel(sr)
            if (!s) return
            const WORKSPACE = this.store.WORKSPACES?.[this.WIDGET?.workspace]
            const params = WORKSPACE?.record?.doc?.params
            if (!params) return
            const WHERE = params.WHERE = params.WHERE || []
            let row = this.seriesSelRow(s.dim)
            if (!row) {
                row = {
                    use: true, attr_type: 'AttrChipWhere', condition: 'in',
                    widget: this.WIDGET.widget, 'widget-segment': this.WIDGET.record?.segment || 'WIDGET-LIST',
                    leftValue: { value: s.dim, valueStr: s.fieldTitle, attr_type: 'AttrLink', component: 'AttrLink', valueStr_fix: true, relation_segment: '' },
                    rightValue: { pi: 'pi pi-arrow-right', value: '', valueStr: '', attr_type: 'AttrLink', component: 'AttrLink', relation_segment: s.segment || '' },
                    attrs: [],
                }
                WHERE.push(row)
            }
            const seg = row.rightValue?.relation_segment || s.segment || ''
            const current = [...this.seriesSelKeys(s.dim)]
            const key = String(s.key)
            let next
            if (exclusive) next = (current.length === 1 && current[0] === key) ? [] : [key]
            else next = current.includes(key) ? current.filter(k => k !== key) : [...current, key]
            const titleOf = (k) => k === key ? s.title : ((this.flex?.series || []).map(x => this.seriesSel(x)).find(x => x && String(x.key) === k)?.title || k)
            const mkRow = (k) => ({
                use: true,
                leftValue: { pi: '', value: '', valueStr: '', attr_type: 'AttrLink', component: 'AttrLink', hideTitle: true, relation_segment: '' },
                rightValue: { pi: 'pi pi-arrow-right', value: k, valueStr: titleOf(k), attr_type: 'AttrLink', component: 'AttrLink', relation_segment: seg },
            })
            const kept = (row.attrs || []).filter(a => a?.rightValue?.value && next.includes(String(a.rightValue.value)))
            const keptIds = new Set(kept.map(a => String(a.rightValue.value)))
            row.attrs = [...kept, ...next.filter(k => !keptIds.has(k)).map(mkRow)]
            row.use = row.attrs.length > 0
            this.seriesSelEpoch++
            this.store.workspace_applySelector(this.WIDGET.workspace, this.WIDGET.page, this.WIDGET)
            this.$refs.legendCmp?.invalidate?.()
            this.hoverBadgeRefresh()
        },
        hoverBadgeEl() {
            let el = this._hoverBadgeEl
            if (!el || !el.isConnected) {
                el = this._hoverBadgeEl = document.createElement('div')
                el.className = 'chart-hover-badge'
                el.style.display = 'none'
                el.addEventListener('mousedown', (e) => e.stopPropagation())
                el.addEventListener('mouseenter', () => this.hoverBadgeKeep())
                el.addEventListener('click', (e) => {
                    e.stopPropagation(); e.preventDefault()
                    const sr = this._hoverBadgeSr
                    if (sr && e.target.closest('.chart-hover-badge-check')) this.seriesSelToggle(sr, !!e.altKey)
                })
                this.flex?.hostElement?.appendChild(el)
            }
            return el
        },
        hoverBadgeShow(sr, px, py, color, vRaw, attr, side) {   // IE 2026 09 27 / ODOO-… (заказ Игоря: вариант A наведения на серии): side 'left' — слева от точки (справа плашка)
            const s = this.seriesSel(sr)
            if (!s) { this.hoverBadgeHide(); return }
            const el = this.hoverBadgeEl()
            this.hoverBadgeKeep()
            this._hoverBadgeSr = sr
            const esc = (t) => String(t ?? '').replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]))
            const on = this.seriesSelKeys(s.dim).has(String(s.key))
            let val = ''
            if (vRaw !== null && vRaw !== undefined && vRaw !== '') {
                val = attr?.attr_type === 'AttrTime' ? this.store.formatTimeHTML(vRaw, attr) : attr?.attr_type === 'AttrDays' ? this.store.formatDaysHTML(vRaw, attr) : this.store.formatCount(vRaw)
            }
            // IE 2026 09 23 / ODOO-341407: i18n — подсказка чекбокса бейджа
            el.innerHTML = `<i class="pi chart-hover-badge-check ${on ? 'pi-check-square' : 'pi-stop'}" title="${this.t('Click — add / remove «{title}» in the {field} selector · Alt+click — only it', { title: esc(s.title), field: esc(s.fieldTitle) })}"></i><span class="chart-hover-badge-name">${esc(s.title)}:</span><b>${val}</b>`
            // U6 (заказ Игоря: объяснение элементов по Alt): объяснение — на самом бейдже (элемент создаётся один раз); значок-чекбокс внутри пересоздаётся
            // на каждой точке — регистрация подсказки на нём копилась бы в общем инстансе подсказок wijmo; нативная подсказка значка остаётся
            uiHelp.bind(el, { key: 'chart.line.hoverBadge.check', state: () => (on ? 'on' : 'off') })
            el.style.display = 'inline-flex'; el.style.borderColor = color
            const host = this.flex.hostElement
            el.style.left = '0px'; el.style.top = '0px'
            const w = el.offsetWidth, h = el.offsetHeight
            let left = px + 12
            if (side === 'left' && px - 12 - w >= 4) left = px - 12 - w   // IE 2026 09 27 / ODOO-… (заказ Игоря: вариант A наведения на серии)
            if (left + w > host.clientWidth - 4) left = Math.max(4, px - 12 - w)
            const top = Math.max(2, Math.min(host.clientHeight - h - 2, py - h / 2))
            el.style.left = left + 'px'; el.style.top = top + 'px'
        },
        hoverBadgeKeep() { if (this._hoverBadgeT) { clearTimeout(this._hoverBadgeT); this._hoverBadgeT = null } },
        // «мостик» точка → бейдж: объединение точки (±10 px) и бейджа с полем 6 px — внутри него наведение не переключается
        hoverBadgeBridge(e) {
            const el = this._hoverBadgeEl, pt = this._hoverPt, host = this.flex?.hostElement
            if (!el || el.style.display === 'none' || !pt || !host) return false
            const hr = host.getBoundingClientRect(), br = el.getBoundingClientRect()
            const px = hr.left + pt.px, py = hr.top + pt.py
            const l = Math.min(px - 10, br.left) - 6, r = Math.max(px + 10, br.right) + 6, t = Math.min(py - 10, br.top) - 6, b = Math.max(py + 10, br.bottom) + 6
            return e.clientX >= l && e.clientX <= r && e.clientY >= t && e.clientY <= b
        },
        hoverBadgeHideSoon() { this.hoverBadgeKeep(); this._hoverBadgeT = setTimeout(() => { this._hoverBadgeT = null; this.hoverBadgeHide() }, 350) },
        hoverBadgeHide() { if (this._hoverBadgeEl) this._hoverBadgeEl.style.display = 'none'; this._hoverBadgeSr = null },
        hoverBadgeRefresh() {
            const sr = this._hoverBadgeSr, el = this._hoverBadgeEl
            if (!sr || !el || el.style.display === 'none') return
            const s = this.seriesSel(sr), on = !!s && this.seriesSelKeys(s.dim).has(String(s.key))
            const i = el.querySelector('.chart-hover-badge-check')
            if (i) { i.classList.toggle('pi-check-square', on); i.classList.toggle('pi-stop', !on) }
        },
        // IE 2026 09 13 / ODOO-5800 (замечание Игоря): подпись оси X, отвечающая точке i (px — её x в чарте). Текст подписи — из
        // itemsSource оси (категорийная ось дат: value = индекс строки, text = месяц / день / неделя); среди подписей с этим
        // текстом («May» есть в каждом году) берётся ближайшая к px по точке деления: горизонтальная подпись — середина,
        // наклонная вверх-вправо (wijmo rotate(-45) вокруг центра подписи) — её правый край у деления, вниз-вправо — левый,
        // вертикальная — центр поворота. null — подписи нет (прорежена, ось без itemsSource) → тег с датой
        hoverAxisXLabel(flex, i, px) {
            try {
                const axX = flex?.axisX
                const host = flex?.hostElement
                const gx = host?.querySelector('.wj-axis-x')
                if (!gx || !axX || i == null || !Number.isFinite(px)) return null
                const src = axX.itemsSource
                if (!src || !src.length) return null
                const it = src.find(x => x && x.value === i)
                let want = it ? String(it.text ?? '').trim() : ''
                if (!want && this.axisXMainRow_rect(flex)) want = this.axisXMainRow_label(this.data?.[i])   // IE 2026 09 23 / ODOO-5800: подписи своей оси под главным рядом (у штатной текст пуст)
                if (!want) return null
                let tol = 4
                try { const nx = axX.convert(i + 1); if (Number.isFinite(nx)) tol = Math.max(4, Math.abs(nx - px) / 2) } catch (e) { tol = 4 }
                const hr = host.getBoundingClientRect()
                let best = null
                for (const t of host.querySelectorAll('.wj-axis-x text')) {   // IE 2026 09 23 / ODOO-5800: и группа своей оси под главным рядом (cell-chart-axis-x)
                    if ((t.textContent || '').trim() !== want) continue
                    const g = t.parentNode
                    const m = (g && g.tagName && g.tagName.toLowerCase() === 'g') ? /rotate\(\s*([-\d.]+)\s*,\s*([-\d.]+)/.exec(g.getAttribute('transform') || '') : null
                    const ang = m ? parseFloat(m[1]) : 0
                    const r = t.getBoundingClientRect()   // с учётом поворота
                    let cx
                    if (!m || Math.abs(ang) < 1) cx = (r.left + r.right) / 2 - hr.left
                    else if (Math.abs(Math.abs(ang) - 90) < 1) cx = parseFloat(m[2])
                    else if (ang < 0) cx = r.right - hr.left
                    else cx = r.left - hr.left
                    if (!Number.isFinite(cx)) continue
                    const d = Math.abs(cx - px)
                    if (d <= tol && (!best || d < best.d)) best = { el: t, d }
                }
                return best ? best.el : null
            } catch (e) { return null }
        },
        // выделение подписи оси X: класс (жирный) + рамка <rect> в том же родителе (у повёрнутой — внутри её <g>, рамка
        // поворачивается вместе с текстом); el = null — снять. Перерисовка чарта пересоздаёт подписи — выделение вернётся на
        // следующем движении мыши
        hoverXLabelMark(el, color) {
            const prev = this._hoverXLabelEl
            if (prev && prev !== el) {
                try { prev.classList.remove('chart-hover-xlabel') } catch (e) { /* подпись уже пересоздана */ }
            }
            if (!el || prev !== el) {
                try { if (this._hoverXLabelBox) this._hoverXLabelBox.remove() } catch (e) { /* уже удалена */ }
                this._hoverXLabelBox = null
            }
            this._hoverXLabelEl = el || null
            if (!el || !el.parentNode) return
            try {
                el.classList.add('chart-hover-xlabel')
                let box = this._hoverXLabelBox
                if (!box || !box.isConnected) {
                    box = this._hoverXLabelBox = document.createElementNS('http://www.w3.org/2000/svg', 'rect')
                    box.setAttribute('class', 'chart-hover-xlabel-box')
                    el.parentNode.insertBefore(box, el)
                }
                const bb = el.getBBox()   // уже жирным
                box.setAttribute('x', (bb.x - 4).toFixed(1)); box.setAttribute('y', (bb.y - 1).toFixed(1))
                box.setAttribute('width', (bb.width + 8).toFixed(1)); box.setAttribute('height', (bb.height + 2).toFixed(1))
                box.setAttribute('rx', '3'); box.setAttribute('ry', '3')
                box.style.stroke = color || '#444'
            } catch (e) {
                try { if (this._hoverXLabelBox) this._hoverXLabelBox.remove() } catch (e2) { /* */ }
                this._hoverXLabelBox = null
            }
        },
        getSelectionWorkspace_date() {
            // IE 2026 09 15 / ODOO-… (заказ Игоря: чипс периода): селектор периода подсвечивает интервал чипса, чужие выделения не берёт
            if (this.store?.periodSel_has?.(this.WIDGET)) { if (this.isVisible && this.data?.length) this.periodSel_highlight(); return }
            if (!this.isVisible || !this.data?.length) return
            // при смене базы activeWORKSPACE обнуляется, а виджет прежней базы ещё может
            // получить вызов (observer/broadcast) — читать selectionWorkspace не с чего
            if (!this.store.activeWORKSPACE) return
            let WORKSPACE = this.store.activeWORKSPACE,
                selectedDates = WORKSPACE.selectionWorkspace?.selectedDates
            // IE 2026 08 18 / ODOO-4997: период принимаем только при 'date' в Get fields
            if (selectedDates && this.attr.getSelectionWorkspace_date && this.store.selDate_ok(this.WIDGET, 'get')) {
                const flex = this.flex
                if (!flex?.axisX?.actualMax) {
                    return
                }
                    
                let date1, date2, date3
                if (selectedDates.col1?.date <= selectedDates.col2?.date) {
                    date1 = selectedDates.col1?.date
                    date2 = selectedDates.col2?.date
                    date3 = selectedDates.col2?.date_next || selectedDates.col2?.date
                } else {
                    date1 = selectedDates.col2?.date
                    date2 = selectedDates.col1?.date
                    date3 = selectedDates.col1?.date_next || selectedDates.col1?.date
                }

                let i1 = this.dateToDataIndex(date1),
                    i2 = this.dateToDataIndex(date2, i1),
                    i3 = this.dateToDataIndex(date3, i2)
                
                this.setSelection(i1, i2, i3, true, 1)
            }
        },
        // IE 2026 09 15 / ODOO-… (заказ Игоря: чипс периода): виджет-селектор периода подсвечивает интервал чипса периода стола
        periodSel_highlight() {
            const p = this.store.periodSel_get(this.WIDGET.workspace)
            if (!p?.from || !this.flex?.axisX?.actualMax || !this.data?.length) return
            const clamp = (i) => Math.min(this.data.length - 1, Math.max(0, i == null ? 0 : i))
            const i1 = clamp(this.dateToDataIndex(p.from)), i2 = clamp(this.dateToDataIndex(p.to || p.from, i1))
            this.setSelection(i1, i2, i2, true, 1)
        },
        setSelection(i1, i2, i3, isFrom_selectionWorkspace=false, timeout=20) {
            if (this.setSelection_timeout) {
                clearTimeout(this.setSelection_timeout)
            }
            this.setSelection_timeout = setTimeout(() => {
                this.setSelection_afterTimeout(i1, i2, i3, isFrom_selectionWorkspace)
                this.setSelection_timeout = null
            }, timeout)
        },
        setSelection_afterTimeout(i1, i2, i3, isFrom_selectionWorkspace) {
            const flex = this.flex,
                padding = 20

            let xMin = flex.axisX.actualMin.valueOf(),
                xMax = flex.axisX.actualMax.valueOf(),
                yMin = flex.axisY.actualMin,
                yMax = flex.axisY.actualMax,
                
                // if axisY is hidden
                flex_rect = flex.hostElement.getBoundingClientRect(),
                plotArea_rect = flex.hostElement.querySelector('.wj-plot-area').getBoundingClientRect(),
                ptMin0 = flex.pageToControl(plotArea_rect.left, plotArea_rect.top),
                ptMax0 = flex.pageToControl(plotArea_rect.right, plotArea_rect.bottom)

            let ptMin = flex.dataToPoint(xMin, yMin),
                ptMax = flex.dataToPoint(xMax, yMax)

            if (i1 > i2) {
                let temp = i1
                i1 = i2
                i2 = i3 = temp
            }
            
            let x1
            if (i1 === null || i1 < 0) {
                x1 = ptMin.x - padding
            } else if (i1 >= this.data.length) {
                x1 = ptMax.x + padding
            } else if (i1 - 1 < 0) {
                let pt1 = flex.dataToPoint(this.dataIndexToDate(i1), yMin)
                x1 = pt1.x
            } else {
                // x1 = middle(i1-1, i1)
                let pt10 = flex.dataToPoint(this.dataIndexToDate(i1-1), yMin),
                    pt11 = flex.dataToPoint(this.dataIndexToDate(i1), yMin)
                    
                x1 = (pt10.x + pt11.x) / 2
            }
            
            let x2
            if (i2 === null || i2 < 0) {
                x2 = ptMin.x - padding
            } else if (i2 >= this.data.length) {
                x2 = ptMax.x + padding
            } else if (i2 === this.data.length-1) {
                let pt2 = flex.dataToPoint(this.dataIndexToDate(i2), yMin)
                x2 = pt2.x
            } else if (i3 >= this.data.length) {
                x2 = ptMax.x + padding
            } else if (i2 === i3) {
                // x2 = middle(i2, i2+1)
                let pt20 = flex.dataToPoint(this.dataIndexToDate(i2), yMin),
                    pt21 = flex.dataToPoint(this.dataIndexToDate(i2+1), yMin)
                    
                x2 = (pt20.x + pt21.x) / 2
            } else  {
                // x2 = middle(i3-1, i3)
                let pt30 = flex.dataToPoint(this.dataIndexToDate(i3-1), yMin),
                    pt31 = flex.dataToPoint(this.dataIndexToDate(i3), yMin)
                    
                x2 = (pt30.x + pt31.x) / 2
            }
            
            this.drawSelection(x1, x2, ptMin0.y, ptMax0.y)
            this.selectionChanged(this.data[i1], this.data[i2], isFrom_selectionWorkspace)
        },
        drawSelection(x1, x2, y1, y2) {
            const marging = 10
            
            this.removeSelection()

            // IE 2026 09 15 (замечание Игоря): при компактных осях область графика прижата к краю холста — верхняя грань рамки
            // (на 10 px выше области) уходила за холст и не рисовалась; рамка держится внутри холста с отступом 2 px
            const hostH = this.flex.hostElement ? this.flex.hostElement.clientHeight : Infinity
            const top = Math.max(2, Math.min(y1, y2) - marging), bottom = Math.min(hostH - 2, Math.max(y1, y2) + marging)
            this.mouseSelecting.rect = this.flex.renderEngine.drawRect(
                Math.min(x1, x2) - marging, top, 
                Math.abs(x1 - x2) + 2*marging, Math.max(4, bottom - top),
                'chart-zone-selected' // className
            )
            this.mouseSelecting.rect.setAttribute("rx", 5)
            this.mouseSelecting.rect.setAttribute("ry", 5)
        },
        removeSelection() {
            if (this.mouseSelecting.rect?.parentNode) {
                this.mouseSelecting.rect.parentNode.removeChild(this.mouseSelecting.rect)
            }
            this.mouseSelecting.rect = null
        },
        selectionChanged(data1, data2, isFrom_selectionWorkspace) {
            if (this.isLegendPanelShown()) this.legendSyncToSelection()
            // IE 2026 08 18 / ODOO-4997: период отдаём только при 'date' в Set fields
            if (!isFrom_selectionWorkspace && this.attr.setSelectionWorkspace_date && this.store.selDate_ok(this.WIDGET, 'set')) {
                this.store.setSelectionWorkspace_date(this.WIDGET,{
                    selectedDates: {
                        col1: data1, 
                        col2: data2, 
                    }
                })
            }
        },

        //---------------------------------
        dataIndexToDate(i) {
            if (this.bindingX_type === 'wijmo.Globalize.parseDate') {
                const date = new Date(this.data[i].date)
                return date.getTime()
            } else {
                return i
            }
        },
        dateToDataIndex(date, i0=0) {
            if (!this.data?.length || !this.data[0].date) {
                return null
            }

            for (let i = Math.max(0, i0); i < this.data.length; i++) {
                if (date < this.data[i].date) {
                    return i - 1
                } else if (date === this.data[i].date) {
                    return i
                }
            }

            return this.data.length + 1
        },
        dateToIndex(dateStr) {
            const target = new Date(dateStr).getTime()
            const data = this.data
            if (!data.length) return 0
            // Неразбираемая дата (NaN) не сравнивается ни с чем, поэтому раньше проваливалась
            // до `return data.length - 1` — зона получала второй угол на ПОСЛЕДНЕЙ точке и
            // молча заливала весь график до конца горизонта (ODOO-4615). Возвращаем NaN:
            // drawAlarmZone такую зону просто не нарисует (там уже есть guard !isNaN).
            if (isNaN(target)) return NaN
            const first = new Date(data[0].date).getTime()
            const last = new Date(data[data.length - 1].date).getTime()
            if (target <= first) return 0
            if (target >= last) return data.length - 1
            for (let i = 0; i < data.length - 1; i++) {
                const t0 = new Date(data[i].date).getTime()
                const t1 = new Date(data[i + 1].date).getTime()
                if (target >= t0 && target <= t1) {
                    const frac = (t1 !== t0) ? (target - t0) / (t1 - t0) : 0
                    return i + frac
                }
            }
            return data.length - 1
        },
        drawAlarmZone(flex, engine, x1, y1, x2, y2, cssClass, style, marging=10, rx=5, ry=5) {
            if (!isNaN(x1) && !isNaN(y1) && !isNaN(x2) && !isNaN(y2)) {
                style = typeof style === 'string' ? this.store.normalizeStyle(style) : style
                let pt1 = flex.dataToPoint(x1, y1),
                    pt2 = flex.dataToPoint(x2, y2),
                    rect = engine.drawRect(
                        Math.min(pt1.x, pt2.x) - marging, Math.min(pt1.y, pt2.y) - marging,
                        Math.abs(pt2.x - pt1.x) + 2*marging, Math.abs(pt2.y - pt1.y) + 2*marging,
                        cssClass,
                        style,
                        // {
                            // fill: 'l(0,0,0,1)#ffffff-#4DD0E1',      // вертикальный градиент (top→bottom)
                        //     fill: 'rgba(244, 67, 54, 0.2)', // красная зона с прозрачностью
                        //     stroke: 'rgba(244, 67, 54, 0.8)', // более яркая граница
                        //     'stroke-width': 1
                        // }
                    )
                rect.setAttribute("rx", rx)
                rect.setAttribute("ry", ry)
                /*stroke-linejoin: round;*/
            }
        },
        // ODOO-4646: chart_down-серия отрисована производным __down-ключом —
        // значение зеркалено в минус ради нижнего стека. Пользователю везде
        // (тултип, подпись точки, легенда) показываем ИСХОДНОЕ значение меры.
        // Снимаем зеркало, а НЕ берём модуль: законный отрицательный расход
        // (возврат, корректировка) обязан остаться отрицательным.
        chartDownUnmirror(binding, v) {
            if (v === null || v === undefined || v === '') return v
            if (typeof binding !== 'string' || !binding.endsWith('__down')) return v
            if (!this.attrs_by_binding?.[binding]?.chart_down) return v
            return -v
        },
        tooltipContent(hti) {
            let tooltip_attr = {},
                html = ''
            if (this.inlineTipOff && this.attr?.['tooltip-inline']) return ''   // IE 2026 10 22 / ODOO-5800 (Igor 22.10): форма легенды графика формы ячейки открыта — подсказки нет (пустое содержимое — wijmo прячет tooltip); значения — в легенде
            if (hti.item) {
                // IE 2026 09 24 / ODOO-5800 (форма ячейки, п. 2/5): 'tooltip-inline' у чарта — обычная всплывающая подсказка вместо окна строки
                // (у синтетического виджета формы ячейки / вкладки Analysis окна widget-row нет — подсказка была пустой)
                if (this.tooltip_widget === 'widget-row' && !this.attr?.['tooltip-inline']) {
                    if (!this.tooltip_widget_opened) return ''

                    const WRow = this.store.get_childrenWidget(this.WIDGET, 'widget-row')
                    if (!WRow || WRow._softClosed) {
                        this.tooltip_widget_opened = false
                        return ''
                    }

                    // IE 2026 09 23 / ODOO-341407: i18n
                    const action = { 'tooltip': this.t('Open line'), 'hotKey': 'Alt F2', 'action_name':'action-front-openLine-2024-11-30',command:'widget_open', 'widget':'widget-row', 'source_attr_type':'AttrChart', '_activate':true, 'get_currentRow':true, 'get_Parent':true, 'open_in_children_widget':true, 'cssClass':'pi p-button-white pi-pencil', source_name:this.attr.name, 'binding':this.attr.binding, attrs:this.attr.attrs }

                    const dataItem = hti.item
                    const iroot = this.store.iroot(dataItem, this.data)

                    const elementForm = document.getElementById(`WIDGET${this.widget_id}`);
                    const elementWidget_Rect = elementForm.getBoundingClientRect()

                    const elementFlex = document.getElementById(this.attr.html_id); //this.$refs.attr_chart
                    const elementFlex_Rect = elementFlex.getBoundingClientRect()

                    const plotRect = hti.chart._plotRect
                    const rect = hti.chart.hostElement.getBoundingClientRect();
                    const x0 = (rect.left + plotRect.left*0) - elementWidget_Rect.left
                    const y0 = (rect.top + plotRect.top*0) - elementWidget_Rect.top

                    const _anc = this.hitAnchor(hti)   // IE 2026 09 10 / ODOO-… (замечание Игоря): по оси самой серии
                    action.selectedRow = {
                        iroot,
                        dataItem,
                        x: x0 + _anc.x,
                        y: y0 + _anc.y
                    }

                    if (WRow.record._meta?.iroot !== iroot || WRow.record._meta?.binding !== this.attr.binding) {
                        this.store.executeStoreMethod(this.WIDGET.vueObj, action, this.attr)
                    }

                } else {
                    if ('date' in hti.item) {
                        let value = hti.item['date'],
                        text = value,
                        j = hti.pointIndex

                        if (!this.attr.data_schedule && this.chartDateGroupsNoSchedule_on() && chartDateGroups_tooltip(hti.item, this.freq)) {
                            text = chartDateGroups_tooltip(hti.item, this.freq)   // IE 2026 10 31 / ODOO-5800 (заказ Игоря): без расписания — подпись из даты самой строки, по шагу ряда
                        } else if (this.attr.data_schedule?.[j]) {
                            let rowDS = this.attr.data_schedule[j]
                            if (rowDS.freq === 'D') {
                                text = `${rowDS.date_Year} ${rowDS.date_Month} ${rowDS.date_Day}  ${rowDS.date_Week}`
                            } else if (rowDS.freq === 'W') {
                                text = `${rowDS.date_Year} ${rowDS.date_Month} ${rowDS.date_Week}`
                            } else if (rowDS.freq === 'M') {
                                text = `${rowDS.date_Year} ${rowDS.date_Month}`
                            } else if (rowDS.freq === 'A') {
                                text = `${rowDS.date_Year}`
                            }
                        }

                        tooltip_attr['date'] = value
                        // IE 2026 09 23 / ODOO-341407: i18n
                        html += `<div style="display: flex; justify-content: space-between;">
                                <b class='tooltip-text'>${this.t('Date:')}</b>
                                <b class='tooltip-text'> ${this.store.formatCount(text)}</b>
                            </div>
                        `
                    }
                    for (let series of this.flex.series) {
                        const attr = this.attrs_by_binding[series['binding']]
                        if (!attr.chart_hidden_tooltip) { // Visible series.visibility==0
                            // IE 2026 09 24 / ODOO-5800 (форма ячейки, п. 3.1): tooltip_binding у поля — значение подсказки берётся из другого поля строки
                            // (IN рисуется без истекающего прихода по IN_plot, а в подсказке — полный IN)
                            let key = series['name']||series['binding'],
                                value = this.chartDownUnmirror(series['binding'], hti.item[attr.tooltip_binding || series['binding']])

                            if (value||0 !== 0) {
                                tooltip_attr[key] = value

                                if (html) {
                                    // html += '</br>';
                                    html += '<div style="height: 5px;"></div>';
                                }
                                let style_stroke = 'white'
                                if (series.style && series.style.stroke) {
                                    style_stroke = series.style.stroke
                                }

                                let value_text
                                if (attr.tooltip_months_days) {
                                    // IE 2026 09 24 / ODOO-5800 (форма ячейки, п. 2/5: DOS в месяцах): значение — месяцы с одной десятичной, рядом дни из поля tooltip_months_days: «5.6 m (169 d)»
                                    const _d = hti.item[attr.tooltip_months_days]
                                    // IE 2026 09 24 / ODOO-341407: единицы и десятичный разделитель под язык интерфейса — шаблоном словаря целиком (en — как было)
                                    const _m = durNum(Math.round(Number(value) * 10) / 10)
                                    value_text = (_d != null && _d !== '' && Number.isFinite(Number(_d))) ? this.t('{m} m ({d} d)', { m: _m, d: Math.round(Number(_d)) }) : this.t('{m} m', { m: _m })
                                } else if (attr.attr_type === 'AttrDays') {
                                    value_text = this.store.formatDaysHTML(value, attr)
                                } else if (attr.attr_type === 'AttrTime') {
                                    value_text = this.store.formatTimeHTML(value, attr) // IE 2026 09 10 / ODOO-5800: DOS в секундах
                                } else {
                                    value_text = this.store.formatCount(value)
                                }

                                // style='line-height: 1.5;'
                                html += `<div style="display: flex; justify-content: space-between;">
                                        <b class='tooltip-header' style='color:${style_stroke};'><span class='tooltip-text' style='border-bottom: 2px solid ${style_stroke};'> ${key}:&nbsp;&nbsp;</span></b>
                                        <b class='tooltip-text' style='border-bottom: 2px solid ${style_stroke};'> ${value_text} <b class='tooltip-header' style='color:${style_stroke};'>■</b></b>
                                    </div>
                                `;
                            }
                        }
                    }
                }
            }

            return html // this.store.tooltip_html(tooltip_attr)
        },
        // ---- IE 2026 10 13 / ODOO-5800: клик по столбику (сегменту стопки) / дольке — селекторы стола по измерению категории (и серии разреза), как пузырь в режиме dims ----
        // true — клик обработан (селекторы поставлены / сняты); 'drill' — Shift: прежний клик с формой расшифровки; иначе — прежний клик
        chartSel_click(e, pie = false) {   // IE 2026 10 13 / ODOO-5800
            try {
                const fieldSelectors = this.WIDGET?.record?.doc?.params?.fieldSelectors
                const on = chartClickSel_on((k, d) => this.store?.setting?.(k, d))
                if (!on || !this.WIDGET?.vueObj || !chartClickSel_selectors(fieldSelectors).length) return false
                if (!pie && this.mouseSelecting && this.mouseSelecting.i1 !== this.mouseSelecting.i2 && !e?.shiftKey) return false   // протяжка по датам — выбор периода, как было
                const target = (e && !e.shiftKey && !e.altKey && !e.ctrlKey && !e.metaKey) ? (pie ? this.chartSel_pieTarget(e, fieldSelectors) : this.chartSel_target(e, fieldSelectors)) : null
                const WHERE = this.store.WORKSPACES?.[this.WIDGET.workspace]?.record?.doc?.params?.WHERE
                const d = chartClickSel_decide({ on, fieldSelectors, mobile: !!this.store?.mobileUi?.on, clickOpenRow: this.attr?.['click-open-row'] === true, event: e, target,
                    current: target ? chartClickSel_current(fieldSelectors, WHERE) : null })
                if (d !== 'select' && d !== 'clear') return d === 'drill' ? 'drill' : false
                const dd = this.store.dropdown
                if (dd && dd.visible && dd.chart_drill && dd._chartDrillOwner === this && !dd.pinned) { try { dd.hide() } catch (err) { /* формы нет */ } }   // своя форма расшифровки — закрыть
                // тот же путь, что флажок плашки пузыря (AttrBubbleChart.pickerToggle, режим dims): каналы fieldSelectors → строки WHERE стола → workspace_applySelector
                this.store.executeStoreMethod(this.WIDGET.vueObj, { command: 'onApplySelector__Click', selector_values: d === 'select' ? target.values : {} }, this.attr)
                return true
            } catch (err) { return false }
        },
        // столбик / сегмент / точка под курсором (chartDrill_hit) → цель: категория оси X + значение разреза серии
        chartSel_target(e, fieldSelectors) {   // IE 2026 10 13 / ODOO-5800
            const hit = this.chartDrill_hit(e)
            if (!hit || !hit.item) return null
            return chartClickSel_target({ fieldSelectors, xKey: this.attr?.axisX_bindingX2, item: hit.item, getValue: (r, b) => this.store.get_value(r, b),
                seriesBinding: hit.binding, seriesDim: this.chartSel_seriesDim(hit.binding) })
        },
        // series_dimension меры разрезной серии («мера::значение»), как в seriesSel
        chartSel_seriesDim(binding) {   // IE 2026 10 13 / ODOO-5800
            const b = binding ? String(binding) : '', i = b.indexOf('::')
            if (i < 0) return ''
            const measure = (this.attrs_by_binding?.[b] || {}).series_binding || b.slice(0, i)
            return this.attrs_by_binding?.[measure]?.series_dimension || this.store.fieldsNoHierarchy(this.WIDGET?.record?.doc?.viewList || []).find(f => f.binding === measure)?.series_dimension || ''
        },
        // долька под курсором → цель: категория дольки (bindingName, либо её основа без «_title» / «.title»)
        chartSel_pieTarget(e, fieldSelectors) {   // IE 2026 10 13 / ODOO-5800
            const fp = this.flexPie
            if (!fp) return null
            let ht = null
            try { ht = fp.hitTest(e) } catch (err) { ht = null }
            if (!ht || !ht.item || !(ht.pointIndex >= 0) || (Number.isFinite(ht.distance) && ht.distance > 2)) return null
            return chartClickSel_target({ fieldSelectors, xKey: this.pieNameAttr()?.binding, item: ht.item, getValue: (r, b) => this.store.get_value(r, b) })
        },
        pie_onClick(e) {   // IE 2026 10 13 / ODOO-5800: у дольки прежде клика не было — только селекторы (флаг выкл / нет каналов — ничего, как было)
            this.chartSel_click(e, true)
        },
        chart_onClick(e) {
            const _sel = this.chartSel_click(e)   // IE 2026 10 13 / ODOO-5800: клик по столбику / сегменту — селекторы стола; Shift+клик — прежняя форма расшифровки
            if (_sel === true) return   // IE 2026 10 13 / ODOO-5800
            // IE 2026 09 13 / ODOO-5800 (заказ Игоря): обычный клик по точке открывает окно легенды-расшифровки на дате точки
            // (окно строки Row — свободный виджет — заслоняло чарт и ходило на бэкенд), окно строки — по Alt+клику.
            // Чарт без сгруппированной легенды (окна легенды нет): обычный клик по-прежнему открывает окно строки.
            // Телефон — свой путь (chartTapValues ниже). Выкл: window.feSettings.set('fe.ux.chartClickLegend', false)
            let _clickLegend = true
            try { _clickLegend = this.store?.setting?.('fe.ux.chartClickLegend', true) !== false } catch (err) { _clickLegend = true }
            if (this.store.mobileUi?.on) _clickLegend = false
            // IE 2026 09 26 / ODOO-… (заказ Игоря: расшифровка кусочка графика): обычный клик по точке / блоку — форма расшифровки у кусочка (utils/chartDrillMixin.js; решение Игоря 27.09);
            // закрытое окно легенды сама больше не открывает — кнопка легенды и Alt+клик (прежний обычный клик ниже); выбор даты / периода — по нажатию мыши, как было
            const _drill = this.chartDrill_click(e, _sel === 'drill' ? { shift: true } : null)   // IE 2026 10 13 / ODOO-5800: при селекторах клика форма расшифровки — по Shift+клику
            // IE 2026 09 29 / ODOO-343341 (заказ Игоря: вкладка расшифровки в окне легенды): у графика с окном легенды клик по кусочку обработан вкладкой Breakdown окна легенды
            // (chartDrillMixin.chartDrill_tabClick: закрытое окно открыто, дата легенды — дата кусочка, привязка — к кусочку, расшифровка — во вкладке)
            if (_drill === 'tab') return
            const _altRow = _clickLegend && !!e?.altKey && !this.chartDrill_altLegacy()   // IE 2026 09 26 / ODOO-… (заказ Игоря: расшифровка кусочка графика): при форме расшифровки Alt+клик — прежний обычный клик (окно легенды)
            // IE 2026 09 16 (заказ Игоря): опция виджета «Click on a point opens the row widget» (по умолчанию выкл): вкл — клик по точке открывает
            // окно строки (открытое окно легенды при этом тоже переводится на дату точки), выкл — клик работает только с легендой
            const _openRow = this.attr?.['click-open-row'] === true
            if (_clickLegend && !_altRow && !_openRow && !_drill && this.isLegendGroupedActive() && !this.isLegendPanelShown()) {   // IE 2026 09 26 / ODOO-… (заказ Игоря: расшифровка кусочка графика): !_drill
                const htO = this.flex?.hitTest(e)
                // IE 2026 09 16 (замечание Игоря): hitTest wijmo отдаёт БЛИЖАЙШУЮ точку и по клику в пустом месте — закрытое окно легенды
                // открывать только по клику ПО точке / столбику (элемент серии под курсором или ≤ 10 px до точки)
                const onPoint = !!(e?.target?.closest?.('.wj-series-group')) || (Number.isFinite(htO?.distance) && htO.distance <= 10)
                if (onPoint && htO?.item && this.data.indexOf(htO.item) >= 0) {
                    this.legendPanelVisible = true
                    if (this.WIDGET) this.WIDGET._legendPanelVisible = true   // помнить выбор на виджете, как у кнопки легенды
                }
            }
            // ODOO-4440: открытая легенда работает расшифровкой — клик по точке
            // переводит её значения на дату этой точки (Alt+клик — окно строки, см. выше)
            if (!_altRow && this.isLegendPanelShown()) {
                const htL = this.flex?.hitTest(e)
                if (htL?.item) {
                    const i = this.data.indexOf(htL.item)
                    if (i >= 0) {
                        this.legendPointIndex = i
                        // якорь рыжей линии — ТОЧКА КЛИКА в координатах значений,
                        // ровно как у окна расшифровки (selectedRow в Row-ветке ниже)
                        try {
                            const wdiv = document.getElementById('WIDGET' + this.WIDGET.id)
                            const wr = wdiv.getBoundingClientRect()
                            const cr = htL.chart.hostElement.getBoundingClientRect()
                            const _ancL = this.hitAnchor(htL)   // IE 2026 09 10 / ODOO-… (замечание Игоря): по оси самой серии
                            this.legendAnchor = {
                                x: (cr.left - wr.left) + _ancL.x,
                                y: (cr.top - wr.top) + _ancL.y,
                            }
                        } catch (err) { this.legendAnchor = null }
                        this.$refs.legendCmp?.invalidate()
                        this.$nextTick(() => this.legendTetherUpdate())
                        // легенда и есть расшифровка — второй попап (widget-row) не открываем (кроме включённой опции click-open-row)
                        if (!_openRow) return
                    }
                }
            }
            // IE 2026 09 04 / ODOO-336291 (mobile UX): B-23 / B-29 / P-29 / P-30 chartTapValues — короткий тап по точке
            // на телефоне НЕ ходит на бэкенд за line-виджетом (замер 03.09: мутация 1233–1459 мс, отрисовка
            // 1464–2253 мс, API ~194 KB), а показывает значение локально. Drill-down остаётся: долгое нажатие
            // (mobChartTapInit ставит _mobLongPress) или кнопка «Open row» в пузырьке.
            // Выкл: window.mobileUi.set('chartTapValues', false)
            if (this.store.mobileUi?.on && this.store.mobileUi.chartTapValues !== false && !this._mobLongPress) {
                const shown = this.mobShowValue(e)
                window.mobTapDone?.('chartPoint') // IE 2026 09 04 / ODOO-336291 (mobile UX): P-31
                if (shown) return
            }
            this._mobLongPress = false
            // IE 2026 09 16 (заказ Игоря): окно строки по клику по точке — только при включённой опции виджета «Click on a point opens the row
            // widget» (viewParams.<chart>.click-open-row, по умолчанию выкл): расшифровка для пользователя — окно легенды
            if (this.tooltip_widget === 'widget-row' && _openRow) {
                const hti = this.flex.hitTest(e)
                if (hti.item) {
                    // IE 2026 09 23 / ODOO-341407: i18n
                    const action = { 'tooltip': this.t('Open line'), 'hotKey': 'Alt F2', 'action_name':'action-front-openLine-2024-11-30',command:'widget_open', 'widget':'widget-row', 'source_attr_type':'AttrChart', 'get_currentRow':true, 'get_Parent':true, 'open_in_children_widget':true, 'cssClass':'pi p-button-white pi-pencil', source_name:this.attr.name, 'binding':this.attr.binding, attrs:this.attr.attrs }

                    const dataItem = hti.item
                    const iroot = this.store.iroot(dataItem, this.data)

                    const elementForm = document.getElementById(`WIDGET${this.widget_id}`);
                    const elementWidget_Rect = elementForm.getBoundingClientRect()

                    const plotRect = hti.chart._plotRect
                    const rect = hti.chart.hostElement.getBoundingClientRect();
                    const x0 = (rect.left + plotRect.left*0) - elementWidget_Rect.left
                    const y0 = (rect.top + plotRect.top*0) - elementWidget_Rect.top

                    const _anc = this.hitAnchor(hti)   // IE 2026 09 10 / ODOO-… (замечание Игоря): по оси самой серии
                    action.selectedRow = {
                        iroot,
                        dataItem,
                        x: x0 + _anc.x,
                        y: y0 + _anc.y
                    }

                    this.store.executeStoreMethod(this.WIDGET.vueObj, action, this.attr)
                    this.tooltip_widget_opened = true
                }
            }
        },
        // ---- // IE 2026 10 12 / ODOO-343342 (заказ Игоря: правая кнопка на остальных элементах — график / узел карты) ----
        // правая кнопка по точке / столбику графика (contextmenu на хосте wijmo, setSelectoinListener) — то же, что обычный клик по кусочку (chart_onClick):
        // окно легенды с вкладкой Breakdown (chartDrill_tabClick: закрытое окно открывается, дата легенды и привязка — кусочек, расшифровка — во вкладке;
        // вкладку, как и при клике, выбирает пользователь); окно легенды без вкладки расшифровки (fe.ux.chartDrillTab = false и т. п.) — открыть и перевести
        // на дату точки, как прежний клик; окна легенды нет — форма расшифровки у кусочка, как клик. Мимо точек, круговая / AntFlow, поле ввода, выделенный текст,
        // телефон, выключатель fe.ux.contextMenuActions = false — не перехватывать (меню виджета Widget.hdrContextMenu / браузера). Счётчик window.ctxMenuActions.chartPoint
        ctxMenu_chart(e) {   // IE 2026 10 12 / ODOO-343342 (заказ Игоря: правая кнопка на остальных элементах — график / узел карты)
            if (!ctxMenu_allowed(this.store, e)) return
            if (!this.WIDGET || !this.flex || this.attr?.['tooltip-inline'] || this.isPieMode?.() || this.isAntMode?.()) return
            try {
                const openRow = this.attr?.['click-open-row'] === true   // опция «Click on a point opens the row widget»: клик идёт мимо вкладки (chartDrill_click) — и правая кнопка тоже; окно строки правой кнопкой не открывается
                if (!openRow && this.chartDrill_tabOn()) {
                    if (this.chartDrill_tabClick(e) !== 'tab') return   // мимо кусочков
                    e.preventDefault(); ctxMenu_count('chartPoint'); return
                }
                if (this.isLegendGroupedActive()) {
                    const ht = this.flex.hitTest(e)
                    const onPoint = !!(e.target?.closest?.('.wj-series-group')) || (Number.isFinite(ht?.distance) && ht.distance <= 10)   // как chart_onClick: только по точке
                    const i = onPoint && ht?.item ? this.data.indexOf(ht.item) : -1
                    if (i < 0) return
                    if (!this.isLegendPanelShown() && this.store.setting('fe.ux.chartClickLegend', true) === false) return   // клик закрытое окно не открывает — и правая кнопка тоже
                    e.preventDefault()
                    this.legendPanelVisible = true
                    this.WIDGET._legendPanelVisible = true   // помнить выбор на виджете, как у кнопки легенды
                    this.legendPointIndex = i
                    try {
                        const wr = document.getElementById('WIDGET' + this.WIDGET.id).getBoundingClientRect(), cr = ht.chart.hostElement.getBoundingClientRect(), a = this.hitAnchor(ht)
                        this.legendAnchor = { x: (cr.left - wr.left) + a.x, y: (cr.top - wr.top) + a.y }
                    } catch (err) { this.legendAnchor = null }
                    this.$refs.legendCmp?.invalidate?.()
                    this.$nextTick(() => this.legendTetherUpdate?.())
                    ctxMenu_count('chartPoint'); return
                }
                if (!openRow && this.chartDrill_on()) {
                    const hit = this.chartDrill_hit(e)
                    if (!hit) return
                    e.preventDefault()
                    const dd = this.store.dropdown
                    const same = dd && dd.visible && dd.chart_drill && dd._chartDrillOwner === this && dd.chart_drill.pointKey === hit.pointKey
                    if (!same) this.chartDrill_open(hit)   // форма уже на этом кусочке — не закрывать
                    ctxMenu_count('chartPoint')
                }
            } catch (err) { /* график в перестройке — меню виджета */ }
        },
        hitAnchor(hti) {
            // IE 2026 09 10 / ODOO-… (замечание Игоря): якорь линии-привязки (окно расшифровки Row / окно легенды) — точка в пикселях чарта
            // по оси САМОЙ серии: значение серии правой оси (DOS в секундах, 18 млн) пересчитывалось главной
            // осью 0…1,3 млн и уходило на тысячи px вверх — «привязка улетает в небеса»; серии главной оси
            // считались верно, отсюда «иногда хватает». Не-число (нет серии / значения) — точка попадания
            const ax = hti?.series?.axisY || hti.chart.axisY
            let x = hti.chart.axisX.convert(hti.x), y = ax.convert(hti.y)
            if (!Number.isFinite(x)) x = hti.point?.x ?? 0
            if (!Number.isFinite(y)) y = hti.point?.y ?? 0
            return { x, y }
        },
        seriesVisibilityChanged(set_selectedMeasures=true) {
            if (this.WIDGET.record?.params?.use_selectorMeasures) {
                if (set_selectedMeasures) {
                    let selectedMeasures = {}
                    for (let series of this.flex.series) {
                        selectedMeasures[series['binding']] = (series.visibility===0 || series.visibility===1) // Visible
                    }
                    this.store.use_selectorMeasures(this.WIDGET, selectedMeasures)
                } else {
                    this.store.use_selectorMeasures(this.WIDGET)
                }
            }
            for (let series of this.flex.series) {
                let attr = this.attrs_by_binding[series['binding']]
                if (attr.setVisibility_chartGroup) {
                    for (let series2 of this.flex.series) {
                        let attr2 = this.attrs_by_binding[series2['binding']]
                        if (attr2.chartGroup === attr.setVisibility_chartGroup) {
                            let visibility = 3 // Hidden
                            if (series.visibility==0) { // Visible
                                visibility = 1 // Plot
                            }
                            if (series2.visibility!=visibility) {
                                if (!this.store.hide_console) console.log(`seriesVisibilityChanged: ${series2['binding']}, ${visibility}`)
                                series2.visibility=visibility
                            }
                        }
                    }
                }
            }
            this.axisRangesRefresh()   // IE 2026 09 13 / ODOO-5800 (замечание Игоря): диапазоны осей — по показанным сериям
            this.axesUnused_hide()   // IE 2026 09 10 / ODOO-… (замечание Игоря): ось Y без показанных серий не рисуется
        },
        axesUnused_hide() {
            // IE 2026 09 10 / ODOO-… (замечание Игоря): универсальное правило — ось Y (основная, именованная «справа» вроде DOS в месяцах,
            // ось группы стека), к которой не привязана ни одна ПОКАЗАННАЯ серия (visibility Visible / Plot), не рисуется:
            // ни линия, ни подписи, ни заголовок, ни её сетка. Настроенное состояние оси запоминается при первом проходе
            // (_ieShown) и возвращается, когда её серия снова включена (легенда wijmo, панель легенды, Default visibility,
            // селектор мер страницы) — все пути идут через seriesVisibilityChanged
            const flex = this.flex
            if (!flex) return
            const used = new Set()
            for (const s of flex.series) if (s.visibility === 0 || s.visibility === 1) used.add(s.axisY || flex.axisY)
            const axes = new Set([flex.axisY])
            for (const s of flex.series) if (s.axisY) axes.add(s.axisY)
            for (const ax of axes) {
                if (!ax) continue
                if (!ax._ieShown) ax._ieShown = { axisLine: ax.axisLine, labels: ax.labels, title: ax.title, majorGrid: ax.majorGrid, minorGrid: ax.minorGrid }
                const want = used.has(ax) ? ax._ieShown : { axisLine: false, labels: false, title: '', majorGrid: false, minorGrid: false }
                for (const k of Object.keys(want)) if (ax[k] !== want[k]) ax[k] = want[k]
            }
        },
        axesUnused_restoreMain() {
            // IE 2026 09 10 / ODOO-… (замечание Игоря): основная ось живёт между пересборками серий — вернуть ей настроенное состояние
            // и забыть снимок, чтобы пересборка не запомнила «скрытую» ось как исходную
            const ax = this.flex?.axisY
            if (!ax?._ieShown) return
            const st = ax._ieShown
            ax._ieShown = null
            for (const k of Object.keys(st)) if (ax[k] !== st[k]) ax[k] = st[k]
        },
        //--------------------------------- ODOO-2734: иерархическая легенда ---------------------------------
        // Модель легенды: «группа → серии» в порядке КОНФИГА (viewList), не в порядке
        // отрисовки (z-порядок серий). Группа порождённой серии разреза = её мера-родитель
        // (series_binding), группа обычной меры = ближайший родительский узел attrs-дерева
        // с title. Серии вне групп собираются наверху без заголовка.
        // Не computed: настройки виджета (attr) правятся на raw-объекте стора мимо
        // vue-прокси, поэтому computed кэшируется и не пересчитывается; методы же
        // перевычисляются на каждом рендере (рендеры триггерятся реактивными данными).
        isLegendGrouped() { return !!this.attr?.['legend-grouped'] },
        isLegendPopup()   { return !!this.attr?.['legend-popup'] },
        // IE 2026 09 15 (замечание Игоря, вечер): ряд «Legend mode» снят — «Popup» стало значением Legend position (своё окно легенды
        // вместо легенды wijmo); легенде wijmo это значение не отдаём
        wjLegendPos() {
            if (this.isLegendGroupedActive()) return 'None'
            const p = this.attr?.['legend-position']
            // Popup, но своей легенде нечего показать (нет серий со значениями — пустая выборка, ODOO-4206) — легенда wijmo справа, чтобы
            // график не остался вовсе без легенды
            return p === 'Popup' ? 'Right' : p
        },
        // ODOO-4206: режим ДЕЙСТВУЕТ, только когда есть что показать в своей панели.
        // Без этого включение Grouped на чарте без групп гасило штатную легенду и не
        // давало взамен ничего — легенда пропадала совсем.
        isLegendGroupedActive() { return this.isLegendGrouped() && this.legendGroups.length > 0 },
        isLegendPanelShown() {
            // окно живёт в общем контейнере виджетов: без проверки активной страницы
            // оно оставалось видимым при переключении стола («улетела на другой стол»)
            if (this.WIDGET.page !== this.store.activeWORKSPACE?.activePAGE?.page) return false
            // IE 2026 09 20 / ODOO-… (Игорь: легенда закрывается вместе с виджетом и на вкладке, к которой не относится): виджет закрыт («мягко» — компонент ещё смонтирован) либо открыта вкладка, к которой
            // легенда не относится (не график и не панель полей этого виджета), — окна нет; признак «легенда открыта» при смене вкладки остаётся
            if (!this.legendOwner_shown()) return false
            // IE 2026 09 10 / ODOO-… (замечание Игоря): при первом открытии виджета окно легенды (панель — всегда свободное окно,
            // chart-legend-panel-popup) не показывать; открывается кнопкой легенды, выбор помнится на виджете
            // (переезд на другую страницу, перемонтирование). Прежнее поведение (в режиме Docked открыта сразу):
            // window.feSettings.set('fe.ux.chartLegendAutoOpen', true)
            let _auto = false
            try { _auto = this.store?.setting?.('fe.ux.chartLegendAutoOpen', false) === true } catch (e) { _auto = false }
            const _def = this.WIDGET?._legendPanelVisible ?? (_auto ? !this.isLegendPopup() : false)
            return this.isLegendGroupedActive() && (this.legendPanelVisible ?? _def)
        },
        // ODOO-4206: положение своей панели берём из того же 'legend-position', что и у
        // штатной легенды — иначе кнопки Left/Top/Right/Bottom видимы, но ни на что не влияют
        legendPanelPosClass() {
            const pos = String(this.attr?.['legend-position'] || 'Right').toLowerCase()
            return `chart-legend-pos-${['left','top','right','bottom'].includes(pos) ? pos : 'right'}`
        },
        buildLegendGroups() {
            if (!this.isLegendGrouped() || !this.flex) { this.legendGroups = []; return }
            // ODOO-4646: сама сборка — чистая функция (общая с баблом); группы
            // чарту нужны и ДО открытия панели (v-if кнопки легенды)
            this.legendGroups = buildLegendGroupsPure({
                series: this.flex.series,
                palette: this.flex.palette,
                rows: this.data,
                attrsByBinding: this.attrs_by_binding,
                tree: this.WIDGET.record?.doc?.viewList || this.attr.attrs,
                expanded: this.legendExpanded,
            })
        },
        onLegendSeriesToggle(item) {
            const series = this.flex.series.find(s => s.binding === item.binding)
            if (!series) return
            const visible = series.visibility === 0 || series.visibility === 1
            series.visibility = visible ? 2 : 0 // Legend <-> Visible, как штатный legendToggle
            this.seriesVisibilityChanged()
            this.buildLegendGroups()
        },
        onLegendGroupToggle(g, force) {
            // force (ODOO-4440, кнопки уровней): true = включить, false = погасить
            const target = force === true ? 0 : force === false ? 2
                : (g.series.some(s => !s.visible) ? 0 : 2) // включить все, иначе выключить все
            for (const item of g.series) {
                const series = this.flex.series.find(s => s.binding === item.binding)
                if (series && series.visibility !== target) series.visibility = target
            }
            this.seriesVisibilityChanged()
            this.buildLegendGroups()
        },
        onLegendGroupExpand(g) {
            // ODOO-4137: только раскрытие, видимость серий не трогаем — сценарий
            // «погасить группу целиком» и «посмотреть, что внутри» независимы
            this.legendExpanded = { ...this.legendExpanded, [g.key]: !g.expanded }
            this.buildLegendGroups()
        },
        onToggle_legendPanel() {
            this.legendPanelVisible = !this.isLegendPanelShown()
            if (this.WIDGET) this.WIDGET._legendPanelVisible = this.legendPanelVisible   // IE 2026 09 10 / ODOO-…: помнить выбор на виджете
            if (!this.legendPanelVisible) this.legendEdgeRemove()
            // чарт спозиционирован на периоде — легенда сразу с цифрами этого периода
            if (this.legendPanelVisible) {
                this.legendSyncToSelection()
            }
            this.$nextTick(() => this.legendTetherUpdate())
        },
        // IE 2026 09 13 / ODOO-5800 (замечание Игоря): разморозка (крестик у даты в заголовке колонки легенды) — снять и точку, и якорь клика,
        // иначе линия-привязка оставалась на старой точке
        onLegendPointReset() {
            this.legendPointIndex = null
            this.legendAnchor = null
            this.$nextTick(() => this.legendTetherUpdate())
        },
        legendSyncToSelection() {
            const i = this.mouseSelecting?.i1
            if (i === null || i === undefined || !this.data?.[i]) return
            if (this.mouseSelecting.i2 === i && this.chartDrill_legendPinned?.(i)) return   // IE 2026 09 29 / ODOO-343341 (заказ Игоря: вкладка расшифровки в окне легенды): легенда — на дате кликнутого кусочка (chartDrillMixin)
            this.legendPointIndex = i
            this.$nextTick(() => this.legendTetherUpdate())
        },
        //--------------------------------- ODOO-4440: легенда-расшифровка
        // пунктирная стрелка-привязка: от левого края окна к оси Y основного чарта
        legendPAGE() {
            return this.store.WORKSPACES?.[this.WIDGET.workspace]?.PAGES?.[this.WIDGET.page]
        },
        // стрелка-привязка легенды = страничное ребро (edges_svg), как у окна
        // расшифровки: рыжая пунктирная кривая, якорь — активная колонка чарта
        legendTetherUpdate() {
            const PAGE = this.legendPAGE()
            if (!PAGE?.vueObj) return
            const panel = this.$refs.legendCmp?.panelEl()
            if (!this.isLegendPanelShown() || !panel || !this.flex) { this.legendEdgeRemove(); return }
            const wdiv = document.getElementById('WIDGET' + this.WIDGET.id)
            const ch = this.flex.hostElement?.getBoundingClientRect()
            const wr = wdiv?.getBoundingClientRect()
            if (!wdiv || !ch || !wr) return
            const plot = this.flex._plotRect
            // якорь: точка клика (как у расшифровки); без зафиксированной точки — точка под курсором (IE 2026 09 13 / ODOO-5800,
            // замечание Игоря); иначе — колонка периода
            let ax = null, ay = null
            if (!this.isVisible || !this.flex.hostElement.offsetParent) {   // IE 2026 09 14: чарт скрыт — якорь в панели полей или без стрелки
                const fa = this.legendFieldAnchor(wdiv, wr)
                if (!fa) { this.legendEdgeRemove(); return }
                ax = fa.x; ay = fa.y
            } else if (this.legendAnchor) { ax = this.legendAnchor.x; ay = this.legendAnchor.y }
            else if (this.legendPointIndex == null && this._hvSnap && this.hoverValuesOn()) { ax = (ch.left - wr.left) + this._hvSnap.px; ay = (ch.top - wr.top) + (plot ? plot.top + 8 : 20) }   // IE 2026 09 27 / ODOO-… (заказ Игоря: вариант A наведения на серии): к вертикали даты
            else if (this.legendPointIndex == null && this._hoverPt) { ax = (ch.left - wr.left) + this._hoverPt.px; ay = (ch.top - wr.top) + this._hoverPt.py }
            if (ax == null) {
                let colX = plot ? plot.left + plot.width / 2 : ch.width / 2
                const i = this.legendPointIndex
                if (i != null && this.data?.[i]) {
                    try {
                        const xv = (this.bindingX_type === 'wijmo.Globalize.parseDate') ? this.dataIndexToDate(i) : i
                        const cx = this.flex.axisX.convert(xv)
                        if (Number.isFinite(cx)) colX = cx
                    } catch (e) { /* ось без convert — якорь в середине плота */ }
                }
                ax = (ch.left - wr.left) + colX
                ay = (ch.top - wr.top) + (plot ? plot.top + 8 : 20)
            }
            const key1 = 'legend-src-' + this.WIDGET.id, key2 = key1 + '-panel'
            const node1 = PAGE.nodes_svg[key1] = Object.assign(PAGE.nodes_svg[key1] || { edges_svg: {} }, {
                type: 'nodeRow', key: key1, widget_id: this.WIDGET.id, WIDGET: this.WIDGET,
                div: wdiv, join: 'x,y',
                x: ax, y: ay,
            })
            const node2 = PAGE.nodes_svg[key2] = Object.assign(PAGE.nodes_svg[key2] || { edges_svg: {} }, {
                key: key2, widget_id: this.WIDGET.id, WIDGET: this.WIDGET,
                div: panel, join: 'widget',
            })
            const edge_key = key1 + ';' + key2
            const edge = PAGE.edges_svg[edge_key] = PAGE.edges_svg[edge_key]
                || { type: 'edgeWidgetRow', key: edge_key, source_key: key1, target_key: key2 }
            node1.edges_svg[edge_key] = edge
            node2.edges_svg[edge_key] = edge
            PAGE.vueObj.refreshe_svg()
        },
        legendEdgeRemove() {
            const PAGE = this.legendPAGE()
            if (!PAGE?.vueObj) return
            const key1 = 'legend-src-' + this.WIDGET.id
            if (PAGE.nodes_svg[key1]) PAGE.vueObj.removeNode(key1)
            if (PAGE.nodes_svg[key1 + '-panel']) PAGE.vueObj.removeNode(key1 + '-panel')
        },
        // раскрытие групп пришло из компонента легенды (клик по шеврону /
        // Ctrl+клик «все»): ручной выбор пользователя главнее дефолтов
        onLegendExpandChanged(map) {
            this.legendExpanded = { ...this.legendExpanded, ...map }
            this.buildLegendGroups()
        },
        // выбранный диапазон периодов (зона на чарте): {i1, i2} или null
        legendRange() {
            const i1 = this.mouseSelecting?.i1, i2 = this.mouseSelecting?.i2
            if (i1 == null || i2 == null) return null
            const a = Math.min(i1, i2), b = Math.max(i1, i2)
            return b > a ? { i1: a, i2: b } : null
        },
        // IE 2026 09 12 / ODOO-… (замечание Игоря): Alt+drag строки легенды — поле серии переезжает перед/после поля целевой серии в дереве полей:
        // в конфиге записи (doc.viewList → запись изменена, Save) и в живых attrs чарта (серии перестраиваются — z-порядок
        // и строки легенды следуют за порядком полей). Разрезная серия ведёт к своей мере (series_binding)
        onLegendMoveField(s, target, before) {
            const ab = this.attrs_by_binding || {}
            const fieldOf = (x) => ab[x.binding]?.series_binding || ab[x.binding]?.binding || x.binding
            const bs = fieldOf(s), bt = fieldOf(target)
            if (!bs || !bt || bs === bt) return
            const rec = this.WIDGET.record
            const movedCfg = moveNodeInTree(rec?.doc?.viewList, bs, bt, before)
            const movedLive = moveNodeInTree(this.attr?.attrs, bs, bt, before)
            if (movedCfg) { const _meta = rec._meta = rec._meta || {}; _meta.modified = true }
            if (movedLive) this.load_data()
            this.buildLegendGroups()
        },
        onLegendSeriesSettings(s) {
            // переход к настройкам поля: открыть панель полей виджета и довести
            // до строки меры этой серии (разрезная серия ведёт к своей мере)
            const a = this.attrs_by_binding[s.binding]
            this.store.legend_goto_field = { binding: a?.series_binding || s.binding }
            this.store.set_activeAttr(this.WIDGET.view, { binding: 'doc.viewList' }, this.WIDGET)
            // IE 2026 09 14 / ODOO-5800 (замечание Игоря): при скрытых вкладках показать их — чтобы вернуться на чарт/отчёт
            if (this.WIDGET?.styleWidget?.hideTabs) this.WIDGET.styleWidget.show_hidden = true
        },
        // IE 2026 09 14 / ODOO-5800 (замечание Игоря): вкладка чарта скрыта (открыта панель полей) — стрелка легенды ведёт
        // не к точке чарта, а к выбранной строке поля в панели полей; строка легенды этой меры подсвечена
        legendFieldAnchor(wdiv, wr) {
            const sel = this.store.legend_field_selection
            if (!sel || sel.widget_id !== this.WIDGET?.id || !sel.binding) return null
            for (const host of wdiv.querySelectorAll('.wj-flexgrid')) {
                const grid = host['$WJ-CTRL']
                if (!grid || !host.offsetParent || !grid.rows) continue
                const rows = grid.rows
                for (let i = 0; i < rows.length; i++) {
                    if (rows[i]?.dataItem?.binding !== sel.binding) continue
                    const col = grid.columns.getColumn ? grid.columns.getColumn('title') : null
                    const cell = grid.cells.getCellElement(i, col ? col.index : 1)
                    if (!cell) return null
                    const cr = cell.getBoundingClientRect()
                    return { x: cr.right - wr.left, y: cr.top + cr.height / 2 - wr.top }
                }
            }
            return null
        },

        markerContent (ht) {
            if (ht.item) {
                this.mouseSelecting.pointIndex = ht._pointIndex
            }
        },
        handleVisibility(isVisible) {
            this.isVisible = isVisible
            this.legendOwner_onVisible(isVisible)   // IE 2026 09 20 / ODOO-… (Игорь: легенда закрывается вместе с виджетом и на вкладке, к которой не относится)
            // IE 2026 09 14 / ODOO-5800: вкладка чарта скрыта/показана — стрелка легенды и подсветка строки меры за выбором поля
            if (this.isLegendPanelShown()) {
                this.legendHoverBinding = isVisible ? null : (this.store.legend_field_selection?.widget_id === this.WIDGET?.id ? this.store.legend_field_selection.binding : null)
                this.$nextTick(() => this.legendTetherUpdate())
            }
            if (isVisible) {
                if (this.attr.getSelectionWorkspace_date){
                    this.WIDGET.getSelectionWorkspace_date = this.getSelectionWorkspace_date
                }
                // IE 2026 09 01 / ODOO-5884: пирог при показе тоже перечитывает данные
                if (this.flex || this.flexPie) {
                    this.$nextTick(() => this.content_Changed())
                } else {
                    this.attrResize()
                }
            }
        },
        
        // IE 2026 09 20 / ODOO-… (Игорь: легенда закрывается вместе с виджетом и на вкладке, к которой не относится): признак «легенда открыта», её закрытие и «своя» вкладка кроме холста — панель полей
        legendOwner_flagOn() { return !!(this.legendPanelVisible ?? this.WIDGET?._legendPanelVisible) },
        legendOwner_close() { this.legendPanelVisible = false; if (this.WIDGET) this.WIDGET._legendPanelVisible = false; this.legendEdgeRemove() },
        legendOwner_related() { return true },
        //---------------------------------
        onToggle_chartSettings() {
            const vueObj = this
            const WRow = vueObj.store.get_childrenWidget(vueObj.WIDGET, 'widget-row')
            if (WRow && !WRow._softClosed && WRow.parentAction?.type === 'widget-row-viewParams' && WRow.record?._meta?.binding === this.attr.binding) {
                vueObj.store.widget_close(WRow.id)
                return
            }
            const cogEl = this.$refs.cogButton
            const widgetEl = document.getElementById('WIDGET' + vueObj.WIDGET.id)
            let x, y
            if (cogEl && widgetEl) {
                const cr = cogEl.getBoundingClientRect()
                const wr = widgetEl.getBoundingClientRect()
                x = cr.left - wr.left + cr.width / 2
                y = cr.top - wr.top + cr.height / 2
            }
            const actionMenu = {
                command: 'widget_open',
                'widget': 'widget-row',
                'type': 'widget-row-viewParams',
                'source_attr_type': 'AttrChart',
                '_activate': true,
                'binding': vueObj.attr.binding,
                'source_name': vueObj.attr.name,
                'get_Parent': true,
                'open_in_children_widget': true,
                'widgetRow_params': {
                    'top_pct': 0.2,
                    'left_pct': 0.2,
                    'width_pct': 0.8,
                    'height_pct': 0.8,
                },
                ...(x != null ? { selectedCog: { x, y } } : {}),
            }
            this.show_commandPanel_topLeft = false
            vueObj.store.executeStoreMethod(vueObj.WIDGET.vueObj, actionMenu, vueObj.attr)
        },
        onShow_commandPanel_topLeft(event) {
            if (this.timerId_onShow_commandPanel_topLeft) {
                clearTimeout(this.timerId_onShow_commandPanel_topLeft)
            }
            this.timerId_onShow_commandPanel_topLeft = setTimeout(() => {
                const WRow = this.store.get_childrenWidget(this.WIDGET, 'widget-row')
                if (WRow && !WRow._softClosed && WRow.parentAction?.type === 'widget-row-viewParams' && WRow.record?._meta?.binding === this.attr.binding) {
                    return
                }
                if (this.store.mouse_isInside(event.target)) {
                    this.set_commandsActive()
                    this.show_commandPanel_topLeft = true
                }
            }, 700)
        },
        onClose_commandPanel_topLeft(event) {
            if (this.timerId_onShow_commandPanel_topLeft) {
                clearTimeout(this.timerId_onShow_commandPanel_topLeft)
            }
            this.timerId_onShow_commandPanel_topLeft = setTimeout(() => {
                this.show_commandPanel_topLeft = false
            }, 200)
        },
        set_commandsActive() {
            if (!this.commandPanel_topLeft.length) {
                // IE 2026 09 23 / ODOO-341407: i18n — подписи и подсказки быстрых настроек чарта (checkValue / default — значения, не переводятся)
                let action_afterChange = { 'tooltip': this.t('Update data'), 'command': 'executeWidgetMethod', 'method': 'select', 'record_sendToBackend_exclude': ['_doc'], 'cssClass':'pi p-button-white pi-sync' }
                // IE 2026 09 15 (замечание Игоря, вечер): запись со своей легендой (legend-grouped) — показать её как Legend position = Popup (без пометки modified)
                if (this.isLegendGrouped() && this.attr?.['legend-position'] !== 'Popup') this.store.set_viewParam(this.WIDGET, this.attr.name, 'legend-position', 'Popup', this.attr, false)
                this.commandPanel_topLeft = [
                    [
                        {'attr_type':'AttrLabel', title:this.t('Frequency:'), cssClass:'mr-2'},
                        // {'binding':`doc.viewParams.dataSheet-freq.use`, checkValue:true, default:false, 'showCommandTitle':true, 'title': this.t('Show frequency selection'), 'command':'set_viewParam', 'cssClass':'pi p-button-white p-button-border mr-1'},
                        {'binding':`doc.params.freq`, checkValue:'G', default:'G', defaultValue:'G', 'showCommandTitle':true, 'title': this.t('Multiple'), 'command':'set_viewParam', 'cssClass':'pi p-button-white p-button-border mr-1', action_afterChange},
                        {'binding':`doc.params.freq`, checkValue:'A', default:'G', 'showCommandTitle':true, 'title': this.t('Year'), 'command':'set_viewParam', 'cssClass':'pi p-button-white p-button-border mr-1', action_afterChange},
                        {'binding':`doc.params.freq`, checkValue:'M', default:'G', 'showCommandTitle':true, 'title': this.t('Month'), 'command':'set_viewParam', 'cssClass':'pi p-button-white p-button-border mr-1', action_afterChange},
                        {'binding':`doc.params.freq`, checkValue:'W', default:'G', 'showCommandTitle':true, 'title': this.t('Week'), 'command':'set_viewParam', 'cssClass':'pi p-button-white p-button-border mr-1', action_afterChange},
                        {'binding':`doc.params.freq`, checkValue:'D', default:'G', 'showCommandTitle':true, 'title': this.t('Days'), 'command':'set_viewParam', 'cssClass':'pi p-button-white p-button-border mr-1', action_afterChange},
                        {'binding':`doc.params.freq`, checkValue:'S', default:'G', 'showCommandTitle':true, 'title': this.t('Shifts'), 'command':'set_viewParam', 'cssClass':'pi p-button-white p-button-border mr-1', action_afterChange},
                    ],[
                        {'binding':`doc.viewParams.${this.attr.name}.chart-selector-use`, checkValue:true, default:false, 'showCommandTitle':true, 'title': this.t('Chart selector'), 'command':'set_viewParam', 'cssClass':'pi p-button-white p-button-border mr-1'},
                        
                        {'binding':`doc.viewParams.${this.attr.name}.animation_axisAnimation`, checkValue:true, default:false, 'showCommandTitle':true, 'title': this.t('Axis animation'), 'command':'set_viewParam', 'cssClass':'pi p-button-white p-button-border mr-1'},
                        // {'attr_type':'AttrNumber', 'binding':f'doc.viewParams.{name}.animation_duration', 'title':'Duration', 'action_afterChange':{'command':'set_viewParam'}},
                        
                    ],[
                        {'attr_type':'AttrLabel', title:this.t('Axis Y Grid:'), cssClass:'mr-2'},
                        {'binding':`doc.viewParams.${this.attr.name}.axisY-majorGrid`, checkValue:true, default:false, defaultValue:true, 'showCommandTitle':true, 'title': this.t('Major'), 'command':'set_viewParam', 'cssClass':'pi p-button-white p-button-border mr-1'},
                        {'binding':`doc.viewParams.${this.attr.name}.axisY-minorGrid`, checkValue:true, default:false, 'showCommandTitle':true, 'title': this.t('Minor'), 'command':'set_viewParam', 'cssClass':'pi p-button-white p-button-border mr-1'},
                        
                        {'attr_type':'AttrLabel', title:this.t('Axis X Grid:'), cssClass:'ml-2 mr-2'},
                        {'binding':`doc.viewParams.${this.attr.name}.axisX-majorGrid`, checkValue:true, default:false, 'showCommandTitle':true, 'title': this.t('Major'), 'command':'set_viewParam', 'cssClass':'pi p-button-white p-button-border mr-1'},
                        {'binding':`doc.viewParams.${this.attr.name}.axisX-minorGrid`, checkValue:true, default:false, 'showCommandTitle':true, 'title': this.t('Minor'), 'command':'set_viewParam', 'cssClass':'pi p-button-white p-button-border mr-1'},
                    ],[
                        {'attr_type':'AttrLabel', title:this.t('Axis Y position:'), cssClass:'mr-2'},
                        {'binding':`doc.viewParams.${this.attr.name}.axisY-position`, checkValue:'Auto', default:'None', defaultValue:'Left', 'showCommandTitle':true, 'title': this.t('Auto'), 'command':'set_viewParam', 'cssClass':'pi p-button-white p-button-border mr-1'},
                        {'binding':`doc.viewParams.${this.attr.name}.axisY-position`, checkValue:'Left', default:'None', 'showCommandTitle':true, 'title': this.t('Left'), 'command':'set_viewParam', 'cssClass':'pi p-button-white p-button-border mr-1'},
                        {'binding':`doc.viewParams.${this.attr.name}.axisY-position`, checkValue:'Top', default:'None', 'showCommandTitle':true, 'title': this.t('Top'), 'command':'set_viewParam', 'cssClass':'pi p-button-white p-button-border mr-1'},
                        {'binding':`doc.viewParams.${this.attr.name}.axisY-position`, checkValue:'Right', default:'None', 'showCommandTitle':true, 'title': this.t('Right'), 'command':'set_viewParam', 'cssClass':'pi p-button-white p-button-border mr-1'},
                        {'binding':`doc.viewParams.${this.attr.name}.axisY-position`, checkValue:'Bottom', default:'None', 'showCommandTitle':true, 'title': this.t('Bottom'), 'command':'set_viewParam', 'cssClass':'pi p-button-white p-button-border mr-1'},
                                            // IE 2026 09 15 / ODOO-… (заказ Игоря): Compact — в ряду позиции оси
                        {'binding':`doc.viewParams.${this.attr.name}.compact-axisY`, checkValue:true, default:false, 'showCommandTitle':true, 'title': this.t('Compact'),
                            'tooltip':this.t('Y axes: no titles, tick values inside the plot; hovered value inside the plot'),
                            'command':'set_viewParam', 'cssClass':'pi p-button-white p-button-border ml-2 mr-1'},
                    ],[
                        {'attr_type':'AttrLabel', title:this.t('Axis X position:'), cssClass:'mr-2'},
                        {'binding':`doc.viewParams.${this.attr.name}.axisX-position`, checkValue:'Auto', default:'None', defaultValue:'Bottom', 'showCommandTitle':true, 'title': this.t('Auto'), 'command':'set_viewParam', 'cssClass':'pi p-button-white p-button-border mr-1'},
                        {'binding':`doc.viewParams.${this.attr.name}.axisX-position`, checkValue:'Left', default:'None', 'showCommandTitle':true, 'title': this.t('Left'), 'command':'set_viewParam', 'cssClass':'pi p-button-white p-button-border mr-1'},
                        {'binding':`doc.viewParams.${this.attr.name}.axisX-position`, checkValue:'Top', default:'None', 'showCommandTitle':true, 'title': this.t('Top'), 'command':'set_viewParam', 'cssClass':'pi p-button-white p-button-border mr-1'},
                        {'binding':`doc.viewParams.${this.attr.name}.axisX-position`, checkValue:'Right', default:'None', 'showCommandTitle':true, 'title': this.t('Right'), 'command':'set_viewParam', 'cssClass':'pi p-button-white p-button-border mr-1'},
                        {'binding':`doc.viewParams.${this.attr.name}.axisX-position`, checkValue:'Bottom', default:'None', 'showCommandTitle':true, 'title': this.t('Bottom'), 'command':'set_viewParam', 'cssClass':'pi p-button-white p-button-border mr-1'},
                                            // IE 2026 09 15 / ODOO-… (заказ Игоря): Compact — в ряду позиции оси
                        {'binding':`doc.viewParams.${this.attr.name}.compact-axisX`, checkValue:true, default:false, 'showCommandTitle':true, 'title': this.t('Compact'),
                            'tooltip':this.t('X axis: years only (no month labels); hovered date inside the plot'),
                            'command':'set_viewParam', 'cssClass':'pi p-button-white p-button-border ml-2 mr-1'},
                    ],[
                        {'attr_type':'AttrLabel', title:this.t('Axis X legend:'), cssClass:'mr-2'},
                        {'binding':`doc.viewParams.${this.attr.name}.axisX-legend`, checkValue:'Auto', default:'Auto', defaultValue:'Auto', 'showCommandTitle':true, 'title': this.t('Auto'), 'command':'set_viewParam', 'cssClass':'pi p-button-white p-button-border mr-1'},
                        {'binding':`doc.viewParams.${this.attr.name}.axisX-legend`, checkValue:'D', default:'Auto', 'showCommandTitle':true, 'title': this.t('Year-Month-Week-Day'), 'command':'set_viewParam', 'cssClass':'pi p-button-white p-button-border mr-1'},
                        {'binding':`doc.viewParams.${this.attr.name}.axisX-legend`, checkValue:'W', default:'Auto', 'showCommandTitle':true, 'title': this.t('Year-Month-Week'), 'command':'set_viewParam', 'cssClass':'pi p-button-white p-button-border mr-1'},
                        {'binding':`doc.viewParams.${this.attr.name}.axisX-legend`, checkValue:'M', default:'Auto', 'showCommandTitle':true, 'title': this.t('Year-Month'), 'command':'set_viewParam', 'cssClass':'pi p-button-white p-button-border mr-1'},
                        {'binding':`doc.viewParams.${this.attr.name}.axisX-legend`, checkValue:'A', default:'Auto', 'showCommandTitle':true, 'title': this.t('Year'), 'command':'set_viewParam', 'cssClass':'pi p-button-white p-button-border mr-1'},
                    ],[
                        // ODOO-4139: режимы иерархической легенды в быстрых настройках — раньше включались только правкой JSON записи виджета;
                        // IE 2026 09 15 (замечание Игоря, вечер): ряд «Legend mode» (Grouped / Popup) снят — Popup стал значением ряда Legend position ниже
                        // IE 2026 09 13 / ODOO-5800 (заказ Игоря): связанная подсветка серий по странице
                        {'attr_type':'AttrLabel', title:this.t('Series highlight:'), cssClass:'mr-2'},
                        {'binding':`doc.viewParams.${this.attr.name}.hover-link`, checkValue:'page', default:'', 'showCommandTitle':true, 'title': this.t('Linked on the page'),
                            'tooltip':this.t('Hovering a series here (on the chart or on a legend row) highlights the series with the same name in every chart of this page that has this option on, and vice versa'),
                            'command':'set_viewParam', 'cssClass':'pi p-button-white p-button-border mr-1'},
                    ],[
                        // IE 2026 09 16 (заказ Игоря): клик по точке открывает окно строки — опция, по умолчанию выкл (расшифровка — легендой)
                        {'attr_type':'AttrLabel', title:this.t('Click on a point:'), cssClass:'mr-2'},
                        {'binding':`doc.viewParams.${this.attr.name}.click-open-row`, checkValue:true, default:false, 'showCommandTitle':true, 'title': this.t('Opens the row widget'),
                            // IE 2026 09 26 / ODOO-… (заказ Игоря: расшифровка кусочка графика): при включённой форме расшифровки — текст про форму (выключена — прежний)
                            // IE 2026 09 29 / ODOO-343341 (заказ Игоря: вкладка расшифровки в окне легенды): у графика с окном легенды — текст про вкладку Breakdown
                            'tooltip':this.chartDrill_tabOn() ? this.t('Off (default): a click on a point opens the legend window at the date of the point, its Breakdown tab shows what the value consists of (Alt+click leaves the legend window as it is). On: a click on a point opens the row widget of the point (the open legend window still follows the point)')
                                : this.chartDrill_globalOn() ? this.t('Off (default): a click on a point opens its breakdown form (Alt+click — the legend window: opens it or moves its values to the date of the point). On: a click on a point opens the row widget of the point (the open legend window still follows the point)')
                                : this.t('Off (default): a click on a point works with the legend window — opens it or moves its values to the date of the point. On: a click on a point opens the row widget of the point (the open legend window still follows the point)'),
                            'command':'set_viewParam', 'cssClass':'pi p-button-white p-button-border mr-1'},
                        // IE 2026 09 26 / ODOO-… (заказ Игоря: расшифровка кусочка графика): форма расшифровки по клику (по умолчанию вкл.; выключатель всего механизма fe.ux.chartDrill убирает и кнопку)
                        // IE 2026 09 29 / ODOO-343341 (заказ Игоря: вкладка расшифровки в окне легенды): подпись — «Breakdown» (у графика с окном легенды расшифровка — вкладка окна, не форма)
                        ...(this.chartDrill_globalOn() ? [{'binding':`doc.viewParams.${this.attr.name}.click-drill`, checkValue:true, default:false, defaultValue:true, 'showCommandTitle':true, 'title': this.t('Breakdown'),
                            'tooltip':this.t('On (default): a click on a point or a bar shows what its value consists of by the dimensions of the data source (the first values and «Others»), with a command to split the series in this chart — in the Breakdown tab of the legend window, on a chart without the legend window — in a form at the point. Off: a click works with the legend window, as before'),
                            'command':'set_viewParam', 'cssClass':'pi p-button-white p-button-border mr-1'}] : []),
                    ],[
                        {'attr_type':'AttrLabel', title:this.t('Legend position:'), cssClass:'mr-2'},
                        {'binding':`doc.viewParams.${this.attr.name}.legend-position`, checkValue:'Auto', default:'None', defaultValue:'Right', 'showCommandTitle':true, 'title': this.t('Auto'), 'command':'set_viewParam', 'cssClass':'pi p-button-white p-button-border mr-1'},
                        {'binding':`doc.viewParams.${this.attr.name}.legend-position`, checkValue:'Left', default:'None', 'showCommandTitle':true, 'title': this.t('Left'), 'command':'set_viewParam', 'cssClass':'pi p-button-white p-button-border mr-1'},
                        {'binding':`doc.viewParams.${this.attr.name}.legend-position`, checkValue:'Top', default:'None', 'showCommandTitle':true, 'title': this.t('Top'), 'command':'set_viewParam', 'cssClass':'pi p-button-white p-button-border mr-1'},
                        {'binding':`doc.viewParams.${this.attr.name}.legend-position`, checkValue:'Right', default:'None', 'showCommandTitle':true, 'title': this.t('Right'), 'command':'set_viewParam', 'cssClass':'pi p-button-white p-button-border mr-1'},
                        {'binding':`doc.viewParams.${this.attr.name}.legend-position`, checkValue:'Bottom', default:'None', 'showCommandTitle':true, 'title': this.t('Bottom'), 'command':'set_viewParam', 'cssClass':'pi p-button-white p-button-border mr-1'},
                        // IE 2026 09 15 (замечание Игоря, вечер): Popup — своё окно легенды (группы «мера → серии измерения», чекбоксы, кнопка легенды)
                        // вместо легенды wijmo; прежний ряд «Legend mode» снят
                        {'binding':`doc.viewParams.${this.attr.name}.legend-position`, checkValue:'Popup', default:'None', 'showCommandTitle':true, 'title': this.t('Popup'),
                            'tooltip':this.t('Own legend window instead of the wijmo legend: groups «measure → series of the dimension» with checkboxes; opened by the legend button'),
                            'command':'set_viewParam', 'cssClass':'pi p-button-white p-button-border mr-1'},
                    ]
                ]
            }

            this.commandPanel_topLeft.forEach((panel, index) => {
                panel.forEach((command, index) => {
                    this.store.set_commandActive(this, command)
                    // U6 (заказ Игоря: объяснение элементов по Alt)
                    if (command && command.binding && !command.uiHelp) {
                        const suf6 = String(command.binding).split('.').pop()
                        const k6 = UI_HELP_QS_LINE[suf6]
                        if (k6) { command.uiHelp = k6; command.uiHelpState = () => UI_HELP_QS_LINE_STATE[suf6](this) }
                    }
                })
          
                this.store.prepare_attrs(panel, `commandPanel${this.WIDGET.id}_${this.attr_id}_${index}`)
            })
        },
    
        get_viewParam(param, defaultValue) {
            return this.store.get_viewParam(this.WIDGET, this.attr.name, param, defaultValue, this.attr)
        },
        set_viewParam(param, value) {
            this.store.set_viewParam(this.WIDGET, this.attr.name, param, value, this.attr)

            if (param === 'axisX-legend') {
                this.load_data()
            }
            // IE 2026 09 13 / ODOO-5800 (заказ Игоря): компактные оси — подписи X и поля считаются при сборке
            if (param === 'axes-compact' || param === 'compact-axisX' || param === 'compact-axisY') {
                this.load_data()
                this.set_itemsSource()
            }
            // IE 2026 09 15 (замечание Игоря, вечер): Legend position = Popup → своя легенда (grouped + popup, окно открыть); сторона → легенда wijmo
            // на этой стороне, своя легенда выключена
            if (param === 'legend-position') {
                const popup = value === 'Popup'
                if (popup !== this.isLegendGrouped()) this.store.set_viewParam(this.WIDGET, this.attr.name, 'legend-grouped', popup, this.attr)
                if (popup !== this.isLegendPopup()) this.store.set_viewParam(this.WIDGET, this.attr.name, 'legend-popup', popup, this.attr)
                this.legendPanelVisible = popup ? true : null
                this.$nextTick(() => this.buildLegendGroups())
            }
            // ODOO-4139: переключение режима легенды из панели — пересобрать группы
            // сразу (штатная легенда wijmo гасится реактивно через isLegendGrouped)
            if (param === 'legend-grouped' || param === 'legend-popup') {
                // ODOO-4206: Popup — это лишь СПОСОБ показа своей панели, сам по себе он
                // ничего не значит. Включение Popup без Grouped выглядело как мёртвая
                // кнопка — включаем режим за пользователя; выключение Grouped снимает Popup.
                if (param === 'legend-popup' && value && !this.isLegendGrouped()) {
                    this.store.set_viewParam(this.WIDGET, this.attr.name, 'legend-grouped', true, this.attr)
                } else if (param === 'legend-grouped' && !value && this.isLegendPopup()) {
                    this.store.set_viewParam(this.WIDGET, this.attr.name, 'legend-popup', false, this.attr)
                }
                // ODOO-4439: включение Popup ОТКРЫВАЕТ окно сразу — иначе панель
                // просто исчезала (дефолт popup-режима — закрыто, открытие кнопкой
                // списка), и это читалось как «попап не срабатывает».
                this.legendPanelVisible = (param === 'legend-popup' && value) ? true : null
                this.$nextTick(() => this.buildLegendGroups())
            }

            this.set_commandsActive()
        },

        // IE 2026 09 10 / ODOO-5800 (заказ Игоря): ось Y для меры AttrTime (DOS в СЕКУНДАХ, Offset) — подписи
        // через formatTimeHTML (format 'm' → месяцы, меньше месяца — дни), шаг 30 дней (2 592 000 с) при формате 'm',
        // как majorUnit 30 у AttrDays; без формата 'm' шаг оставляем wijmo — секундные меры (часы) иначе давали бы
        // частокол меток. withTitle — подпись именованной оси (как «DOS — days …» у AttrDays)
        // IE 2026 09 29 / ODOO-341407: формат 'd' (всегда дни) — заголовок «… — days», шаг кратен суткам и подобран по размаху оси
        // (timeAxisDaysStep: 1 / 2 / 5 / 7 / 14 / 30 … дн): DOS на Distribution — 5–21 дн, на Schedules — ~4 400 дн, постоянный шаг не годится
        axisTime_apply(axis, attr, withTitle = true) {
            if (withTitle) {
                const axisName = (!attr.axisY || attr.axisY === 'DOS') ? this.t('Stock cover') : attr.axisY   // IE 2026 09 25 / ODOO-5800: the named axis 'DOS' is titled «Stock cover» (Igor 25.09), the axis key is unchanged
                axis.title = attr['axisY-title'] || (attr?.format === 'm' ? this.t('{axis} — months (d = days)', { axis: axisName })
                    : attr?.format === 'd' ? this.t('{axis} — days', { axis: axisName })   // IE 2026 09 29 / ODOO-341407: формат 'd'
                        : this.t('{axis} — time', { axis: axisName }))   // IE 2026 09 23 / ODOO-341407: i18n
            }
            if (attr?.format === 'm') {
                axis.majorUnit = 30 * 24 * 3600
                axis.minorUnit = 30 * 24 * 3600
            } else if (attr?.format === 'd') {
                // IE 2026 09 29 / ODOO-341407: шаг — при каждой раскладке подписей: wijmo берёт его из _calcMajorUnit (размах оси и число
                // помещающихся меток — его же); лестница дней — timeAxisDaysStep, меток — вдвое меньше помещающихся, как у wijmo.
                // Нет таких методов (другая версия wijmo) — шаг остаётся wijmo, подписи всё равно в днях
                axis.majorUnit = null
                axis.minorUnit = null
                if (typeof axis._calcMajorUnit === 'function' && typeof axis._getActualRange === 'function') {
                    axis._calcMajorUnit = function () {
                        if (typeof this.majorUnit === 'number' && this.majorUnit > 0) return this.majorUnit   // явный шаг — как у wijmo
                        const fit = typeof this._getAnnoNumber === 'function' ? this._getAnnoNumber(this.axisType === wjChart.AxisType.Y) : 10
                        return timeAxisDaysStep(this._getActualRange(), Math.max(2, Math.floor(fit / 2)))
                    }
                }
            }
            axis.itemFormatter = (engine, label) => {
                label.text = this.store.formatTimeHTML(label.val, attr)
                return label
            }
        },
        dataLabelContent(ht) {
            // ht: HitTestInfo
            // ht.y = значение точки
            // ht.y у stacked-серии = значение точки, не накопленная высота стека
            // (проверено на стенде) — для chart_down снимаем зеркало (ODOO-4646)
            const v = this.chartDownUnmirror(ht?.series?.binding, ht?.y)
            if (v == null) return ''
            // AttrDays (DOS/LS): метка в месяцах, как ось и тултип — иначе точка
            // показывает сырые дни при оси в 'm' (ODOO-3720)
            const attr = this.attrs_by_binding?.[ht?.series?.binding]
            if (attr?.attr_type === 'AttrDays') {
                return this.store.formatDaysHTML(v, attr)
            }
            if (attr?.attr_type === 'AttrTime') {
                return this.store.formatTimeHTML(v, attr) // IE 2026 09 10 / ODOO-5800: DOS в секундах — метка в месяцах
            }
            return wjcCore.Globalize.format(v, 'n0') // или 'n2', 'p0' и т.д.
        },

        // (опционально) фильтр, чтобы не было каши
        dataLabelRendering(sender, e) {
            const ht = e?.hitTestInfo;
            const v = ht?.y;

            // 1) скрываем пустые/нулевые
            if (v == null || v === 0) {
                e.cancel = true;
                return;
            }

            const binding = ht?.series?.binding;
            const field = this.attrs_by_binding?.[binding] || {};
            const dl = field.dataLabel || {};
            const pos = dl.position || 'None';

            // 2) если position не задан / None -> не рисуем
            if (pos === 'None') {
                e.cancel = true;
                return;
            }

            // // 3) иначе рисуем и применяем настройки
            // e.cancel = false;
            // e.position = pos;
            // e.connectingLine = !!dl.connectingLine;
            // e.border = !!dl.border;
            // e.offset = dl.offset ?? 4;
            
            const pt = e.point
            const size = { w: 60, h: 16 } // грубая оценка

            const rect = {
                x1: pt.x - size.w / 2,
                y1: pt.y - size.h,
                x2: pt.x + size.w / 2,
                y2: pt.y,
            }

            for (const r of this.drawnLabels) {
                const overlap =
                rect.x1 < r.x2 &&
                rect.x2 > r.x1 &&
                rect.y1 < r.y2 &&
                rect.y2 > r.y1

                if (overlap) {
                e.cancel = true
                return
                }
            }

            this.drawnLabels.push(rect)

        },

        zoneColor(LS) {
            if (LS === 6)  return {strokeColor:'#1E88E5', zoneColor:'#1E88E5'}; // IE 2026 10 01 / ODOO-5800: синий — выше порога excess (сверхнормативная зона, категория excess)
            if (LS === 5)  return {strokeColor:'#2E7D32', zoneColor:'#2E7D32'}; // тёмно-зелёный — Over Stock
            if (LS === 4)  return {strokeColor:'#acd1ee', zoneColor:'#acd1ee'}; // белый — neutral / empty
            if (LS === 3)  return {strokeColor:'#FBC02D', zoneColor:'#FBC02D'}; // жёлтый — Plan zone (DOS)
            if (LS === 2)  return {strokeColor:'#FB8C00', zoneColor:'#FB8C00'}; // оранжевый — Min zone (DOS)
            if (LS === 1)  return {strokeColor:'#C62828', zoneColor:'#C62828'}; // красный — Out Of Stock
            if (LS === -1) return {strokeColor:'#9E9E9E', zoneColor:'#9E9E9E'}; // серый — No-sales
            return {strokeColor:'#acd1ee', zoneColor:'#acd1ee'};
        },
        // ODOO-4646 (B/C): фактическая ширина группы колонок в пикселях.
        // wijmo по умолчанию отдаёт группе ~70% бина; 'groupWidth' чарта может
        // задать проценты ('30%') или пиксели.
        stack2GroupWidth(binW) {
            const g = this.flex?.options?.groupWidth
            if (typeof g === 'number' && g > 0) return Math.min(g, binW)
            if (typeof g === 'string' && g.trim().endsWith('%')) {
                const p = parseFloat(g)
                if (Number.isFinite(p)) return binW * Math.max(5, Math.min(100, p)) / 100
            }
            return binW * 0.7
        },
        // ODOO-4646 (B/C): один сегмент второго стека. Сегменты копятся снизу вверх
        // в порядке серий flex.series (тот же порядок, что в легенде), погашенные
        // серии в накоплении не участвуют — иначе в стеке остаются дыры.
        drawStack2Symbol(engine, ht, mode) {
            const binding = ht.series?.binding
            const i = ht.pointIndex
            const row = this.data?.[i]
            if (!row || binding == null) return
            const v = +row[binding]
            if (!Number.isFinite(v) || v === 0) return

            const isOn = (s) => s.visibility === 0 || s.visibility === 1
            const group = [...this.flex.series].filter(
                s => this.attrs_by_binding?.[s.binding]?.chart_down && !this.attrs_by_binding?.[s.binding]?.axisX && isOn(s))   // IE 2026 09 12 / ODOO-…
            const idx = group.findIndex(s => s.binding === binding)
            if (idx < 0) return
            let base = 0
            for (let k = 0; k < idx; k++) {
                const vk = +row[group[k].binding]
                if (Number.isFinite(vk)) base += vk
            }

            // convert(ht.x) — ЦЕНТР категории (так же считает сток-рендер ниже)
            const cx = ht.chart.axisX.convert(ht.x)
            const binW = Math.abs(ht.chart.axisX.convert(ht.x + 1) - cx)
            const gw = this.stack2GroupWidth(binW)
            let w, x
            if (mode === 'beside') {
                // колонка вплотную справа от основного стека, в пределах категории
                w = Math.max(gw, 3)
                x = cx + gw / 2 + Math.max(1, binW * 0.02)
            } else { // 'inside' — узкий столбик по центру, поверх стека остатков
                w = Math.max(gw * 0.34, 3)
                x = cx - w / 2
            }

            const y0 = ht.chart.axisY.convert(base)
            const y1 = ht.chart.axisY.convert(base + v)
            const top = Math.min(y0, y1)
            const h = Math.abs(y1 - y0)
            if (!(h > 0)) return

            const attr = this.attrs_by_binding[binding] || {}
            // цвет берём СЫРОЙ (wijmo-градиент 'l(...)#a-#b' движок понимает,
            // а css-перевод из legendSeriesColor — нет); палитра — как запасной
            const rawFill = attr?.cssStyleChart?.fill
                || (ht.series.style && typeof ht.series.style === 'object' && ht.series.style.fill)
            engine.fill = rawFill || legendSeriesColor(this.flex?.series || [], this.flex?.palette, ht.series, attr)
            engine.stroke = 'rgba(255,255,255,.85)'
            engine.strokeWidth = 1
            engine.drawRect(x, top, w, h)
        },
        itemFormatter(engine, ht, defaultFormat) {
            if (ht.chartElement !== wjcChart.ChartElement.SeriesSymbol) {
                return defaultFormat();
            }

            // ODOO-4646, варианты B/C: второй стек (меры chart_down) рисуем своим слоем —
            // узкой колонкой внутри категории ('inside') или колонкой рядом ('beside').
            // defaultFormat НЕ вызываем: штатная отрисовка серии подавлена, из общего
            // стека wijmo она визуально исчезает. Вариант A ('down') сюда не попадает.
            const stack2mode = this.attr.chart_stack2 || 'down'
            if (stack2mode !== 'down' && this.attrs_by_binding?.[ht.series?.binding]?.chart_down && !this.attrs_by_binding?.[ht.series?.binding]?.axisX) {   // IE 2026 09 12 / ODOO-…
                this.drawStack2Symbol(engine, ht, stack2mode);
                return;
            }

            if (this.attr.chartType) {
                const item = ht.item;
                const binding = ht.series.binding;
                const field = this.attrs_by_binding?.[binding] || {};

                // {'attr_type':'AttrStr', 'binding':f'doc.viewParams.{name}.binding_stock', 'title': 'Stock field', 'action_afterChange':{'command':'set_viewParam'}},
                // {'attr_type':'AttrStr', 'binding':f'doc.viewParams.{name}.binding_LS', 'title': 'Stock level field', 'action_afterChange':{'command':'set_viewParam'}},
                // {'attr_type':'AttrStr', 'binding':f'doc.viewParams.{name}.binding_in', 'title': 'In field', 'action_afterChange':{'command':'set_viewParam'}},
                // {'attr_type':'AttrStr', 'binding':f'doc.viewParams.{name}.binding_out', 'title': 'Out field', 'action_afterChange':{'command':'set_viewParam'}},
                const binding_stock = this.attr.binding_stock || 'open_balance';
                const binding_DOS   = this.attr.binding_DOS   || 'DOS';
                const binding_LS    = this.attr.binding_LS    || 'LS';
                const binding_in    = this.attr.binding_in    || 'IN';
                const binding_out   = this.attr.binding_out   || 'OUT';
                const binding_wo    = this.attr.binding_wo === false ? '' : (this.attr.binding_wo || 'WO_OUT');   // IE 2026 09 11 / ODOO-5800: списание

                // // ширина “бина” по X (приблизительно)
                // const count = ht.chart.itemsSource.itemCount;
                // const pr = ht.chart._plotRect;
                // const binW = pr.width / Math.max(1, count);
                // const w = binW * 0.3;

                const i = ht.pointIndex ?? ht.x;
                const item_next = this.data[i + 1];
                const item_prev = this.data[i - 1];

                const stock = item[binding_stock] || 0;
                const DOS = item[binding_DOS] || 0;
                const DOS2 = item_next?.[binding_DOS] ?? DOS;
                const in_ = item[binding_in] || 0;
                const out = (item[binding_out] || 0) + (binding_wo ? (item[binding_wo] || 0) : 0);   // IE 2026 09 11 / ODOO-5800: расход + списание
                const stockEnd = stock + in_ - out;

                // x0:start+in x1:out x2:end
                let x0 = ht.chart.axisX.convert(ht.x);
                let x2 = ht.chart.axisX.convert(ht.x + 1);
                const w0 = (x2 - x0);
                const w = Math.max(w0 * 0.5, 7);
                const w_in = w / 2; //Math.max(3 + 2, w / 2);
                const r = Math.max(w / 3, 3);
                const lineWidth = Math.max(r / 2, 2);
                const x00 = x0
                const x20 = x2
                x0 -= w
                const x1 = x0 + w;
                x2 = x1 + w;

                let y0 = ht.chart.axisY.convert(stock);
                let y1 = ht.chart.axisY.convert(stock + in_);
                let y_out = ht.chart.axisY.convert(stock - out);
                let y2 = ht.chart.axisY.convert(stock + in_ - out);
                let y_min = Math.min(in_, out) / 2
                const h = Math.abs(y0 - y2);

                const {strokeColor, zoneColor} = this.zoneColor(item[binding_LS]);
                const { strokeColor: strokeColor2, zoneColor: zoneColor2 } = this.zoneColor(item_next?.[binding_LS] ?? item[binding_LS]);
                const { strokeColor: strokeColor0, zoneColor: zoneColor0 } = this.zoneColor(item_prev?.[binding_LS] ?? item[binding_LS]);
                
                // engine.strokeCap = 'round';
                // engine.strokeJoin = 'round';
                
                if (binding === binding_stock) {
                    if (this.attr.chartType === 'stockColumnLine') {
                        // stock end
                        engine.strokeWidth = lineWidth;
                        engine.stroke = y0 === y2 ? strokeColor : strokeColor2;
                        engine.drawLine(x00, y2,  x00 + w0 / 2, y2);

                        if (out > 0 && in_ > 0) {
                            if (in_ > out) {
                                const y21 = y2 //- lineWidth * 3
                                const y11 = y1 //- lineWidth * 3
                                
                                // in-up
                                engine.stroke = "#99CC9977" // "#acd1ee"
                                engine.fill = "#99CC9977"
                                // const top_in = Math.min(y21, y11);
                                // const h_in = Math.abs(y11 - y21);
                                // engine.drawRect(x00 - w_in, top_in, w_in * 2, h_in);
                                engine.strokeWidth = w_in * 2;
                                engine.drawLine(x00, y11,  x00, y21);
                                
                                // // out-up
                                // engine.stroke = "#CC996677" // "#8a0100"
                                // engine.strokeWidth = lineWidth;
                                // engine.drawLine(x00, y11,  x00, y21);

                                // in
                                // engine.stroke = "#99CC9977"
                                // engine.fill = "#99CC9977"
                                // const top_in0 = Math.min(y0, y2);
                                // const h_in0 = Math.abs(y2 - y0);
                                // engine.drawRect(x00 - w_in, top_in0, w_in * 2, h_in0);

                                engine.strokeWidth = w_in * 2;
                                engine.stroke = "#99CC9977"
                                engine.drawLine(x00, y0,  x00, y2);

                                engine.strokeWidth = lineWidth;
                                engine.stroke = strokeColor // "#99CC99"
                                engine.drawLine(x00, y0,  x00, y2 + h / 2);
                                engine.stroke = strokeColor2 // "#99CC99"
                                engine.drawLine(x00, y2 + h / 2,  x00, y2);

                                engine.stroke = strokeColor2;
                                engine.fill = "white";
                                engine.drawEllipse(x00, y2, r/2, r/2);

                            } else {
                                const y01 = y0 //- lineWidth * 3
                                const y11 = y1 //- lineWidth * 3
                                
                                // in-up
                                engine.stroke = "#99CC9977"
                                engine.fill = "#99CC9977"
                                // const top_in = Math.min(y01, y11);
                                // const h_in = Math.abs(y11 - y01);
                                // engine.drawRect(x00 - w_in, top_in, w_in * 2, h_in);
                                engine.strokeWidth = w_in * 2;
                                engine.drawLine(x00, y01,  x00, y11);
                                
                                // // out-up
                                // engine.stroke = "#CC996677"
                                // engine.strokeWidth = lineWidth;
                                // engine.drawLine(x00, y11,  x00, y01);
                                
                                // out
                                engine.strokeWidth = lineWidth;
                                engine.stroke = strokeColor // "#CC9966"
                                engine.drawLine(x00, y0,  x00, y2 - h / 2);
                                engine.stroke = strokeColor2 // "#CC9966"
                                engine.drawLine(x00, y2 - h / 2,  x00, y2);

                                engine.stroke = strokeColor2;
                                engine.fill = "white";
                                engine.drawEllipse(x00, y2, r/2, r/2);
                            }

                            // if (y2 > y0) {
                            //     engine.stroke = "white";
                            //     engine.fill = "white";
                            //     engine.drawEllipse(x00, y0 - lineWidth * 2, r/2, r/2);
                            // }

                        } else {
                            // in
                            if (in_ > 0) {
                                // engine.stroke = "#99CC99"
                                // engine.fill = "#99CC99"
                                // const top_in = Math.min(y0, y1);
                                // const h_in = Math.abs(y1 - y0);
                                // engine.drawRect(x00 - w_in, top_in, w_in * 2, h_in);

                                engine.strokeWidth = w_in * 2;
                                engine.stroke = "#99CC9977"
                                engine.drawLine(x00, y0,  x00, y2);

                                engine.strokeWidth = lineWidth;
                                engine.stroke = strokeColor
                                engine.drawLine(x00, y0,  x00, y2 + h / 2);
                                engine.stroke = strokeColor2 // "#99CC99"
                                engine.drawLine(x00, y2 + h / 2,  x00, y2);

                                engine.stroke = strokeColor2;
                                engine.fill = "white";
                                engine.drawEllipse(x00, y2, r/2, r/2);
                            }
                            
                            // out
                            if (out > 0) {
                                engine.strokeWidth = lineWidth;
                                engine.stroke = strokeColor
                                engine.drawLine(x00, y0,  x00, y2 - h / 2);
                                engine.stroke = strokeColor2 // "#CC9966"
                                engine.drawLine(x00, y2 - h / 2,  x00, y2);

                                engine.stroke = strokeColor2;
                                engine.fill = "white";
                                engine.drawEllipse(x00, y2, r/2, r/2);
                            }
                        }
                        
                        // if (out > 0 && in_ > 0) {
                        //     engine.strokeWidth = lineWidth * 3; 
                        //     engine.stroke = "white";
                        //     engine.drawLine(x00 - w, y2 + lineWidth / 2,  x00 + w, y2 + lineWidth / 2); 
                        // }
                        
                        // stock start
                        engine.strokeWidth = lineWidth; 
                        engine.stroke = strokeColor;
                        engine.fill = zoneColor;
                        engine.drawLine(x00 - w0 / 2, y0,  x00, y0); 
                        engine.drawEllipse(x00, y0, r/2, r/2);

                    } else if (this.attr.chartType === 'stockColumn') {
                        // in
                        const top_in = Math.min(y0, y1);
                        const h_in = Math.abs(y1 - y0);
                        engine.fill = "#99CC99"
                        engine.stroke = "#99CC99"
                        engine.drawRect(x0, top_in, w, h_in);

                        // out
                        const top_out = Math.min(y1, y2);
                        const h_out = Math.abs(y2 - y1);
                        engine.fill = "#CC9966"
                        engine.stroke = "#CC9966"
                        engine.drawRect(x1, top_out, w, h_out);

                        // stock start
                        engine.strokeWidth = 3;
                        engine.stroke = "#8ea0ff"
                        // engine.drawLine(x0 - w * 2, y0, x0 - w, y0);
                        if (in_ === 0) {
                            engine.strokeWidth = 3;
                            engine.drawLine(x0, y0,  x0 + w, y0);
                        }
                        if (out === 0) {
                            engine.strokeWidth = 3;
                            engine.drawLine(x0 + w, y2,  x2, y2);
                        }
                        engine.stroke = strokeColor;
                        engine.fill = zoneColor;
                        engine.drawEllipse(x0, y0, r, r);
                    
                    } else if (this.attr.chartType === 'stockStepLine') {
                        engine.stroke = "#8ea0ff"
                        engine.strokeWidth = 3;
                        
                        if (in_ === 0 && out === 0) {
                            engine.drawLine(x0, y0,  x2, y2);

                        } else if (in_ === 0 && out > 0) {
                            engine.drawLine(x0, y0,  x0, y2);
                            engine.drawLine(x0, y2,  x2, y2);

                        } else if (in_ > 0 && out === 0) {
                            engine.drawLine(x0, y0,  x0, y2);
                            engine.drawLine(x0, y2,  x2, y2);

                        } else if (in_ * 0.2 <= out) {
                            // out
                            engine.drawLine(x0, y0,  x0, y_out);
                            engine.drawLine(x0, y_out,  x1, y_out);

                            // in
                            engine.drawLine(x1, y_out,  x1, y2);
                            engine.drawLine(x1, y2,  x2, y2);

                        } else { // in_ > 0 && out > 0
                            // in
                            engine.drawLine(x0, y0,  x0, y1);
                            engine.drawLine(x0, y1,  x1, y1);

                            // out
                            engine.drawLine(x1, y1,  x1, y2);
                            engine.drawLine(x1, y2,  x2, y2);

                            // // in
                            // engine.drawLine(x0, y0,  x0, y1);
                            
                            // // out
                            // engine.drawLine(x0, y0,  x0, y_out);

                            // engine.drawLine(x0, y2,  x2, y2);
                        }

                        // stock start
                        engine.stroke = strokeColor;
                        engine.fill = zoneColor;
                        engine.drawEllipse(x0, y0, r, r);

                    } else if (this.attr.chartType === 'stockLine') {
                        engine.stroke = "#8ea0ff"
                        engine.strokeWidth = 3;
                        
                        // in
                        engine.drawLine(x0, y0, x0, y1);

                        // out
                        engine.drawLine(x0, y1, x2, y2);

                        // stock start
                        engine.stroke = strokeColor;
                        engine.fill = zoneColor;
                        engine.drawEllipse(x0, y0, r, r);

                    } else if (this.attr.chartType === 'stockCandlestick') {
                        // stock end 
                        engine.strokeWidth = lineWidth;
                        engine.stroke = strokeColor2;
                        engine.fill = zoneColor2;
                        engine.drawLine(x00, y2,  x20, y2);

                        if (in_ === 0 && out === 0) {
                            12
                        } else if (in_ === 0 && out > 0) {
                            // out
                            engine.stroke = "#acd1ee" // "#acd1ee"
                            engine.fill = "#acd1ee"
                            engine.strokeWidth = lineWidth;
                            engine.drawLine(x00, y1,  x00, y2);

                        } else if (in_ > 0 && out === 0) {
                            // in
                            engine.stroke = "#acd1ee" // "#acd1ee"
                            engine.fill = "#acd1ee"
                            const top_in = Math.min(y0, y2);
                            const h_in = Math.abs(y2 - y0);
                            // engine.drawRect(x00 - w_in, top_in, w_in * 2, h_in);
                            engine.drawLine(x00, y0,  x00, y2);

                        } else if (in_ <= out) {
                            // in
                            engine.stroke = "#acd1ee" // "#acd1ee"
                            engine.fill = "white"
                            const top_in = Math.min(y0, y1);
                            const h_in = Math.abs(y1 - y0);
                            // engine.drawRect(x00 - w_in, top_in, w_in * 2, h_in);
                            engine.strokeWidth = lineWidth * 1;
                            engine.drawLine(x00, y0,  x00, y1);
                            
                            // out
                            engine.stroke = "#acd1ee" // "#8a0100"
                            engine.fill = "#acd1ee"
                            engine.strokeWidth = lineWidth;
                            engine.drawLine(x00, y0,  x00, y2);

                        } else { // in_ > out
                            // in
                            engine.stroke = "#acd1ee" // "#acd1ee"
                            engine.fill = "#acd1ee"
                            const top_in = Math.min(y0, y2);
                            const h_in = Math.abs(y2 - y0);
                            // engine.drawRect(x00 - w_in, top_in, w_in * 2, h_in);
                            engine.strokeWidth = lineWidth * 1;
                            engine.drawLine(x00, y0,  x00, y2);
                            
                            // out
                            engine.stroke = "#acd1ee" // "#8a0100"
                            engine.fill = "#acd1ee"
                            engine.strokeWidth = lineWidth * 1;
                            engine.drawLine(x00, y1,  x00, y2);
                        }
                        
                        // stock start
                        engine.strokeWidth = lineWidth;
                        engine.stroke = strokeColor;
                        engine.fill = zoneColor;
                        engine.drawLine(x00 - w0 + w_in, y0,  x00, y0);
                        engine.stroke = strokeColor;
                        engine.drawEllipse(x00, y0, r, r);
                    }

                    return;
                
                } else if (binding === binding_DOS && !this.attr['stock_DOS_line']) {
                    // ODOO-4441: при stock_DOS_line ступени не рисуем — серия DOS
                    // отрисовывается штатно своим типом (Spline/Line)
                    engine.stroke = "#999990"
                    engine.strokeWidth = 3;

                    let axisY = this.axisY['DOS'] || ht.chart.axisY
                    y0 = axisY.convert(DOS);
                    y2 = axisY.convert(DOS2);
                    if (DOS <= DOS2) {
                        // in
                        engine.drawLine(x0, y0,  x0, y2);
    
                        // out
                        engine.drawLine(x0, y2,  x1, y2);

                        // end
                        engine.stroke = "#999990"
                        engine.drawLine(x1, y2,  x2, y2);
                    } else {
                        // in
                        engine.drawLine(x0, y0,  x0, y2);
    
                        // out
                        engine.drawLine(x0, y2,  x1, y2);

                        // end
                        engine.stroke = "#999990"
                        engine.drawLine(x1, y2,  x2, y2);
                    }

                    // stock start
                    engine.stroke = strokeColor
                    engine.fill = zoneColor;
                    engine.drawEllipse(x0, y0, r, r);

                    return;
                }
            }

            return defaultFormat();
        },


    },
    unmounted() {
        if (this._i18nHandler) { window.removeEventListener('i18n:changed', this._i18nHandler); this._i18nHandler = null }   // IE 2026 09 24 / ODOO-341407
        this.legendEdgeRemove()
        // IE 2026 09 04 / ODOO-336291 (mobile UX): B-23 / B-41 — снять слушатель закрытия пузырька
        // и лист серий (телепорт в body переживает размонтирование чарта)
        this.mobBubbleHide()
        this.mobLegendOpen = false
        clearTimeout(this._hvDwellT)   // IE 2026 09 27 / ODOO-… (заказ Игоря: вариант A наведения на серии)
    },
    watch: {
        // IE 2026 09 27 / ODOO-… (заказ Игоря: вариант A наведения на серии): окно легенды открыли / закрыли при курсоре над графиком — плашка прячется / возвращается сразу
        legendPanelVisible() { this.$nextTick(() => this.hoverValuesRefresh()) },
        // IE 2026 09 20 / ODOO-… (Игорь: легенда закрывается вместе с виджетом и на вкладке, к которой не относится): открылась панель полей при скрытом графике — стрелка легенды к выбранной строке поля, её мера подсвечена
        legendRelatedShown(v) {
            if (!v || !this.isLegendPanelShown()) return
            const sel = this.store.legend_field_selection
            this.legendHoverBinding = (sel && sel.widget_id === this.WIDGET?.id) ? (sel.binding || null) : null
            this.$nextTick(() => this.legendTetherUpdate())
        },
        // IE 2026 09 15 (заказ Игоря: селективные серии): чипс стола изменён (крестик чипса, другой виджет) — чекбоксы легенды и бейджа
        seriesSelSig() { this.$refs.legendCmp?.invalidate?.(); this.hoverBadgeRefresh() },
        // IE 2026 09 14 / ODOO-5800: выбор строки поля в панели полей этого виджета — стрелка легенды к ней, строка меры подсвечена
        'store.legend_field_selection'(v) {
            if (!v || v.widget_id !== this.WIDGET?.id || !this.isLegendPanelShown()) return
            if (!this.isVisible || !this.flex?.hostElement?.offsetParent) {
                this.legendHoverBinding = v.binding || null
                // панель полей могла ещё не отрисовать строку (виртуализация грида) — повторить позже
                this.$nextTick(() => this.legendTetherUpdate())
                setTimeout(() => this.legendTetherUpdate(), 500)
            }
        },
        'store.itemsSource_change_index'(newVal, oldVal) {
            if (this._tabsLazyPending) return   // IE 2026 09 26 / ODOO-5800 (fe.ux.tabsLazyHidden): серии не собраны (скрытая неоткрытая вкладка) — подписи оси при показе
            const changedSet = this.store.get_itemsSource_changedSet(newVal, oldVal)
            // IE 2026 09 01 / ODOO-5884: в pie-режиме flex нет — словари осей не его забота
            if (this.flex && this.attr.axisX_bindingX2 && this.flex.bindingX!='date_parse' && !this.attr.axisX_bindingX2?.endsWith('.title')) {
                for (let attr of this.attr.attrs||[]) {
                    if (attr['binding'] === this.attr.axisX_bindingX2) {
                        if (attr.relation_segment && (changedSet === null || changedSet.has(attr.relation_segment))) {
                            // if (!this.store.hide_console) console.log(`watch ${this.store.itemsSource.change_type} ${newVal}`)
                            this.store.get_itemsSource(this, this.doc[this.binding], attr, {fill:'_doc.data', fetchMode: 'justGet'})
                            this.flex.bindingX = `${attr['binding']}.title`
                            this.set_itemsSource()
                            break
                        }
                    }
                }
            }
        }
    },
}
</script>

<style>
/* IE 2026 09 11 / ODOO-5800 (заказ Игоря): подсветка серии под курсором — остальные притушены, ось серии выделена, ярлык с именем */
/* IE 2026 09 26 / ODOO-… (замечание Игоря: выделение серий графика): прежняя подсветка (drop-shadow наведённой серии, жирная ось,
   притушение .28) — только при выключенном fe.ux.chartHoverDimOthers (хост без chart-hover-soft) */
.wj-flexchart:not(.chart-hover-soft) .wj-series-group > g.chart-series-dim { opacity: .28; transition: opacity .12s; }
.wj-flexchart:not(.chart-hover-soft) .wj-series-group > g.chart-series-hover { filter: drop-shadow(0 0 2px rgba(0,0,0,.45)); }
.wj-flexchart:not(.chart-hover-soft) .chart-axis-hover text { font-weight: 700; fill: #1f2937; }
.wj-flexchart:not(.chart-hover-soft) .chart-axis-hover .wj-line, .wj-flexchart:not(.chart-hover-soft) .chart-axis-hover .wj-tick { stroke: #1f2937; stroke-width: 1.5; }
/* IE 2026 09 26 / ODOO-… (замечание Игоря: выделение серий графика): режим soft — наведённая серия и её ось вид не меняют,
   остальные серии гаснут до одной мягкой прозрачности (--chart-hover-dim, fe.ux.chartHoverDimOpacity) с переходом 140 мс в обе стороны — правило
   перехода на ВСЕХ группах серий, иначе возврат из притушения шёл бы скачком; размеры и раскладка не меняются */
.wj-flexchart.chart-hover-soft .wj-series-group > g { transition: opacity .14s ease-out; }
.wj-flexchart.chart-hover-soft .wj-series-group > g.chart-series-dim { opacity: var(--chart-hover-dim, .35); }
/* IE 2026 09 15 (заказ Игоря: селективные серии): бейдж точки с чекбоксом селектора — как подпись точки на карте */
.wj-flexchart .chart-hover-badge {
    position: absolute; z-index: 20; align-items: center; gap: 4px; pointer-events: auto; cursor: default;   /* выше линии-маркера wijmo */
    background: rgba(255, 255, 255, 0.92); border: 1.5px solid #888; border-radius: 10px; padding: 1px 8px 1px 5px;
    font-size: 12px; color: #1f2937; white-space: nowrap; box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
}
.wj-flexchart .chart-hover-badge-check { cursor: pointer; color: var(--cs-accent, #647eff); font-size: 13px; }
.wj-flexchart .chart-hover-badge-check:hover { filter: brightness(0.85); }
.wj-flexchart .chart-hover-badge-name { color: #4b5563; max-width: 220px; overflow: hidden; text-overflow: ellipsis; }
.wj-flexchart .chart-hover-tag {
    position: absolute; z-index: 5; pointer-events: none; display: none;
    padding: 0 5px; border: 1.5px solid #444; border-radius: 3px; background: rgba(255,255,255,.95);
    font-size: 11px; font-weight: 600; line-height: 16px; white-space: nowrap; color: #1f2937;
}
.wj-flexchart .chart-hover-tag-dot { width: 10px; height: 10px; padding: 0; border-radius: 50%; border-width: 2px; background: #fff; }
/* IE 2026 09 13 / ODOO-5800 (замечание Игоря): подпись оси X точки под курсором — жирным, в рамке (вместо тега с датой) */
.wj-flexchart .wj-axis-x text.chart-hover-xlabel { font-weight: 700; fill: #1f2937; }
.wj-flexchart .wj-axis-x .chart-hover-xlabel-box { fill: rgba(255,255,255,.95); stroke: #444; stroke-width: 1.5; pointer-events: none; }
/* IE 2026 09 13 / ODOO-5800 (заказ Игоря): компактные оси — деления Y внутри области (мелко, с белой обводкой поверх серий) */
.wj-flexchart text.chart-axis-inside { font-size: 10px; paint-order: stroke; stroke: rgba(255,255,255,.92); stroke-width: 3px; stroke-linejoin: round; }
/* IE 2026 09 13 / ODOO-5800 (замечание Игоря): нет строк данных — рисунок погашен, сообщение по центру */
.attr-chart.chart-empty .attr-chart-1 svg { visibility: hidden; }
.attr-chart .chart-empty-msg { position: absolute; left: 0; right: 0; top: 0; bottom: 0; display: flex; align-items: center; justify-content: center;
    color: #6b7280; font-size: 13px; pointer-events: none; z-index: 2; }
.wj-flexchart .chart-hover-axis-label {
    position: absolute; z-index: 5; pointer-events: none;
    padding: 1px 6px; border: 1.5px solid #444; border-radius: 9px; background: rgba(255,255,255,.92);
    font-size: 11px; font-weight: 600; line-height: 14px; white-space: nowrap;
}
.attr-chart {
    width:-webkit-fill-available !important;
    display: flex;
    flex-direction: column;
    height: 100%;
    /* padding-bottom: 3px; */
    position: relative; /* 2026-02-17 */
}
.custom-gridlines.wj-flexchart .wj-axis-x .wj-tick,
.custom-gridlines.wj-flexchart .wj-axis-y .wj-tick {
    stroke: darkgreen;
}

.custom-gridlines.wj-flexchart .wj-axis-x .wj-gridline,
.custom-gridlines.wj-flexchart .wj-axis-y .wj-gridline {
    opacity: .25;
    stroke: darkgreen;
    stroke-width: 1px;
}

.custom-gridlines.wj-flexchart .wj-axis-x .wj-gridline-minor,
.custom-gridlines.wj-flexchart .wj-axis-y .wj-gridline-minor {
    opacity: .25;
    stroke: darkgreen;
    stroke-dasharray: 0;
    stroke-width: .25px;
}
.chart-selector.wj-flexchart {
    /* position: absolute; */
    bottom: 0px;
    height: 30px;
}
/* ODOO-2734: иерархическая легенда — IE 2026 09 15 / ODOO-…: кнопка живёт в островке .corner-island (Widget.vue), свой отступ не нужен */
/* IE 2026 09 11 / ODOO-… (замечание Игоря 10: «не выходит нажать на верхние правые кнопки»): кнопки ☰/⚙ — над хостом графика.
   Подписи ховера серий (hoverPointTags) делают хост positioned (position: relative под HTML-подписи точки), и SVG
   графика, стоящий в DOM ПОСЛЕ кнопок без z-index, накрывал их — клики уходили в график. Выше подписей ховера (5) */
.attr-chart > .corner-island { z-index: 6; }   /* IE 2026 09 15 / ODOO-…: островок вместо отдельных кнопок */
/* активная кнопка легенды в тулбаре — видно, что панель открыта */
.chart-legend-btn-on { background: rgba(47, 59, 82, 0.12); border-radius: 4px; }   /* IE 2026 09 14 / ODOO-5800 (замечание Игоря): как у карты (attr-geomap-btn-on) */
/* остальные стили окна легенды — в ChartLegendPanel.vue (ODOO-4646) */
.buttons-chart{
    transition: all 250ms;
    opacity: 0;
    display: flex;
    align-items: center;

    position: absolute;
    padding: 24px;
    /* top: 24px; */
    right: 0px;
    color: lightslategray;
    /* visibility: hidden; */
    text-shadow:
            /* many shadows blur out the area around the text */
            0 0 1px white,
            0 0 2px white,
            0 0 3px white,
            0 0 4px white,
            0 0 5px white,
            0 0 6px white,
            0 0 7px white,
            0 0 8px white,
            0 0 9px white,
            0 0 10px white
}
.attr-chart:hover .buttons-chart {
    opacity: 1;
}
.wj-flexchart .wj-chart-linemarker .wj-chart-linemarker-hline,
.wj-flexchart .wj-chart-linemarker .wj-chart-linemarker-vline {
    height: 1px;
    width: 1px;
    opacity: .9;
    background: rgba(255, 150, 30, 0.75)
}
/* IE 2026 09 15 (заказ Игоря: селективные серии): линия-маркер wijmo (следует за мышью) перехватывала клик по чекбоксу бейджа точки */
.wj-flexchart .wj-chart-linemarker, .wj-flexchart .wj-chart-linemarker * { pointer-events: none; }
/* IE 2026 09 27 / ODOO-… (заказ Игоря: вариант A наведения на серии): проход мышью — вертикаль на дате, точки линий, плашка значений
   всех серий; перекрестие LineMarker wijmo (за мышью) в режиме не рисуется, но работает (индекс точки для выбора периода) */
.wj-flexchart.chart-hover-values .wj-chart-linemarker { visibility: hidden; }
.wj-flexchart .chart-hv-line { position: absolute; z-index: 4; width: 0; border-left: 1px solid rgba(75, 85, 99, .55); pointer-events: none; display: none; }
.wj-flexchart .chart-hv-dot { position: absolute; z-index: 4; width: 7px; height: 7px; border-radius: 50%; border: 1.5px solid #fff; transform: translate(-50%, -50%);
    box-shadow: 0 0 0 .5px rgba(0, 0, 0, .25); pointer-events: none; display: none; }
.wj-flexchart .chart-hv-plate { position: absolute; z-index: 5; pointer-events: none; display: none; box-sizing: border-box; min-width: 140px; max-width: 260px;
    padding: 5px 7px 6px; background: rgba(255, 255, 255, .96); border: 1px solid #d1d5db; border-radius: 8px; box-shadow: 0 2px 10px rgba(0, 0, 0, .12);
    font-size: 12px; line-height: 16px; color: #1f2937; }
.wj-flexchart .chart-hv-date { font-weight: 600; margin: 0 3px 3px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.wj-flexchart .chart-hv-table { border-collapse: separate; border-spacing: 0; width: 100%; }
.wj-flexchart .chart-hv-table td { padding: 1px 3px; white-space: nowrap; vertical-align: middle; }
.wj-flexchart .chart-hv-table tr.chart-hv-near td { background: rgba(100, 126, 255, .16); background: color-mix(in srgb, var(--cs-accent, #647eff) 16%, transparent); }
.wj-flexchart .chart-hv-table tr.chart-hv-near td:first-child { border-radius: 4px 0 0 4px; }
.wj-flexchart .chart-hv-table tr.chart-hv-near td:last-child { border-radius: 0 4px 4px 0; }
.wj-flexchart .chart-hv-k { width: 14px; }
.wj-flexchart .chart-hv-key { display: block; width: 14px; height: 3px; border-radius: 2px; }
.wj-flexchart .chart-hv-key.chart-hv-key-box { width: 10px; height: 10px; }
.wj-flexchart .chart-hv-val { font-weight: 600; text-align: right; font-variant-numeric: tabular-nums; }
.wj-flexchart .chart-hv-name { color: #4b5563; max-width: 170px; overflow: hidden; text-overflow: ellipsis; }
.wj-flexchart .chart-hv-more { color: #6b7280; font-size: 11px; margin: 1px 3px 0; }

/* зона ниже 0 */
.neg-zone {
    stroke: none;
}
 
/* линия нуля */
.zero-line {
    stroke: rgba(102, 102, 102, 0.65);
    stroke-width: 2;
    shape-rendering: crispEdges;
}

/* зоны drawAlarmZone */
.chart-zone-green {
    fill: #dfedde;
    stroke: none;
    opacity: 0.6;
}
.chart-zone-yellow {
    fill: #fff2de;
    stroke: none;
    opacity: 0.6;
}
.chart-zone-orange {
    fill: #ffdede;
    stroke: none;
    opacity: 0.6;
}
.chart-zone-red {
    fill: #ff8a8a;
    stroke: none;
    opacity: 0.6;
}
.chart-zone-grey {
    fill: rgba(0, 0, 0, 0.1);
    stroke: none;
    opacity: 0.6;
}

/* IE 2026 09 15 / ODOO-… (замечание Игоря): график прозрачен на время проходов выравнивания осей — одна отрисовка */
/* IE 2026 09 15 (замечание Игоря): класс на обёртке .attr-chart — реактивный :class на хосте wijmo при переключении стирал wj-control /
   wj-flexchart, и правила wijmo (контейнер LineMarker relative / маркер absolute) переставали действовать: при наведении контейнер маркера
   вставал в поток на высоту графика и уводил svg за границу хоста — тело виджета «пропадало» */
.attr-chart.chart-settling > .attr-chart-1 { opacity: 0; }
</style>